import { createElement as a } from "react";
var l = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#FFF",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm6.68 10c.353.61 1.005.987 1.71.987h31.22a1.974 1.974 0 0 0 1.71-2.962L25.71 4.988a1.974 1.974 0 0 0-3.42 0L6.68 32.025a1.975 1.975 0 0 0 0 1.974z",
      }),
      a("path", {
        className: "ot-0 otc-2",
        fill: "#00BED5",
        d: "M25.987 25.3h-4V13.087l4-1.785V25.3zm-2.02 2.014a2.249 2.249 0 1 0 2.249 2.249 2.265 2.265 0 0 0-2.249-2.246v-.003z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1 ttcw-2",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M41.287 32.025 25.677 4.988a1.974 1.974 0 0 0-3.42 0L6.647 32.025a1.975 1.975 0 0 0 1.71 2.962h31.22a1.974 1.974 0 0 0 1.71-2.962zM21.955 13.087l4-1.785v14h-4V13.087zm-.27 16.46a2.25 2.25 0 0 0 2.219 2.268 2.26 2.26 0 0 0 2.279-2.249 2.249 2.249 0 0 0-4.498-.02z",
      })
    );
  },
  t = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm15.944 33.107a2.4 2.4 0 0 1-2.4-2.4c0-1.901 2.4-5.6 2.4-5.6s2.4 3.699 2.4 5.6a2.4 2.4 0 0 1-2.4 2.4zm-6.944-12h8a2 2 0 0 0 0-4H26.98l5.027-2.28a2 2 0 0 0-1.633-3.652l-13.41 6.084.008.01a7.21 7.21 0 0 0-1.97 1.38v-.542h-11l6.667 15h4.332v-2.03A7.157 7.157 0 0 0 20 33.107h10a2 2 0 0 0 0-4h2a2 2 0 0 0 0-4h1a2 2 0 0 0 0-4z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        d: "M11.644 31.607h1.857v-12H6.31l5.334 12z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.98 17.107H41a2 2 0 1 1 0 4h-8a2 2 0 1 1 0 4h-1a2 2 0 1 1 0 4h-2a2 2 0 1 1 0 4H20a7.157 7.157 0 0 1-4.999-2.03v2.03H10.67l-6.668-15h11v.542a7.21 7.21 0 0 1 1.97-1.38l-.007-.01 13.41-6.084a2 2 0 0 1 1.633 3.651l-5.026 2.281zm-15.336 14.5h1.857v-12H6.31l5.334 12z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M39.943 25.107s-2.4 3.699-2.4 5.6a2.4 2.4 0 1 0 4.8 0c0-1.901-2.4-5.6-2.4-5.6z",
      }),
      a("path", {
        className: "ot-0 otc-0",
        fill: "#00BED5",
        d: "M10.668 33.107H15v-15H4l6.668 15z",
      })
    );
  },
  c = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm0 38.746-.003.003s-12.96-12.967-12.99-12.999H20a.75.75 0 0 0 .712-.513L22 21.372l3.288 9.865a.75.75 0 0 0 1.424 0l1.829-5.487h8.452c-.03.032-12.99 12.999-12.99 12.999L24 38.746zm-7.329-26.362a7.882 7.882 0 0 0-6.8 11.866h9.588l1.83-5.487a.75.75 0 0 1 1.423 0L26 28.628l1.288-3.865A.751.751 0 0 1 28 24.25h10.129a7.882 7.882 0 0 0-12.376-9.556L24 16.446l-1.753-1.752a7.886 7.886 0 0 0-5.576-2.31z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M26.711 31.237a.75.75 0 0 1-1.422 0L22 21.372l-1.289 3.865a.75.75 0 0 1-.711.513h-8.993c.03.032 12.99 12.999 12.99 12.999l.003-.003.003.003s12.96-12.967 12.99-12.999H28.54l-1.829 5.487z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "m19.46 24.25 1.829-5.487a.75.75 0 0 1 1.422 0L26 28.628l1.289-3.865A.75.75 0 0 1 28 24.25h10.129a7.882 7.882 0 0 0-12.376-9.556L24 16.446l-1.753-1.752A7.882 7.882 0 0 0 9.871 24.25h9.588z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M27.289 24.763 26 28.628l-3.289-9.865a.75.75 0 0 0-1.422 0l-1.83 5.487H10a.7.7 0 0 0-.116.023c.315.535.692 1.03 1.123 1.477H20a.75.75 0 0 0 .711-.513L22 21.372l3.289 9.865a.75.75 0 0 0 1.422 0l1.83-5.487h8.452a7.872 7.872 0 0 0 1.136-1.5H28a.75.75 0 0 0-.711.513z",
      })
    );
  },
  h = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00bed5",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 6C14.059 6 6 14.059 6 24s8.059 18 18 18 18-8.059 18-18c-.012-9.936-8.064-17.988-18-18zm0 34a15.974 15.974 0 0 1-11.982-26.568l22.55 22.549A15.912 15.912 0 0 1 24 40zM13.432 12.018l22.55 22.549c5.602-6.323 5.312-15.915-.661-21.889-5.974-5.973-15.566-6.263-21.889-.66z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm6 0c0 9.941 8.059 18 18 18 9.936-.012 17.988-8.064 18-18 0-9.941-8.059-18-18-18S6 14.059 6 24z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.432 12.018A15.916 15.916 0 0 1 24 8a15.974 15.974 0 0 1 11.982 26.567l-22.55-22.549zM31.54 28H33v-4h-5.46l4 4zM35 28h-1v-4h1v4zm-3.5-7.5A2.5 2.5 0 0 1 34 23h1a3.5 3.5 0 0 0-3.5-3.5A4.505 4.505 0 0 1 27 15v-2l-1-.5V15a5.506 5.506 0 0 0 5.5 5.5zm0-2A3.5 3.5 0 0 1 28 15v-2.5l1 .5v2a2.5 2.5 0 0 0 2.5 2.5A5.507 5.507 0 0 1 37 23h-1a4.506 4.506 0 0 0-4.5-4.5zM36 28h1v-4h-1v4zM17.407 38.587A15.974 15.974 0 0 1 8 24c0-3.896 1.43-7.656 4.018-10.568l22.55 22.549a15.974 15.974 0 0 1-17.16 2.606zM20.465 24H14a2 2 0 1 0 0 4h10.465l-4-4z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "M35.004 24h-1v4h1v-4zm2 0h-1v4h1v-4zm-5.464 4h1.464v-4H27.54l4 4zM14 24a2 2 0 1 0 0 4h10.469l-4-4H14zm17.5-4.5A4.505 4.505 0 0 1 27 15v-2l-1-.5V15a5.506 5.506 0 0 0 5.5 5.5A2.5 2.5 0 0 1 34 23h1a3.5 3.5 0 0 0-3.5-3.5z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "M31.5 17.5A2.5 2.5 0 0 1 29 15v-2l-1-.5V15a3.5 3.5 0 0 0 3.5 3.5A4.506 4.506 0 0 1 36 23h1a5.507 5.507 0 0 0-5.5-5.5z",
      })
    );
  },
  s = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm9 15h7.992V26L9 29.551V39zm11 0V20.554L28 17v22h-8zm10.968-27.446L31 39h8l-.032-31-8 3.554z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1",
        fill: "#002677",
        d: "M20 20.554V39h8V17l-8 3.554zM9 39h7.992V26L9 29.551V39z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M30.968 11.554 31 39h8l-.032-31-8 3.554z",
      })
    );
  },
  e = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm20 11a5.005 5.005 0 0 1 3 1.014V16a3.003 3.003 0 0 0-3-3H7v22h13zm8 0a5.005 5.005 0 0 0-3 1.014V16a3.003 3.003 0 0 1 3-3h13v22H28z",
      }),
      a("path", {
        className: "at-2",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28 11a4.996 4.996 0 0 0-4 2.003A4.996 4.996 0 0 0 20 11H5v26h15c.843 0 1.646.355 2.215.977a2.41 2.41 0 0 0 3.57 0A3.008 3.008 0 0 1 28 37h15V11H28zm-5 25.014A5.005 5.005 0 0 0 20 35H7V13h13a3.003 3.003 0 0 1 3 3v20.014zM28 35h13V13H28a3.003 3.003 0 0 0-3 3v20.014A5.005 5.005 0 0 1 28 35z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-1",
        fill: "#fff",
        d: "M20 35H7V13h13a3.003 3.003 0 0 1 3 3v20.014A5.005 5.005 0 0 0 20 35zm21 0H28a5.005 5.005 0 0 0-3 1.014V16a3.003 3.003 0 0 1 3-3h13v22z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-2",
        fill: "#00BED5",
        d: "M39 18H28v2h9.978L39 18zm-11 7h9.978L39 23H28v2zm0 5h9.978L39 28H28v2zM9 30h9.978L20 28H9v2zm11-12H9v7h11v-7z",
      })
    );
  },
  v = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm10.5 38h-21V10h21v28z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M13.5 10v28h21V10h-21zm19 26h-17V12h17v24z",
      }),
      a("path", {
        className: "at-1 ot-0 otc-0",
        fill: "#fff",
        d: "M32.5 36h-17V12h17v24z",
      }),
      a("path", {
        className: "ot-2 otc-2",
        fill: "#00BED5",
        d: "M30.52 23H17.5v2h13.02v-2zm0-6H17.5v2h13.02v-2zM27 29h-9.5v2h8.48L27 29z",
      })
    );
  },
  o = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-1 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zM32 8H11v28h21V8zm5 32H16v-2h18V12h3v28z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-0",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 8h21v4h5v28H16v-4h-5V8zm2 2v24h17V10H13zm22 28H18v-2h14V14h3v24z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-2",
        fill: "#00BED5",
        d: "M28.02 21H15v2h13.02v-2zm0-6H15v2h13.02v-2zM15 29h8.48l1.02-2H15v2z",
      })
    );
  },
  f = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm7.973 11.026 30.45-.008 4.614-17.535h-5.064v-3.457h-19a3 3 0 0 0-3-3h-5a3 3 0 0 0-3 3v20.967l-.006.025h.006v.008z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        d: "m13.282 19.483-2.85 13.535h26.449l3.562-13.535H13.282z",
      }),
      a("path", {
        className: "ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M37.973 17.483h5.064l-4.614 17.535-30.45.008v-.008h-.006l.006-.025V14.026a3 3 0 0 1 3-3h5a3 3 0 0 1 3 3h19v3.457zM10.432 33.018H36.88l3.562-13.535h-27.16l-2.85 13.535z",
      }),
      a("path", {
        className: "ot-0 otc-0",
        fill: "#00BED5",
        d: "m7.973 35.026 3.719-17.561 31.345.018-4.614 17.535-30.45.008z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "m11.692 17.465 26.281.015v-3.454h-19a3 3 0 0 0-3-3h-5a3 3 0 0 0-3 3v20.967l-.006.025h.006v.008l3.719-17.561z",
      })
    );
  },
  n = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm24 17c6.075 0 11-4.925 11-11v-9.952h-3V15a8 8 0 1 0-16 0v5.048h-3V30c0 6.075 4.925 11 11 11z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        d: "M24 11a4 4 0 0 0-4 4v5.048h8V15a4 4 0 0 0-4-4zm0 14.524a1.994 1.994 0 0 0-1 3.723v4.277l2-.889v-3.388a1.994 1.994 0 0 0-1-3.723z",
      }),
      a("path", {
        className: "ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M32 20.048V15a8 8 0 1 0-16 0v5.048h-3V30c0 6.075 4.925 11 11 11s11-4.925 11-11v-9.952h-3zM20 15a4 4 0 0 1 8 0v5.048h-8V15zm5 17.635v-3.388a2 2 0 1 0-2 0v4.277l2-.89z",
      }),
      a("path", {
        className: "ot-0 otc-0 ttc-1",
        fill: "#002677",
        d: "M13 20.048V30c0 6.075 4.925 11 11 11s11-4.925 11-11v-9.952H13z",
      }),
      a("path", {
        className: "ot-0 otc-0 ttc-2",
        fill: "#fff",
        d: "M25 29.248v3.388l-2 .889v-4.278a2 2 0 1 1 2 0v.001z",
      }),
      a("path", {
        className: "ot-0 otc-0",
        fill: "#00BED5",
        d: "M20 20.048V15a4 4 0 0 1 8 0v5.048h4V15a8 8 0 1 0-16 0v5.048h4z",
      })
    );
  },
  i = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 23.171V7.03c8.98.54 15.989 7.975 16 16.971a16.766 16.766 0 0 1-4.112 11.06L25 23.171zm2-.828 9.674 9.674A14.7 14.7 0 0 0 39 24 15.018 15.018 0 0 0 27 9.3v13.043z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zM23 9c-8.28.01-14.99 6.72-15 15 .004 1.765.321 3.516.937 5.17L23 22.922V9zm0 30a15.009 15.009 0 0 1-13.256-8l14.025-6.231 9.83 9.831A14.953 14.953 0 0 1 23 39zm2-15.829 11.888 11.89A16.766 16.766 0 0 0 41 24c-.01-8.997-7.02-16.43-16-16.972V23.17z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        d: "M27 9.3v13.043l9.674 9.674A14.7 14.7 0 0 0 39 24 15.018 15.018 0 0 0 27 9.3z",
      }),
      a("path", {
        className: "ot-0 otc-0",
        fill: "#00BED5",
        d: "M41 24c-.011-8.996-7.02-16.43-16-16.971v16.142L36.889 35.06A16.77 16.77 0 0 0 41 24z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "M23 9A14.96 14.96 0 0 0 8.937 29.17L23 22.922V9zm.769 15.769L9.744 31A14.981 14.981 0 0 0 33.6 34.6l-9.831-9.831z",
      })
    );
  },
  m = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zM31 6a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1zM17 6a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0V7a1 1 0 0 0-1-1zm22 31V11a2 2 0 0 0-2-2h-4v2a2 2 0 1 1-4 0V9H19v2a2 2 0 1 1-4 0V9h-4a2 2 0 0 0-2 2v26a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2z",
      }),
      a("path", {
        d: "M18 11a1 1 0 1 1-2 0V7a1 1 0 1 1 2 0v4zm13 1a1 1 0 0 0 1-1V7a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1z",
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        d: "M37 15v22H11V15H9v22a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2V15h-2z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M37 9h-4v2a2 2 0 1 1-4 0V9H19v2a2 2 0 1 1-4 0V9h-4a2 2 0 0 0-2 2v4h30v-4a2 2 0 0 0-2-2z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M37 37H11V15h26v22zm-4-15v-4h-4v4h4zm0 2h-4v4h4v-4zm0 10v-4h-4v4h4zm-7-16h-4v4h4v-4zm0 6h-4v4h4v-4zm0 6h-4v4h4v-4zm-7-12h-4v4h4v-4zm0 6h-4v4h4v-4zm0 6h-4v4h4v-4z",
      }),
      a("path", {
        d: "M15 22v-4h4v4h-4zm0 2v4h4v-4h-4zm0 10v-4h4v4h-4zm11-16h-4v4h4v-4zm-4 6h4v4h-4v-4zm4 6h-4v4h4v-4zm3-8v-4h4v4h-4zm0 2v4h4v-4h-4zm0 10v-4h4v4h-4z",
        className: "at-2 ttc-3 otc-0",
        fill: "#002677",
      })
    );
  },
  z = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-1 ot-0 otc-0",
        fill: "#fff",
        d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 9C15.716 9 9 15.716 9 24c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15-.01-8.28-6.72-14.99-15-15zm1 15.414-7.1 7.109-.742-2.087L23 23.586V11l2 .955v12.459z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-0",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm0 43C13.507 43 5 34.493 5 24S13.507 5 24 5s19 8.507 19 19a19 19 0 0 1-19 19z",
      }),
      a("path", {
        className: "at-2 ttc-0 otc-0",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M24 5C13.507 5 5 13.507 5 24s8.507 19 19 19 19-8.507 19-19A19 19 0 0 0 24 5zm0 34c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15-.01 8.28-6.72 14.99-15 15z",
      }),
      a("path", {
        fill: "transparent",
        d: "M24 5C13.507 5 5 13.507 5 24s8.507 19 19 19 19-8.507 19-19A19 19 0 0 0 24 5z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        d: "m17.16 29.436 5.84-5.85V11l2 .955v12.459l-7.097 7.109-.742-2.087z",
      })
    );
  },
  d = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.5 30h-9V18h9v12zm-6.27-8.493c-.464 0-.91.185-1.238.513a1.75 1.75 0 0 0 .01 2.475l3 3 3-3a1.749 1.749 0 0 0-1.237-2.988c-.464 0-.91.185-1.238.513l-.53.53-.53-.53a1.749 1.749 0 0 0-1.237-.513z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm30 7h-.008l-.741 9.088A1.836 1.836 0 0 1 27.5 42h-7a1.836 1.836 0 0 1-1.748-1.912L18.008 31H18V16h.008l.741-9.088A1.836 1.836 0 0 1 20.5 5h7a1.836 1.836 0 0 1 1.748 1.912L29.992 16H30v15z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.251 6.912 29.992 16H30v15h-.008l-.744 9.088A1.836 1.836 0 0 1 27.5 42h-7a1.836 1.836 0 0 1-1.751-1.912L18.008 31H18V16h.008l.744-9.088A1.836 1.836 0 0 1 20.5 5h7a1.836 1.836 0 0 1 1.751 1.912zM28.5 29.5h-9v-12h9v12z",
      }),
      a("path", {
        className: "ot-0 otc-0 ttc-1",
        fill: "#00BED5",
        d: "M30 16H18v15h12V16z",
      }),
      a("path", {
        className: "at-2 otc-0",
        fill: "#002677",
        d: "m24.53 21.52-.53.53-.53-.53A1.75 1.75 0 1 0 21 24l3 3 3-3a1.75 1.75 0 0 0-2.47-2.48z",
      })
    );
  },
  p = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm31 16a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2H17a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h14z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M31 8H17a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zm-5.456 30h-3.088a1 1 0 1 1 0-2h3.088a1 1 0 0 1 0 2zM17 31.536l14-6.5V11H17v20.536z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M25.508 38H22.42a1 1 0 1 1 0-2h3.088a1 1 0 1 1 0 2z",
      }),
      a("path", {
        className: "ot-0 otc-2",
        fill: "#00BED5",
        d: "M31 11H17v20.536l14-6.5V11z",
      })
    );
  },
  w = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm35.113 9.363A10.482 10.482 0 0 0 40 24.5a10.589 10.589 0 0 0-.14-1.681L42 20h-3.013a10.52 10.52 0 0 0-7.412-5.793A6 6 0 1 0 20 12c.052.676.17 1.346.349 2h-1.673A4.741 4.741 0 0 0 14 10v5.024A10.518 10.518 0 0 0 8.61 21H7.244C6.557 21 6 21.557 6 22.244v2.47c0 .732.445 1.39 1.124 1.663l1.146.461a10.5 10.5 0 0 0 7.774 7.862l1.293 3.3H21v-3h8.5c.105 0 .208-.007.31-.014l.19-.011V38h3.3l1.813-4.637z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M26 7.5a4.505 4.505 0 0 0-4.5 4.5 4.57 4.57 0 0 0 1.474 3.3h6.051A4.56 4.56 0 0 0 30 14.025c.325-.626.497-1.32.5-2.025A4.505 4.505 0 0 0 26 7.5z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M42 20h-3.013a10.52 10.52 0 0 0-7.412-5.793A6 6 0 1 0 20 12c.052.676.17 1.346.349 2h-1.673A4.741 4.741 0 0 0 14 10v5.024A10.518 10.518 0 0 0 8.61 21H7.244C6.557 21 6 21.557 6 22.244v2.47c0 .732.445 1.39 1.124 1.663l1.146.461a10.5 10.5 0 0 0 7.774 7.862l1.293 3.3H21v-3h8.5c.105 0 .208-.007.31-.014l.19-.011V38h3.3l1.816-4.637a10.439 10.439 0 0 0 4.744-10.544L42 20zm-27.513 2.432a.88.88 0 1 1-.002-1.761.88.88 0 0 1 .002 1.76zM26 7.5a4.5 4.5 0 0 0-4.5 4.5c.005.696.172 1.38.49 2 .248.488.581.927.984 1.297h6.055c.396-.364.725-.794.971-1.272.325-.626.497-1.32.5-2.025A4.5 4.5 0 0 0 26 7.5z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M42 20h-3.024a10.492 10.492 0 0 0-9.476-6H18.676A4.741 4.741 0 0 0 14 10v5.024A10.518 10.518 0 0 0 8.61 21H7.244C6.557 21 6 21.557 6 22.244v2.47c0 .732.445 1.39 1.124 1.663l1.146.461a10.5 10.5 0 0 0 7.774 7.862l1.293 3.3H21v-3h8.5c.169 0 .333-.018.5-.025V38h3.3l1.816-4.637a10.37 10.37 0 0 0 4.741-10.537L42 20z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-0",
        fill: "#00BED5",
        d: "M31.01 15.3a6 6 0 1 0-10.02 0h10.02z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M14.487 20.671a.881.881 0 1 0-.002 1.762.881.881 0 0 0 .002-1.762z",
      })
    );
  },
  M = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm17 18.111V10.816a3 3 0 1 0-2 0V43l2-.889zm8-31.295V42.11L23 43V10.815a3 3 0 1 1 2 0zm8 31.295V10.816a3 3 0 1 0-2 0V43l2-.889z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M29.043 7.485A2.992 2.992 0 0 1 32 5a2.993 2.993 0 0 1 1 5.816V42.11L31 43V10.815a2.992 2.992 0 0 1-1.957-3.33zM31 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm-9.957-.515A2.992 2.992 0 0 1 24 5a2.993 2.993 0 0 1 1 5.816V42.11L23 43V10.815a2.992 2.992 0 0 1-1.957-3.33zM23 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm-9.957-.515A2.992 2.992 0 0 1 16 5a2.993 2.993 0 0 1 1 5.816V42.11L15 43V10.815a2.992 2.992 0 0 1-1.957-3.33zM15 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        d: "m23 43 2-.889V21h-2v22zm-8 0 2-.889V21h-2v22zm16-22v22l2-.889V21h-2z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M32 5a2.992 2.992 0 0 0-1 5.815V21h2V10.816A2.993 2.993 0 0 0 32 5zm-8 0a2.992 2.992 0 0 0-1 5.815V21h2V10.816A2.993 2.993 0 0 0 24 5zm-8 0a2.992 2.992 0 0 0-1 5.815V21h2V10.816A2.993 2.993 0 0 0 16 5z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M32 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
      })
    );
  },
  r = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm14.312 28H38v3a6 6 0 0 1-6 6h-3v7l-15-6v-5.021a14.993 14.993 0 1 1 23.316-16.466l2.91 8.914A2 2 0 0 1 38.313 28z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "M18.254 9.61a11.4 11.4 0 0 1 8.736-.01 3.623 3.623 0 0 1 .212 6.781c-.359.154-.73.274-1.102.395-.181.059-.362.117-.542.18a20.018 20.018 0 0 0-5.351 2.723 27.997 27.997 0 0 0-2.854 2.62 3.12 3.12 0 0 1-1.353.866 3.333 3.333 0 0 1-1.747.03 3.911 3.911 0 0 1-2.874-2.983 7.716 7.716 0 0 1 .711-4.412 11.4 11.4 0 0 1 6.164-6.19z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        fillRule: "evenodd",
        d: "m37.317 16.511 2.91 8.914A2 2 0 0 1 38.313 28H38v3a6 6 0 0 1-6 6h-3v7l-15-6v-5.02a15 15 0 1 1 23.317-16.47zm-10.108-.129a3.683 3.683 0 0 0 2.09-2.282 3.65 3.65 0 0 0 .154-1.068 3.685 3.685 0 0 0-2.463-3.444 11.4 11.4 0 0 0-14.9 6.2 7.715 7.715 0 0 0-.711 4.412 3.91 3.91 0 0 0 2.87 2.988 3.33 3.33 0 0 0 1.75-.023 3.105 3.105 0 0 0 1.36-.865 27.987 27.987 0 0 1 2.855-2.62 20.018 20.018 0 0 1 5.35-2.723c.185-.065.371-.125.558-.186a12.33 12.33 0 0 0 1.087-.389z",
      })
    );
  },
  N = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm9 15h30V9H9v30z",
      }),
      a("path", {
        className: "at-2 ot-0 otc-0",
        fill: "#002677",
        d: "M37.5 10.5h-27v27h27v-27z",
      }),
      a("path", {
        d: "M17 36.5h-5.5V31H17v5.5zm0-13h-5.5V18H17v5.5zm6.5 13H18V31h5.5v5.5zm0-6.5H18v-5.5h5.5V30zm0-6.5H18V18h5.5v5.5zm0-6.5H18v-5.5h5.5V17zm6.5 6.5h-5.5V18H30v5.5zm6.5 6.5H31v-5.5h5.5V30zm0-6.5H31V18h5.5v5.5z",
        className: "at-3 ot-0 otc-0",
        fill: "#00BED5",
      }),
      a("path", {
        className: "at-0 ot-2 otc-2",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M9 10.5h1.5v27h27v-27zm8 26V31h-5.5v5.5zm0-13h-5.5V18H17v5.5zm1 13h5.5V31H18v5.5zm5.5-6.5H18v-5.5h5.5V30zM18 23.5h5.5V18H18v5.5zm5.5-6.5H18v-5.5h5.5V17zm1 6.5H30V18h-5.5v5.5zm12 6.5H31v-5.5h5.5V30zM31 23.5h5.5V18H31v5.5z",
      })
    );
  },
  u = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zM39.556 9.858l-2.121-.707-4.243 4.242 1.415 1.415 4.949-4.95zM25 3v7h-2V4l2-1zM14.808 13.393l-4.95-4.949-.707 2.121 4.242 4.243 1.415-1.415zM3 23h7v2H4l-1-2zm5.444 15.143 2.12.707 4.244-4.244-1.415-1.414-4.95 4.951zM23 45v-7h2v6l-2 1zM12 24c0 6.627 5.373 12 12 12a12 12 0 0 0 12-12c0-6.627-5.373-12-12-12s-12 5.373-12 12zm26.142 15.557-4.95-4.951 1.415-1.414 4.242 4.244-.707 2.121zM44 23h-6v2h7l-1-2z",
      }),
      a("path", {
        d: "m25 3-2 1v6h2V3zM14.808 13.393l-4.95-4.949-.707 2.121 4.242 4.243 1.415-1.415zM10 23H3l1 2h6v-2zM8.444 38.143l2.121.707 4.243-4.244-1.415-1.414-4.949 4.951zM23 45l2-1v-6h-2v7zm10.192-10.394 4.95 4.951.707-2.121-4.242-4.244-1.415 1.414zM38 25h7l-1-2h-6v2zm1.556-15.142-2.121-.707-4.243 4.242 1.415 1.415 4.949-4.95z",
        className: "ot-2 otc-0 ttc-1 ttcw-3",
        fill: "#00BED5",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-1",
        fill: "#fff",
        d: "M24 12c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12a12 12 0 0 0-12-12z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M12 24c0-6.627 5.373-12 12-12a12 12 0 0 1 12 12c0 6.627-5.373 12-12 12s-12-5.373-12-12zm2 0c0 5.523 4.477 10 10 10 5.52-.006 9.994-4.48 10-10 0-5.523-4.477-10-10-10s-10 4.477-10 10z",
      }),
      a("path", {
        className: "at-2 ttc-3",
        fill: "#002677",
        d: "M24 30a6.007 6.007 0 0 1-6-6h-2a8 8 0 1 0 16 0h-2a6.007 6.007 0 0 1-6 6z",
      })
    );
  },
  V = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm36.629 6.351a6.643 6.643 0 0 0 1.39-.825 6.633 6.633 0 0 0 2.297-7.075L43 20.328l-1.76-.928 1.699-1.346-3.515-1.845-2.631 2.08a6.385 6.385 0 0 0-2.685-.6l-.141.003a6.921 6.921 0 0 0-3.567.991 6.7 6.7 0 0 0-9.436-5.618V9.55l-2 .888v2.639a6.7 6.7 0 0 0-8.894 8.837l1.3 2.92s1.751 3.933 1.83 4.084a5.139 5.139 0 0 0 6.666 2.32 2416.047 2416.047 0 0 0-4.568 5.716 1.478 1.478 0 0 0 1.726 2.246c.111-.04 19.605-8.849 19.605-8.849z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "M36.679 20.526a4.243 4.243 0 0 0-2.575-.837h-.2a4.507 4.507 0 0 0-3.612 1.734c-2.831 3.534-9.211 11.5-12.029 15.025 3.9-1.759 12.486-5.638 17.545-7.923.35-.153.68-.348.984-.581a4.655 4.655 0 0 0-.111-7.422l-.002.004z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        fillRule: "evenodd",
        d: "m41.24 19.4 1.76.928-2.69 2.128a6.6 6.6 0 0 1-3.681 7.9s-19.49 8.81-19.6 8.851a1.476 1.476 0 0 1-.873.054 1.478 1.478 0 0 1-.853-2.3c.034-.047 1.243-1.559 2.922-3.658l1.646-2.058a5.139 5.139 0 0 1-6.664-2.327 644.68 644.68 0 0 1-1.83-4.084l-1.3-2.92a6.7 6.7 0 0 1 8.894-8.837v-2.639l2-.888v3.515a6.7 6.7 0 0 1 9.425 5.618 6.922 6.922 0 0 1 3.419-.988c.097-.006.189-.006.289-.006a6.385 6.385 0 0 1 2.685.6l2.63-2.08 3.52 1.85-1.7 1.341zm-5.424 9.13c.35-.154.68-.349.984-.582l-.014.004a4.655 4.655 0 0 0-.111-7.422 4.243 4.243 0 0 0-2.575-.837h-.2a4.507 4.507 0 0 0-3.6 1.734l-3.69 4.608c-2.95 3.684-6.447 8.051-8.339 10.417 2.948-1.329 8.57-3.869 13.324-6.016l4.221-1.907z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        d: "m41.24 19.4 1.7-1.341-3.52-1.85-2.629 2.079a5.9 5.9 0 0 1 1.1.65 6.745 6.745 0 0 1 2.416 3.513L43 20.328l-1.76-.928zm-14.812-6.35a6.68 6.68 0 0 0-5.457.015V9.55l-2 .888v2.639a6.7 6.7 0 0 0-8.894 8.837l1.3 2.92s1.751 3.933 1.83 4.084a5.139 5.139 0 0 0 6.664 2.327c3.89-4.86 8.852-11.054 8.852-11.054a6.459 6.459 0 0 1 1.677-1.508 6.713 6.713 0 0 0-3.972-5.633z",
      })
    );
  },
  g = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm-7.657 38.093a4 4 0 0 1-7.695-2.188l5.578-19.624 7.148 4.113-5.03 17.699zM20.84 13.01A4.948 4.948 0 0 0 24 14.167a4.948 4.948 0 0 0 3.161-1.157l1.44 5.09 2.672-1.542-2.5-8.8a4.97 4.97 0 0 0-9.552 0l-2.5 8.8 2.68 1.542 1.438-5.09zM36.6 40.847a4 4 0 0 1-4.94-2.754l-5.031-17.7 7.148-4.113 5.578 19.624a4 4 0 0 1-2.754 4.943zM26 9.167a2 2 0 1 1-4 0 2 2 0 0 1 4 0z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "m39.352 35.905-5.578-19.624-2.21 1.272-2.788-9.79a4.969 4.969 0 0 0-9.552 0l-2.788 9.79-2.21-1.272-5.578 19.624a4.002 4.002 0 1 0 7.7 2.188l5.031-17.7-2.256-1.3 1.721-6.084a4.9 4.9 0 0 0 6.322 0l1.716 6.091-2.256 1.3 5.031 17.7a4 4 0 0 0 7.695-2.188v-.007zM24 11.166a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm-1-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "m31.567 17.566-2.79-9.8a4.969 4.969 0 0 0-9.553 0l-2.79 9.8 2.682 1.534 1.723-6.09a4.9 4.9 0 0 0 6.322 0l1.723 6.09 2.683-1.534z",
      }),
      a("path", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        d: "M24 11.166a2 2 0 1 1 0-4 2 2 0 0 1 0 4z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-0",
        fill: "#00BED5",
        d: "M24 8.166a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
      }),
      a("path", {
        d: "m39.352 35.905-5.578-19.624-7.148 4.112 5.031 17.7a4 4 0 1 0 7.695-2.188zm-30.704 0a4.002 4.002 0 1 0 7.7 2.188l5.031-17.7-7.148-4.112-5.583 19.624z",
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
      })
    );
  },
  H = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zM23.644 8.131l-6.665 6.627a4.764 4.764 0 1 0 6.718 6.758l9.668-9.612-9.72-3.773zm-11.492 5.886L12.17 14h.002a1.23 1.23 0 0 1 2.09.882 1.05 1.05 0 0 1-.094.478.993.993 0 0 0-.052.13 6.763 6.763 0 0 0 10.99 7.445l.593-.589 1.216 1.905-2.75 2.75h2.828l1.038-1.038c.42.613.883 1.196 1.383 1.745L27.121 30h2.828l.9-.9a16.014 16.014 0 0 0 4.652 2.81l1.15.446a3.706 3.706 0 0 1 2.621 3.144H23.238a6.859 6.859 0 0 1-4.881-2.022L5.523 20.646l6.629-6.629zM38.17 39c.299-.32.546-.684.731-1.08.213-.447.345-.927.391-1.42H23.237a7.852 7.852 0 0 1-5.588-2.315L4.816 21.352l-.23.231a2 2 0 0 0 0 2.83l11.852 11.831a9.405 9.405 0 0 0 6.64 2.75L38.171 39z",
      }),
      a("path", {
        className: "at-2 ttc-3 otc-0",
        fill: "#002677",
        d: "M20.338 22.901a4.735 4.735 0 0 0 3.359-1.385l9.668-9.612-9.72-3.773-6.666 6.627a4.764 4.764 0 0 0 3.359 8.143z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        d: "M23.237 35.5h16.036a3.706 3.706 0 0 0-2.623-3.144l-1.15-.446a16.013 16.013 0 0 1-4.651-2.81l-.9.9h-2.828l2.293-2.293c-.5-.55-.962-1.133-1.383-1.745L26.993 27h-2.829l2.75-2.75-1.215-1.905-.592.59a6.763 6.763 0 0 1-10.991-7.446.98.98 0 0 1 .052-.13c.068-.15.1-.314.093-.478a1.23 1.23 0 0 0-2.09-.882l-.02.018-6.628 6.628 12.833 12.833a6.859 6.859 0 0 0 4.881 2.022z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        d: "M23.237 36.5a7.852 7.852 0 0 1-5.588-2.315L4.816 21.352l-.23.231a2 2 0 0 0 0 2.83l11.852 11.831a9.404 9.404 0 0 0 6.64 2.75L38.171 39a4.274 4.274 0 0 0 1.122-2.5H23.237z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        d: "M39.308 36h-16.07A7.4 7.4 0 0 1 18 33.832L5.17 21l-.584.584a2 2 0 0 0 0 2.83l11.852 11.83a9.4 9.4 0 0 0 6.64 2.749L38.17 39c.3-.32.546-.684.731-1.08a4.21 4.21 0 0 0 .412-1.832c.002-.032-.003-.057-.004-.088z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M18 33.832A7.4 7.4 0 0 0 23.237 36h16.07c0 .031.007.056.007.088a3.705 3.705 0 0 0-2.664-3.732l-1.15-.446a16.127 16.127 0 0 1-4.658-2.8l-.893.89H27.12l2.285-2.285a16.392 16.392 0 0 1-1.373-1.755L26.993 27h-2.83l2.752-2.75-1.215-1.905-.592.589a6.763 6.763 0 0 1-10.991-7.445.947.947 0 0 1 .052-.13c.068-.15.1-.314.093-.478a1.229 1.229 0 0 0-2.09-.881h-.005l-.013.014L5.17 21 18 33.832z",
      })
    );
  },
  A = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm8 5.991h1v-12H8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2zm7 .5a2.5 2.5 0 0 1-5 0v-13a2.5 2.5 0 0 1 5 0v13zm23 .009a2.5 2.5 0 0 1-5 0v-13a2.5 2.5 0 0 1 5 0v13zm1-.509h1a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1v12zM17 26h14v-4H17v4z",
      }),
      a("path", {
        d: "M12.5 14.991a2.5 2.5 0 0 0-2.5 2.5v13a2.5 2.5 0 0 0 5 0v-13a2.5 2.5 0 0 0-2.5-2.5zm23 .009a2.5 2.5 0 0 0-2.5 2.5v13a2.5 2.5 0 0 0 5 0v-13a2.5 2.5 0 0 0-2.5-2.5zM6 19.991v8a2 2 0 0 0 2 2h1v-12H8a2 2 0 0 0-2 2zm34-2h-1v12h1a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zM31 22H17v4h14v-4z",
        className: "at-0 ot-2",
        fill: "transparent",
      }),
      a("path", {
        d: "M12.5 14.991a2.5 2.5 0 0 0-2.5 2.5v13a2.5 2.5 0 0 0 5 0v-13a2.5 2.5 0 0 0-2.5-2.5zm23 .009a2.5 2.5 0 0 0-2.5 2.5v13a2.5 2.5 0 0 0 5 0v-13a2.5 2.5 0 0 0-2.5-2.5zM6 19.991v8a2 2 0 0 0 2 2h1v-12H8a2 2 0 0 0-2 2zm34-2h-1v12h1a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2z",
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M33 22H15v4h18v-4z",
      })
    );
  },
  x = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm30.024.763a7.188 7.188 0 0 1 5.998-3.223 7.19 7.19 0 0 1 5.964 3.168 8.72 8.72 0 0 1 .016-.272c.009-.136.018-.272.018-.41-.007-9.933-8.062-17.982-17.994-17.982-9.933 0-17.987 8.049-17.995 17.981 0 .139.01.275.019.41.006.091.012.181.016.273a7.196 7.196 0 0 1 11.962.055A7.195 7.195 0 0 1 23 21.619V39a1 1 0 1 1-2 0v-2l-2 .89V39a3 3 0 0 0 6 0V21.609a7.2 7.2 0 0 1 5.024 3.154z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M11.301 11.301A17.994 17.994 0 0 1 42.02 24.025c0 .139-.01.274-.019.41-.006.09-.012.181-.016.272a7.196 7.196 0 0 0-11.962.055A7.198 7.198 0 0 0 25 21.61V39a3 3 0 0 1-6 0v-1.11l2-.89v2a1 1 0 0 0 2 0V21.618a7.195 7.195 0 0 0-4.973 3.145 7.196 7.196 0 0 0-11.962-.056 8.94 8.94 0 0 0-.016-.271 6 6 0 0 1-.018-.41c0-4.773 1.896-9.35 5.27-12.725zM10.848 18a14.513 14.513 0 0 1 12.375-8.438L24 8.032A16.011 16.011 0 0 0 9.22 18h1.628z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M24.025 21.54a7.184 7.184 0 0 0-1.025.079V39a1 1 0 1 1-2 0v-2l-2 .89V39a3 3 0 1 0 6 0V21.609a7.222 7.222 0 0 0-.975-.069z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M24.025 6.031A17.994 17.994 0 0 0 6.031 24.025c0 .23.026.454.034.682a7.196 7.196 0 0 1 11.962.055 7.194 7.194 0 0 1 11.997 0 7.196 7.196 0 0 1 11.962-.055c.008-.228.034-.451.034-.681A17.995 17.995 0 0 0 24.025 6.03z",
      }),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        d: "M24 8.032A16.011 16.011 0 0 0 9.22 18h1.628a14.514 14.514 0 0 1 12.374-8.438L24 8.032z",
      })
    );
  },
  R = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.666 4.045a24 24 0 1 1 26.668 39.91 24 24 0 0 1-26.668-39.91zM24 41l10.26-14.73a12.36 12.36 0 1 0-20.52 0L24 41z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M27.964 7.649a12.364 12.364 0 0 1 6.29 18.62v.005L24 41 13.743 26.264a12.364 12.364 0 0 1 14.22-18.615zM17.337 22.113a7.212 7.212 0 1 0 13.326-5.52 7.212 7.212 0 0 0-13.326 5.52z",
      }),
      a("path", {
        className: "ot-0 otc-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M34.257 26.269a12.364 12.364 0 1 0-20.514 0L24 41l10.253-14.726.004-.005z",
      }),
      a("path", {
        className: "ot-0 otc-2",
        fill: "#00BED5",
        d: "M31.212 19.353a7.212 7.212 0 1 1-14.424 0 7.212 7.212 0 0 1 14.424 0z",
      })
    );
  },
  L = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm39.561 3.411L40 23.967l5-5.547-3.243-3.252-6.068 4.057L29.231 13H6l-1 8 4 8.983L16 31l8 5 3-3.008h4l1.824 1.98a3.059 3.059 0 0 0 2.189.985 2.749 2.749 0 0 0 2.348-4.222l-.8-1.424 3-2.9z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "m41.5 17.745-4.7 3.142-1.339.9-1.161-1.122L28.424 15H7.766l-.712 5.7 3.325 7.468 6.324.918 7.006 4.378 2.461-2.467h5.708l.595.646 1.793 1.951c.19.217.458.35.745.37a.825.825 0 0 0 .693-.4.738.738 0 0 0-.074-.814l-1.563-2.796 1.1-1.07 2.494-2.414.429-3.369 4.15-4.603-.74-.753z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M6 13h23.231l6.458 6.225 6.068-4.057L45 18.42l-5 5.547-.441 3.446-3 2.9.8 1.424a2.749 2.749 0 0 1-2.348 4.222 3.059 3.059 0 0 1-2.189-.985L31 32.992h-4L24 36l-8-5-7-1.017L5 21l1-8zm22.424 2H7.766l-.712 5.7 3.325 7.459 6.324.918 7.006 4.375 2.461-2.467h5.71l.595.646 1.793 1.951c.19.217.458.35.745.37a.825.825 0 0 0 .693-.4.736.736 0 0 0-.074-.814l-1.563-2.796 1.1-1.07 2.494-2.414.43-3.369 4.15-4.603-.744-.745-4.7 3.142-1.339.9L28.424 15z",
      })
    );
  },
  B = function (l) {
    return a(
      "svg",
      Object.assign(
        { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" },
        l
      ),
      a("circle", {
        className: "at-0 otc-0 ttc-1 ttcw-1",
        fill: "#FFF",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "at-0 otc-2 ttc-2",
        fill: "transparent",
        d: "M24 0C10.75 0 0 10.75 0 24s10.75 24 24 24 24-10.75 24-24S37.25 0 24 0zm12.72 40H11.28C9.47 40 8 38.53 8 36.72c0-.58.16-1.12.43-1.59l.24-.43h13.62l1.06-2.12H9.84l2.34-4.24h10.1l1.06-2.12h-9.99l2.34-4.24h6.58l1.06-2.12h-6.47L19 16V7h-1c-.55 0-1-.45-1-1s.45-1 1-1h12c.55 0 1 .45 1 1s-.45 1-1 1h-1v9l10.57 19.12c.27.48.43 1.02.43 1.6 0 1.81-1.47 3.28-3.28 3.28z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-0",
        fill: "#002677",
        d: "M39.57 35.12 29 16V7h1c.55 0 1-.45 1-1s-.45-1-1-1H18c-.55 0-1 .45-1 1s.45 1 1 1h1v9L8.43 35.12c-.27.48-.43 1.02-.43 1.6C8 38.53 9.47 40 11.28 40h25.44c1.81 0 3.28-1.47 3.28-3.28 0-.58-.16-1.12-.43-1.6zM36.72 38H11.28c-.71 0-1.28-.57-1.28-1.28 0-.2.06-.41.18-.63l.77-1.4h11.33l1.06-2.12H12.12l2.34-4.24h7.82l1.06-2.12h-7.7l2.4-4.24h4.24l1.06-2.12h-4.19L21 16.52V7h6v9.52L37.83 36.1c.12.21.17.41.17.62 0 .71-.57 1.28-1.28 1.28z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-0",
        fill: "#00BED5",
        d: "M11.28 38h25.44c.71 0 1.28-.57 1.28-1.28 0-.2-.06-.41-.17-.62L31.14 24H16.86l-1.22 2.21h7.7l-1.06 2.12h-7.82l-2.34 4.24h11.22l-1.06 2.12H10.95l-.77 1.4c-.12.22-.18.43-.18.63 0 .71.57 1.28 1.28 1.28z",
      })
    );
  },
  C = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm-9.475 6.46h2v-2h14v2h2a2 2 0 1 1 0 4h-2v2h-14v-2h-2a2 2 0 1 1 0-4zm2 10h-2a2 2 0 0 0 0 4h2v2h14v-2h2a2 2 0 1 0 0-4h-2v-2h-14v2zm-6.5 15.5-3-3.477 3-3.477v6.954zm19.5 10.5v-2h2a2 2 0 1 0 0-4h-2v-2h-14v2h-2a2 2 0 0 0 0 4h2v2h14zm5-12h-2v2h-14v-2h-2a2 2 0 1 1 0-4h2v-2h14v2h2a2 2 0 0 1 0 4zm5.5-5.5v6.956l3-3.478-3-3.478z",
      }),
      a("path", {
        d: "M40.025 24.96v6.956l3-3.478-3-3.478zm-30 7v-6.954l-3 3.477 3 3.477z",
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
      }),
      a("path", {
        d: "M14.525 9.96a1.5 1.5 0 0 1 0-3h2.5v-2h13v2h2.5a1.5 1.5 0 0 1 0 3h-2.5v2h-13v-2h-2.5zm0 10a1.5 1.5 0 0 1 0-3h2.5v-2h13v2h2.5a1.5 1.5 0 1 1 0 3h-2.5v2h-13v-2h-2.5zm17 17a1.5 1.5 0 1 1 0 3h-2.5v2h-13v-2h-2.5a1.5 1.5 0 0 1 0-3h2.5v-2h13v2h2.5zm-12.5-5v-2h-2.5a1.5 1.5 0 0 1 0-3h2.5v-2h13v2h2.5a1.5 1.5 0 1 1 0 3h-2.5v2h-13z",
        className: "at-0 ttc-1 ttcw-1",
        fill: "#fff",
      }),
      a("path", {
        className: "at-2",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M34.525 24.96h-.5v-2h-2v-1h.5a3.5 3.5 0 1 0 0-7h-.5v-3h.5a3.5 3.5 0 0 0 0-7h-.5v-2h-17v2h-.5a3.5 3.5 0 1 0 0 7h.5v3h-.5a3.5 3.5 0 1 0 0 7h.5v2h2v1h-.5a3.5 3.5 0 1 0 0 7h.5v1h-3v2h-.5a3.5 3.5 0 1 0 0 7h.5v2h17v-2h.5a3.5 3.5 0 1 0 0-7h-.5v-1h3v-2h.5a3.5 3.5 0 1 0 0-7zm-20-15a1.5 1.5 0 0 1 0-3h2.5v-2h13v2h2.5a1.5 1.5 0 0 1 0 3h-2.5v2h-13v-2h-2.5zm-1.5 8.5a1.5 1.5 0 0 0 1.5 1.5h2.5v2h13v-2h2.5a1.5 1.5 0 0 0 0-3h-2.5v-2h-13v2h-2.5a1.5 1.5 0 0 0-1.5 1.5zm18.5 18.5a1.5 1.5 0 1 1 0 3h-2.5v2h-13v-2h-2.5a1.5 1.5 0 0 1 0-3h2.5v-2h13v2h2.5zm.5-7h2.5a1.5 1.5 0 0 0 0-3h-2.5v-2h-13v2h-2.5a1.5 1.5 0 1 0 0 3h2.5v2h13v-2z",
      }),
      a("path", {
        d: "M19.025 6h-1v5.142l1-.238V6zm0 9.858h-1V21l1-.238v-4.904zm1 15.284 1-.238V26h-1v5.142zM17 41.182l1-.239V36.04h-1v5.142z",
        className: "at-2",
        fill: "#002677",
      })
    );
  },
  I = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zM12 9.023v29.97h24V9.023h-7.818l-.332-.02a3.981 3.981 0 0 0-7.717 0l-.331.02H12z",
      }),
      a("path", {
        className: "at-1 ot-0 otc-2",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M16.992 13.004h14v-1a2.97 2.97 0 0 0-.178-.981H34v25.97H14v-25.97h3.17a2.972 2.972 0 0 0-.178.98v1zM17 32.029h13.978l1.022-2H17v2zm13.978-6H17v-2h15l-1.022 2zM17 20.03h13.978l1.022-2H17v2z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-3",
        fill: "#002677",
        fillRule: "evenodd",
        d: "m27.85 9.004.332.019H36v29.97H12V9.023h7.802l.331-.02a3.981 3.981 0 0 1 7.717 0zM14 36.994h20V11.022h-3.186c.114.315.174.646.178.98v1h-14v-1c.003-.334.063-.665.178-.98H14v25.97z",
      }),
      a("path", {
        d: "M17 32.03h13.978l1.022-2H17v2zm0-6h13.978l1.022-2H17v2zm0-6h13.978l1.022-2H17v2z",
        className: "at-2 otc-0 ttcw-3",
        fill: "#00BED5",
      })
    );
  },
  D = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zM12 9.023v29.97h24V9.023h-7.818l-.332-.02a3.981 3.981 0 0 0-7.717 0l-.331.02H12z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M16.992 13.004h14v-1a2.971 2.971 0 0 0-.178-.981H34v25.97H14v-25.97h3.17a2.97 2.97 0 0 0-.178.98v1zm.219 11.764 5.036 5.036 10.025-10.025h-4.243l-5.782 5.782-2.915-2.914-2.121 2.121z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-3",
        fill: "#002677",
        fillRule: "evenodd",
        d: "m27.85 9.004.332.019H36v29.97H12V9.023h7.802l.331-.02a3.981 3.981 0 0 1 7.717 0zM14 36.994h20V11.022h-3.186c.114.315.174.646.178.98v1h-14v-1a2.97 2.97 0 0 1 .178-.98H14v25.97z",
      }),
      a("path", {
        className: "at-0",
        fill: "transparent",
        d: "m28.182 9.023-.332-.02a3.981 3.981 0 0 0-7.717 0l-.331.02H12v29.97h24V9.023h-7.818z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-1",
        fill: "#fff",
        d: "M34 36.993H14v-25.97h3.17a2.97 2.97 0 0 0-.178.98v1h14v-1a2.97 2.97 0 0 0-.178-.98H34v25.97z",
      }),
      a("path", {
        className: "at-2 otc-0 ttcw-3",
        fill: "#00BED5",
        d: "m22.247 25.561-2.915-2.914-2.121 2.121 5.036 5.036 10.025-10.025h-4.243l-5.782 5.782z",
      })
    );
  },
  b = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm27.35 12.524 6.818-14.308-.002-.001A10.031 10.031 0 1 0 15 18.062v15.354a6.559 6.559 0 0 0 12.35 3.108z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-1",
        fill: "#fff",
        d: "m34.17 22.216-6.82 14.308A6.559 6.559 0 0 1 15 33.416V18.062a10.031 10.031 0 1 1 19.166 4.153l.003.001z",
      }),
      a("path", {
        className: "at-0 ot-2 ttcw-2",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M25.031 6.031c6.645 0 12.031 5.387 12.031 12.031a11.98 11.98 0 0 1-1.027 4.875h.006l-6.908 14.489A8.56 8.56 0 0 1 13 33.416V18.062c0-6.645 5.387-12.031 12.031-12.031zm2.318 30.493 6.82-14.308-.003-.001A10.031 10.031 0 1 0 15 18.062v15.354a6.559 6.559 0 0 0 12.35 3.108z",
      }),
      a("path", {
        className: "at-2 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M25 12.248a6.257 6.257 0 0 0-6.25 6.25V21h.023a4.25 4.25 0 0 1 0 8.5h-.009V31h.009a5.746 5.746 0 0 0 1.477-11.3v-1.2a4.744 4.744 0 0 1 9.36-1.1l1.39-.619a6.256 6.256 0 0 0-6-4.533z",
      })
    );
  },
  E = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "ot-0 otc-2 ttc-2",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm6.33 0A20.98 20.98 0 0 0 24 33.71 20.98 20.98 0 0 0 41.67 24a20.932 20.932 0 0 0-35.34 0z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M4 24a22.925 22.925 0 0 1 20-11.71A22.924 22.924 0 0 1 44 24a22.933 22.933 0 0 1-40 0zm2.33 0A20.98 20.98 0 0 0 24 33.71 20.98 20.98 0 0 0 41.67 24a20.932 20.932 0 0 0-35.34 0z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-1",
        fill: "#fff",
        d: "M24 33.711A20.98 20.98 0 0 1 6.33 24a20.932 20.932 0 0 1 35.34 0A20.98 20.98 0 0 1 24 33.711z",
      }),
      a("path", {
        className: "at-2 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M24 32a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
      }),
      a("path", {
        className: "at-2",
        fill: "#002677",
        d: "M24 28a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
      })
    );
  },
  O = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zM11 30l3-.039L25 20V10l10-3.813v11.026c0 1.128.1 2.143 1.028 2.78a4.522 4.522 0 0 1-2.553 8.257H31.77c-.585 0-1.165.122-1.7.36l-7.76 4.206A13.736 13.736 0 0 1 16.731 34H11a2 2 0 0 1-2-2.019A1.97 1.97 0 0 1 11 30zm-2.667 8H40v-3H7l1.333 3z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
        d: "M11 34h5.732c1.922 0 3.823-.403 5.58-1.184l7.761-4.206a4.183 4.183 0 0 1 1.7-.36h1.705a4.522 4.522 0 0 0 2.553-8.257C35.1 19.356 35 18.341 35 17.213V6.187L25 10v10l-11 9.961L11 30a1.97 1.97 0 0 0-2 1.981A2 2 0 0 0 11 34z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        d: "m7 35 1.333 3H40v-3H7z",
      })
    );
  },
  j = function (l) {
    return a(
      "svg",
      Object.assign(
        { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" },
        l
      ),
      a("circle", {
        className: "at-0 otc-0 ttc-2 ttcw-1",
        fill: "#FFF",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "at-0 ttc-1",
        fill: "transparent",
        d: "M25.03 8C19.5 8 15 12.51 15 18.06v15.35c0 3.63 2.94 6.58 6.56 6.58a6.56 6.56 0 0 0 5.79-3.48l6.82-14.31c.59-1.31.9-2.71.9-4.15C35.06 12.51 30.56 8 25.03 8z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-0",
        fill: "#002677",
        d: "M37.06 18.06C37.06 11.41 31.66 6 25.03 6S13 11.41 13 18.06v15.35c0 4.73 3.84 8.58 8.56 8.58 3.16 0 6.05-1.74 7.57-4.57l6.91-14.49h-.01a11.83 11.83 0 0 0 1.03-4.87zm-2.89 4.16-6.82 14.31A6.57 6.57 0 0 1 21.56 40C17.94 40 15 37.05 15 33.42V18.06C15 12.51 19.5 8 25.03 8s10.03 4.51 10.03 10.06c0 1.45-.3 2.84-.89 4.16z",
      }),
      a("path", {
        className: "ot-2 otc-0 tt-2 ttc-3 ttcw-2",
        fill: "#002677",
        d: "M39.06 18.06C39.06 10.31 32.77 4 25.03 4 17.29 4 11 10.31 11 18.06V30h10c2.76 0 5-2.24 5-5s-2.24-5-5-5h-.75v-1.5c0-2.62 2.13-4.75 4.75-4.75 2.24 0 4.11 1.56 4.61 3.65l1.4-.62c-.75-2.61-3.15-4.53-6-4.53-3.45 0-6.25 2.8-6.25 6.25V20H13v-1.94C13 11.41 18.4 6 25.03 6s12.03 5.41 12.03 12.06c0 1.69-.35 3.33-1.03 4.87h.01L35.06 25h.88c.81 0 1.55-.47 1.91-1.2.8-1.82 1.21-3.75 1.21-5.74z",
      }),
      a("path", {
        className: "at-0 tt-3 ttcw-3",
        fill: "#00BED5",
        d: "M39.06 18.06C39.06 10.31 32.77 4 25.03 4 17.29 4 11 10.31 11 18.06V20h2v-1.94C13 11.41 18.4 6 25.03 6s12.03 5.41 12.03 12.06c0 1.69-.35 3.33-1.03 4.87h.01L35.06 25h.88c.81 0 1.55-.47 1.91-1.2.8-1.82 1.21-3.75 1.21-5.74z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-2",
        fill: "#00BED5",
        d: "M25 12.25c-3.45 0-6.25 2.8-6.25 6.25V20h1.5v-1.5c0-2.62 2.13-4.75 4.75-4.75 2.24 0 4.11 1.56 4.61 3.65l1.4-.62c-.75-2.61-3.16-4.53-6.01-4.53z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M24 0C10.75 0 0 10.75 0 24s10.75 24 24 24 24-10.75 24-24S37.25 0 24 0zm3.35 36.52A6.56 6.56 0 0 1 21.56 40C17.94 40 15 37.05 15 33.42v-2.67h6c3.17 0 5.75-2.58 5.75-5.75s-2.58-5.75-5.75-5.75h-.75v-.75c0-2.62 2.13-4.75 4.75-4.75 2.24 0 4.11 1.56 4.61 3.65l1.4-.62c-.75-2.61-3.15-4.53-6-4.53-3.45 0-6.25 2.8-6.25 6.25v.75H15v-1.19C15 12.51 19.5 8 25.03 8s10.03 4.51 10.03 10.06c0 1.44-.3 2.84-.9 4.15l-6.81 14.31zm10.5-12.72c-.35.73-1.09 1.2-1.91 1.2h-.88l.98-2.06h-.01c.68-1.54 1.03-3.18 1.03-4.87C37.06 11.41 31.66 6 25.03 6S13 11.41 13 18.06v2.69h8c2.34 0 4.25 1.91 4.25 4.25s-1.91 4.25-4.25 4.25H11V18.06C11 10.31 17.29 4 25.03 4c7.74 0 14.03 6.31 14.03 14.06 0 1.99-.41 3.92-1.21 5.74z",
      })
    );
  },
  S = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm-2.392 16.365a5 5 0 1 1 4.784 0 8.006 8.006 0 0 1 5 4.635H16.607a8.006 8.006 0 0 1 5-4.635zM35 32.549l4-1.777V9h-4v12h-3.587c.388.953.587 1.971.587 3v5H16v-5a7.962 7.962 0 0 1 .59-3h-4.6a4 4 0 0 0 0 8H16v11.991l16-7.109V29h3v3.549z",
      }),
      a("path", {
        d: "M26.392 16.365a5 5 0 1 0-4.784 0 8.006 8.006 0 0 0-5 4.635h14.785a8.006 8.006 0 0 0-5.001-4.635zM16 40.991l16-7.109V29H16v11.991zM35 9v12h-3.587c.387.953.587 1.971.587 3v5h3v3.55l4-1.778V9h-4zM16.587 21h-4.6a4 4 0 1 0 0 8H16v-5c0-1.029.2-2.047.587-3z",
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
      }),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "M16 24v5h16v-5a7.96 7.96 0 0 0-.587-3H16.587A7.96 7.96 0 0 0 16 24z",
      })
    );
  },
  y = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm31 17a2 2 0 0 0 2-2V21.182a6.36 6.36 0 0 0-2.546-5.091A3.637 3.637 0 0 1 29 13.182V13h1V6H18v7h1v.182a3.637 3.637 0 0 1-1.454 2.909A6.36 6.36 0 0 0 15 21.182V39a2 2 0 0 0 2 2h14z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "#002677",
        d: "M28 8h-8v3h8V8z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M30.454 16.091A3.637 3.637 0 0 1 29 13.182V13h1V6H18v7h1v.182a3.637 3.637 0 0 1-1.454 2.909A6.36 6.36 0 0 0 15 21.182V39a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V21.182a6.36 6.36 0 0 0-2.546-5.091zM20 8h8v3h-8V8zm-3 28h14V21l-14 6v9z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-0",
        fill: "#00BED5",
        d: "M30 6H18v7h12V6zm2.66 13.15L15 27v9h18V21.182a6.364 6.364 0 0 0-.34-2.031z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M17 36h14V21l-14 6v9z",
      }),
      a("path", {
        d: "M15 36v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3H15zm15.454-19.909A3.637 3.637 0 0 1 29 13.182V13H19v.182a3.637 3.637 0 0 1-1.454 2.909A6.36 6.36 0 0 0 15 21.182V27l17.66-7.849a6.35 6.35 0 0 0-2.206-3.06z",
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
      })
    );
  },
  F = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm32-12h1V6a1 1 0 0 0-1-1H16a1 1 0 0 0-1 1v6h1v28a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V12z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M30 34H18V18h12v16zm-7.054-12.483h-2.93l.004 6.067h1.32V25.2h1.36l1.856 2.634-1.829 2.65h1.56l1.05-1.526 1.057 1.525h1.59l-1.857-2.676 1.65-2.34h-1.538l-.833 1.325-1.362-1.917a1.423 1.423 0 0 0 .134-.07c.475-.263.8-.733.876-1.27.021-.16.023-.322.006-.483a1.656 1.656 0 0 0-.643-1.173 1.433 1.433 0 0 0-.133-.089 2.412 2.412 0 0 0-1.338-.273z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M23.456 24.056a.763.763 0 0 0 .318-.664c0-.573-.346-.828-1.12-.828h-1.319v1.665H22.6c.296.034.596-.026.856-.173z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-3 ttcw-2",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M16 5h16a1 1 0 0 1 1 1v6h-1v28a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2V12h-1V6a1 1 0 0 1 1-1zm2 29h12V18H18v16z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-1",
        fill: "#fff",
        d: "M30 34H18V18h12v16z",
      }),
      a("path", {
        className: "at-2 otc-0",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M22.7 25.2h-1.365v2.384h-1.32v-6.07h2.931a2.41 2.41 0 0 1 1.338.273 1.657 1.657 0 0 1 .776 1.262c.017.16.015.323-.006.483a1.728 1.728 0 0 1-.876 1.27 1.395 1.395 0 0 1-.134.071l1.362 1.916.833-1.326h1.542l-1.649 2.341 1.857 2.676H26.4l-1.058-1.525-1.05 1.525h-1.559l1.83-2.649-1.862-2.63zm-.046-2.639h-1.319v1.665H22.6c.296.034.596-.026.856-.173a.763.763 0 0 0 .318-.664c0-.573-.346-.828-1.12-.828z",
      }),
      a("path", {
        fill: "transparent",
        d: "M16 12v28a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V12H16z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M16 5h16a1 1 0 0 1 1 1v6H15V6a1 1 0 0 1 1-1z",
      })
    );
  },
  P = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#ffff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm36 15a2 2 0 0 0 2-2V11a2 2 0 0 0-2-2h-5.3a8.971 8.971 0 0 0-13.395 0H12a2 2 0 0 0-2 2v26a2 2 0 0 0 2 2h24z",
      }),
      a("path", {
        className: "ot-0 otc-2 ttc-3 ttcw-1",
        fill: "#fff",
        d: "M24 8a7.008 7.008 0 0 0-7 7v1h6.225l2.5-5h2.236l-2.5 5H31v-1a7.008 7.008 0 0 0-7-7z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.7 9H36a2 2 0 0 1 2 2v26a2 2 0 0 1-2 2H12a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2h5.31A8.971 8.971 0 0 1 30.7 9zm-5.239 7H31v-1a7 7 0 1 0-14 0v1h6.225l2.5-5h2.236l-2.5 5z",
      }),
      a("path", {
        className: "at-0 ttc-2 ttcw-3",
        fill: "#00BED5",
        d: "M23.225 16h2.236l2.5-5h-2.236l-2.5 5z",
      })
    );
  },
  Z = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm12 28.816V34.5a8.5 8.5 0 0 1-17 0v-8.559A9 9 0 0 1 11 17V9a2 2 0 0 1 2-2h2a1 1 0 1 1 0 2h-2v8a7 7 0 1 0 14 0V9h-2a1 1 0 1 1 0-2h2a2 2 0 0 1 2 2v8a9 9 0 0 1-8 8.941V34.5a6.5 6.5 0 1 0 13 0v-5.684a3 3 0 1 1 2 0zM36 26a1 1 0 1 1-2 0 1 1 0 0 1 2 0z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M32.045 25.486A2.993 2.993 0 0 1 35 23a2.993 2.993 0 0 1 1 5.816V34.5a8.5 8.5 0 0 1-17 0v-8.559A9 9 0 0 1 11 17V9a2 2 0 0 1 2-2h2a1 1 0 1 1 0 2h-2v8a7 7 0 1 0 14 0V9h-2a1 1 0 1 1 0-2h2a2 2 0 0 1 2 2v8a9 9 0 0 1-8 8.941V34.5a6.5 6.5 0 1 0 13 0v-5.684a2.993 2.993 0 0 1-1.955-3.33zM34 26a1 1 0 1 0 2 0 1 1 0 0 0-2 0z",
      }),
      a("path", {
        d: "M34 34.5a6.5 6.5 0 1 1-13 0v-8.559A9 9 0 0 0 29 17h-2a7 7 0 1 1-14 0h-2a9 9 0 0 0 8 8.941V34.5a8.5 8.5 0 0 0 17 0V31h-2v3.5zM25 9h1V7h-1a1 1 0 1 0 0 2zm-9-1a1 1 0 0 0-1-1h-1v2h1a1 1 0 0 0 1-1z",
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
      }),
      a("path", {
        d: "M11 9v8h2V9h1V7h-1a2 2 0 0 0-2 2zm16-2h-1v2h1v8h2V9a2 2 0 0 0-2-2zm8 16a2.993 2.993 0 0 0-1 5.816V31h2v-2.184A2.993 2.993 0 0 0 35 23z",
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
      }),
      a("path", {
        className: "at-2 ot-0 ttc-3",
        fill: "#002677",
        d: "M35 27a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
      })
    );
  },
  k = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm39.44-8.585A1 1 0 1 0 40.856 14L34.37 7.516a1 1 0 1 0-1.415 1.414l1.657 1.657-4.127 4.126-3.081-3.081a2.014 2.014 0 0 0 0 2.849L14.4 27.488V31l-1.067 1.065a.923.923 0 0 0 0 1.306l.42.42L7.543 40h1.415l5.5-5.502.542.54c.361.36.946.36 1.307 0l1.065-1.065h3.51L33.89 20.966a2.015 2.015 0 0 0 2.85 0l-3.082-3.081 4.127-4.126 1.656 1.656z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.37 7.516 40.856 14a1 1 0 1 1-1.414 1.415l-1.656-1.656-4.127 4.126 3.082 3.08a2.015 2.015 0 0 1-2.85 0l-13.008 13.01H17.37l-1.065 1.066a.926.926 0 0 1-1.307 0l-.541-.541-5.5 5.5H7.544l6.21-6.208-.42-.42a.923.923 0 0 1 0-1.306L14.4 31v-3.512L27.405 14.48a2.014 2.014 0 0 1 0-2.85l3.08 3.082 4.128-4.126-1.657-1.657a1 1 0 0 1 1.415-1.414zm-14.762 24.07c.747 0 1.464-.298 1.992-.826l4.921-4.922-5.754-2.214-3.15 3.151a2.817 2.817 0 0 0 1.991 4.81z",
      }),
      a("path", {
        className: "ot-0 otc-2",
        fill: "#00BED5",
        d: "M17.611 30.76a2.817 2.817 0 0 0 3.984 0l4.921-4.922-5.754-2.214-3.152 3.151a2.819 2.819 0 0 0 .001 3.985z",
      })
    );
  },
  T = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm39.521-5.621a1 1 0 1 0 1.414-1.415l-9.9-9.9a1 1 0 0 0-1.414 1.414l.707.707-19.8 19.8a6 6 0 0 0 8.486 8.486l19.8-19.8.707.708z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M20.343 22h11.314l5.743-5.743-5.657-5.657-11.4 11.4zM29 20a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1-5a1 1 0 1 0 2 0 1 1 0 0 0-2 0z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "m31.265 7.28 9.9 9.9a1 1 0 1 1-1.414 1.416l-.707-.708-19.8 19.8a6 6 0 1 1-8.486-8.486l19.8-19.8-.707-.707a1 1 0 0 1 1.414-1.414zM20.572 22.217h11.314l5.743-5.743-5.657-5.657-11.4 11.4zm.658 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "m40.935 16.964-9.9-9.9a1 1 0 1 0-1.415 1.414l.707.707-19.8 19.8a6 6 0 0 0 8.486 8.486l19.8-19.8.707.708a1 1 0 1 0 1.414-1.415h.001z",
      }),
      a("path", {
        className: "at-0 ttcw-1",
        fill: "#fff",
        d: "M17.6 36.056a4 4 0 1 1-5.656-5.656l19.8-19.8 5.656 5.657-19.8 19.8z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "m20.343 22-8.4 8.4a4 4 0 1 0 5.657 5.656L31.657 22H20.343z",
      }),
      a("path", {
        className: "at-1 ot-0 otc-2",
        fill: "#fff",
        d: "M21 26a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
      }),
      a("path", {
        d: "M31.23 16.217a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-2 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
      })
    );
  },
  G = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm33 3.418a11.884 11.884 0 0 1 1.946-6.328 6.949 6.949 0 0 0 .998-4.587 7.06 7.06 0 0 0-5.852-6.013A7.347 7.347 0 0 0 29 10.407a6.897 6.897 0 0 0-3.193.773 3.942 3.942 0 0 1-3.614 0A6.9 6.9 0 0 0 19 10.407c-.365 0-.73.028-1.091.083a7.06 7.06 0 0 0-5.852 6.013 6.949 6.949 0 0 0 .997 4.587A11.887 11.887 0 0 1 15 27.418v3.99a8.91 8.91 0 0 0 1.903 5.533c.306.413.79.655 1.304.652A1.764 1.764 0 0 0 20 35.828v-1.25a4.084 4.084 0 0 1 3.292-4.11A4.004 4.004 0 0 1 28 34.407v1.422a1.762 1.762 0 0 0 1.793 1.765 1.61 1.61 0 0 0 1.304-.652A8.908 8.908 0 0 0 33 31.407v-3.99z",
      }),
      a("path", {
        className: "at-1 ot-0 otc-0",
        fill: "#fff",
        d: "M36.936 16.38a8.026 8.026 0 0 0-6.694-6.88A8.27 8.27 0 0 0 29 9.407a7.944 7.944 0 0 0-3.651.884 2.938 2.938 0 0 1-2.698 0A7.945 7.945 0 0 0 19 9.407a7.992 7.992 0 0 0-6.794 12.212 10.99 10.99 0 0 1 1.794 5.8v3.99a9.955 9.955 0 0 0 2.115 6.15 2.614 2.614 0 0 0 2.092 1.035A2.766 2.766 0 0 0 21 35.828v-1.25a2.995 2.995 0 0 1 3-3.17 3 3 0 0 1 3 3v1.42a2.766 2.766 0 0 0 2.793 2.765 2.614 2.614 0 0 0 2.092-1.036A9.955 9.955 0 0 0 34 31.407v-3.99a10.99 10.99 0 0 1 1.794-5.797 7.97 7.97 0 0 0 1.142-5.24z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M30.242 9.501a8.026 8.026 0 0 1 6.694 6.878 7.97 7.97 0 0 1-1.142 5.24 10.99 10.99 0 0 0-1.794 5.8v3.99a9.955 9.955 0 0 1-2.115 6.15 2.614 2.614 0 0 1-2.092 1.035A2.766 2.766 0 0 1 27 35.828v-1.42a3 3 0 0 0-3-3 2.996 2.996 0 0 0-3 3.17v1.25a2.765 2.765 0 0 1-2.793 2.765 2.614 2.614 0 0 1-2.092-1.036A9.955 9.955 0 0 1 14 31.407v-3.99a10.99 10.99 0 0 0-1.794-5.797A7.992 7.992 0 0 1 22.65 10.29a2.938 2.938 0 0 0 2.698 0A7.944 7.944 0 0 1 29 9.407c.416 0 .83.032 1.242.094zM32 27.418a12.868 12.868 0 0 1 2.097-6.857 5.96 5.96 0 0 0 .854-3.934 6.044 6.044 0 0 0-5.009-5.148 6.352 6.352 0 0 0-.942-.072 5.915 5.915 0 0 0-2.735.662 4.937 4.937 0 0 1-4.53 0 5.914 5.914 0 0 0-2.736-.662c-.315 0-.63.025-.942.072a6.045 6.045 0 0 0-5.008 5.148 5.958 5.958 0 0 0 .853 3.934A12.869 12.869 0 0 1 16 27.418v3.99a7.918 7.918 0 0 0 1.69 4.918c.118.17.311.27.517.267a.776.776 0 0 0 .793-.765v-1.25a5.081 5.081 0 0 1 4.12-5.095A5.006 5.006 0 0 1 29 34.407v1.42a.775.775 0 0 0 .793.766.62.62 0 0 0 .516-.267 7.918 7.918 0 0 0 1.69-4.919v-3.99z",
      }),
      a("path", {
        className: "at-2 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M14.994 17.331h1.5a2.454 2.454 0 0 1 2.45-2.45c.25.003.499.045.736.125l1.133-1.134a3.899 3.899 0 0 0-1.868-.492 3.955 3.955 0 0 0-3.95 3.951z",
      })
    );
  },
  W = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zM12.007 7H11v12.945h1.007V17H35v3h1v-7.058A1.941 1.941 0 0 0 34.058 11H19.985a2 2 0 0 0-2-2h-5.978V7zM24 36.423V37.5a4.5 4.5 0 1 1-9 0v-5.051A4.49 4.49 0 0 1 11 28v-5a1 1 0 0 1 1-1h1v1h-1v5a3.5 3.5 0 1 0 7 0v-5h-1v-1h1a1 1 0 0 1 1 1v5a4.49 4.49 0 0 1-4 4.449V37.5a3.5 3.5 0 1 0 7 0v-1.065a2.008 2.008 0 1 1 1-.012zM36 26h1v-3a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v3h1v15a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V26z",
      }),
      a(
        "g",
        { className: "at-0 otc-2", fill: "transparent" },
        a("path", {
          fillRule: "evenodd",
          d: "M35 38.46h-6v-9.082h6v9.081zm-3.529-6.96H30v3.05h.662v-1.2h.683l.934 1.32-.918 1.33h.783l.525-.766.531.766h.8l-.928-1.343.828-1.176h-.773l-.418.666-.683-.961.067-.037a.865.865 0 0 0 .439-.879.831.831 0 0 0-.389-.633 1.208 1.208 0 0 0-.672-.137z",
        }),
        a("path", { d: "m17.987 10-5.98.015V11h6.978a1 1 0 0 0-.998-1z" })
      ),
      a(
        "g",
        { className: "at-0 ot-2", fill: "transparent", fillRule: "evenodd" },
        a("path", {
          d: "M12.007 17H35v3h1v-7.058A1.941 1.941 0 0 0 34.058 11H19.985a2 2 0 0 0-2-2h-5.978V7H11v12.945h1.007V17zm7.438-4.985-2.174 3.97h-5.256v-3.97h7.43zM17.987 10l-5.98.015V11h6.98a1 1 0 0 0-1-1zM28 22h8a1 1 0 0 1 1 1v3h-1v15a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V26h-1v-3a1 1 0 0 1 1-1zm1 16.46h6v-9.082h-6v9.081z",
        }),
        a("path", {
          d: "M31.345 33.35h-.683v1.196H30V31.5h1.468c.233-.02.466.027.672.137a.831.831 0 0 1 .389.633.865.865 0 0 1-.439.879l-.067.037.683.961.418-.666h.772l-.828 1.176L34 36h-.8l-.529-.766-.527.766h-.783l.918-1.33-.934-1.32zm-.02-1.325h-.663v.836h.635c.149.017.3-.013.43-.087a.384.384 0 0 0 .16-.334c0-.287-.174-.415-.562-.415zm-9.832 2.225A2 2 0 1 1 24 36.424V37.5a4.5 4.5 0 1 1-9 0v-5.051A4.49 4.49 0 0 1 11 28v-5a1 1 0 0 1 1-1h1v1h-1v5a3.5 3.5 0 1 0 7 0v-5h-1v-1h1a1 1 0 0 1 1 1v5a4.49 4.49 0 0 1-4 4.449V37.5a3.5 3.5 0 1 0 7 0v-1.065a2 2 0 0 1-1.507-2.184zm1.992 1.25h.015a1.003 1.003 0 1 0 0-2.007h-.015a1.004 1.004 0 0 0 0 2.007z",
        })
      ),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M28 26v15a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V26h-8z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M36 22h-8a1 1 0 0 0-1 1v3h10v-3a1 1 0 0 0-1-1z",
      }),
      a(
        "g",
        { className: "at-0 ttc-2 ttcw-1", fill: "#fff" },
        a("path", { d: "M35 38.459h-6v-9.081h6v9.081z" }),
        a("path", {
          d: "M30.662 32.025h.663c.388 0 .562.128.562.415a.384.384 0 0 1-.16.334.71.71 0 0 1-.43.087h-.635v-.836z",
        })
      ),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M30.662 33.35h.683l.934 1.32-.918 1.33h.783l.527-.766.529.766h.8l-.932-1.343.828-1.176h-.772l-.418.666-.683-.961.067-.037a.865.865 0 0 0 .439-.879.83.83 0 0 0-.389-.633 1.207 1.207 0 0 0-.672-.137H30v3.046h.662V33.35zM12.007 17H35v3h1v-7.058A1.941 1.941 0 0 0 34.058 11H12.007V7H11v12.945h1.007V17zM23 37.5a3.5 3.5 0 1 1-7 0v-5.051A4.49 4.49 0 0 0 20 28v-5a1 1 0 0 0-1-1h-1v1h1v5a3.5 3.5 0 1 1-7 0v-5h1v-1h-1a1 1 0 0 0-1 1v5a4.49 4.49 0 0 0 4 4.449V37.5a4.5 4.5 0 1 0 9 0V36h-1v1.5z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M17.985 9 12 9.015V11h7.985a2 2 0 0 0-2-2zm5.496 23.493a2 2 0 1 0 2 2 2.007 2.007 0 0 0-2-2z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M12.015 15.985h5.256l2.174-3.97h-7.43v3.97z",
      }),
      a("path", {
        className: "at-2 ot-0",
        fill: "#002677",
        d: "M23.5 33.493a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M31.727 32.774a.384.384 0 0 0 .16-.334c0-.287-.174-.415-.562-.415h-.663v.836h.638a.71.71 0 0 0 .427-.087z",
      })
    );
  },
  U = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00bed5",
        cx: 24,
        cy: 24,
        r: 23,
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm29.83 16a2.4 2.4 0 0 0 2.386-2.159L35 10H13l2.784 27.841A2.4 2.4 0 0 0 18.17 40h11.66z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M15.51 15h16.98l.3-3H15.21l.3 3z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m13 10 2.784 27.841A2.4 2.4 0 0 0 18.17 40h11.66a2.4 2.4 0 0 0 2.386-2.159L35 10H13zm10.04 16.376-1.34 3.095a.418.418 0 0 1-.549.217l-3.095-1.34a.42.42 0 0 1-.217-.549l1.34-3.099a.418.418 0 0 1 .55-.217l3.093 1.34a.417.417 0 0 1 .217.553zm2.732 9.241 3.094-1.341v-.005a.416.416 0 0 0 .217-.548l-1.34-3.095a.418.418 0 0 0-.549-.217l-3.095 1.34a.418.418 0 0 0-.217.549l1.341 3.1a.417.417 0 0 0 .549.217zM30.1 22.976l-3.1 1.34a.417.417 0 0 1-.549-.217L25.116 21a.415.415 0 0 1 .217-.548l3.1-1.341a.42.42 0 0 1 .55.217l1.34 3.095a.418.418 0 0 1-.223.548v.005zM15.21 12l.3 3h16.98l.3-3H15.21z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        d: "m15.007 15 2.27 22.692c.044.46.431.81.892.808H29.83a.895.895 0 0 0 .893-.808L32.993 15H15.006z",
      }),
      a("path", {
        className: "ot-0 otc-2",
        fill: "#fff",
        d: "m28.428 19.11-3.095 1.34a.417.417 0 0 0-.217.55l1.34 3.094a.417.417 0 0 0 .549.217l3.095-1.34a.417.417 0 0 0 .217-.549l-1.34-3.095a.417.417 0 0 0-.549-.217zm-1.234 11.301L24.1 31.752a.417.417 0 0 0-.217.549l1.341 3.095a.417.417 0 0 0 .549.216l3.095-1.34a.417.417 0 0 0 .216-.549l-1.34-3.095a.417.417 0 0 0-.549-.217zm-8.014-5.707L17.838 27.8a.417.417 0 0 0 .217.548l3.095 1.34a.417.417 0 0 0 .548-.216l1.34-3.096a.417.417 0 0 0-.216-.548l-3.096-1.34a.417.417 0 0 0-.548.216z",
      })
    );
  },
  Q = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm11 15h11V28H11v11zm26 0H26V28h11v11zm0-21h1v-5h-8.633l1.78-1.612A2.572 2.572 0 0 0 27.7 7.571L24 10.917l-3.7-3.346a2.573 2.573 0 1 0-3.452 3.817L18.633 13H10v5h1v6h11V13h4v11h11v-6z",
      }),
      a("path", {
        d: "M26 13v11h11v-6h.993v-5H26zm-15.994 5H11v6h11V13H10.006v5zM37 28H26v11h11V28zm-15 0H11v11h11V28z",
        className: "ot-2 otc-0 ttc-1 ttcw-3",
        fill: "#00BED5",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        d: "m29.367 13 1.785-1.612a2.572 2.572 0 0 0-3.447-3.817L24 10.917l-3.7-3.346a2.572 2.572 0 1 0-3.447 3.817L18.633 13H10v5h1v6h11V13h4v11h11v-6h1v-5h-8.633z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        d: "M37 24H26V13h3.367l1.785-1.612a2.572 2.572 0 0 0-3.447-3.817L24 10.917l-3.7-3.346a2.572 2.572 0 1 0-3.447 3.817L18.633 13H22v11H11v4h11v11h4V28h11v-4z",
      })
    );
  },
  $ = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        cx: 24,
        cy: 24,
        r: 23,
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm33.66 11 .106-.11c5.242-5.35 5.199-13.924-.097-19.221L24 6l-9.667 9.672c-5.295 5.296-5.34 13.869-.1 19.22l.108.108a13.6 13.6 0 0 0 9.034 3.97v-5.426l-5.669-5.669h1.768l3.901 3.901v-5.232l-5.669-5.669h1.768l3.902 3.901v-8.413l1.25-.555v8.967l3.9-3.9h1.77l-5.67 5.669v5.231l3.9-3.9h1.768l-5.669 5.669v5.429A13.6 13.6 0 0 0 33.66 35z",
      }),
      a("path", {
        className: "ot-2",
        fill: "transparent",
        d: "M33.67 15.669 24 6l-9.669 9.669c-5.295 5.296-5.34 13.869-.1 19.22l.108.108a13.6 13.6 0 0 0 9.034 3.973v-5.426l-5.669-5.669h1.768l.036.036 3.865 3.865v-5.232l-5.669-5.669h1.768l.036.036 3.865 3.865v-8.413l1.25-.555v8.968l3.9-3.9h1.768l-5.669 5.669v5.232l3.9-3.9h1.768l-5.669 5.669v5.424A13.6 13.6 0 0 0 33.66 35l.107-.107c5.244-5.35 5.2-13.926-.097-19.224z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "m28.526 27.875-3.9 3.9v-5.231l5.67-5.669h-1.77l-3.9 3.9v-8.967l-1.25.555v8.413l-3.866-3.865-.036-.036h-1.768l5.67 5.669v5.232l-3.866-3.865-.036-.036h-1.768l5.67 5.669v5.426c.207.009.415.03.624.03.21 0 .417-.021.625-.03v-5.426l5.67-5.669h-1.769z",
      })
    );
  },
  _ = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm27.535 6.777L38 41.242v-8.484l-6.223-6.223a12.888 12.888 0 1 0-4.242 4.242z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M10.824 15.692A10.841 10.841 0 0 1 20.841 9c5.984.007 10.833 4.857 10.84 10.841a10.841 10.841 0 1 1-20.857-4.15zm3.335 4.149a6.88 6.88 0 0 1 5.612-6.712L21.001 11a8.85 8.85 0 0 0-8.842 8.841h2z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M28.776 9.669a12.892 12.892 0 0 1 3 16.866L38 32.758v8.484L27.535 30.777a12.892 12.892 0 1 1 1.24-21.108zM10.823 23.99a10.841 10.841 0 0 0 10.017 6.692c5.984-.008 10.833-4.857 10.84-10.84a10.841 10.841 0 1 0-20.857 4.148z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        d: "M12.159 19.841h2a6.88 6.88 0 0 1 5.612-6.712L21 11a8.85 8.85 0 0 0-8.841 8.841z",
      })
    );
  },
  q = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm28.82 9.331 6.206-4.705a.447.447 0 0 0-.264-.803l-7.786-.159-2.4-6.914L34 16.659V7H14v9.659l9.42 4.091-2.4 6.914-7.785.159a.447.447 0 0 0-.261.8l6.206 4.705-2.255 7.453a.447.447 0 0 0 .683.5L24 36.833l6.392 4.451a.447.447 0 0 0 .683-.5l-2.255-7.453z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M32 9H16v6.347l8 3.473 8-3.473V9z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "m26.98 27.664 7.785.159a.447.447 0 0 1 .261.803l-6.206 4.705 2.255 7.45a.446.446 0 0 1-.683.5L24 36.833l-6.389 4.448a.446.446 0 0 1-.683-.5l2.255-7.453-6.206-4.705a.447.447 0 0 1 .261-.8l7.786-.159 2.4-6.914L14 16.659V7h20v9.659l-9.42 4.091 2.4 6.914zm-.477 4.914 3.754-2.847-4.71-.096L24 25.185l-1.55 4.463-4.71.096 3.754 2.847-.4 1.332-.96 3.177 2.724-1.9L24 34.4l1.14.787 2.724 1.9-.96-3.177-.4-1.332z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "m23.998 36.833-6.39 4.448a.447.447 0 0 1-.683-.5l2.255-7.453-6.206-4.705a.447.447 0 0 1 .26-.8l7.787-.159L24 19.094l2.979 8.57 7.785.159a.447.447 0 0 1 .26.8l-6.204 4.705 2.255 7.453a.447.447 0 0 1-.683.5l-6.394-4.448z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        d: "M14 7v9.659L24 21l10-4.341V7H14z",
      })
    );
  },
  J = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm8.055 12h3V13h-3a2 2 0 0 0-2 2v19a2 2 0 0 0 2 2zm26 0h-20V13h4.167a4 4 0 0 1 4-4h3.667a4 4 0 0 1 4 4h4.166v23zm3 0h3.004a2 2 0 0 0 1.996-2V15a2 2 0 0 0-2-2h-3v23z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M25.889 11h-3.667a2 2 0 0 0-2 2h7.667a2 2 0 0 0-2-2z",
      }),
      a(
        "g",
        { className: "at-2 ttc-1 otc-0", fill: "#002677" },
        a("path", { d: "M6.055 15v19a2 2 0 0 0 2 2h3V13h-3a2 2 0 0 0-2 2z" }),
        a("path", {
          fillRule: "evenodd",
          d: "M25.888 9h-3.666a4 4 0 0 0-4 4h-4.167v23h20V13h-4.167a4 4 0 0 0-4-4zm-3.666 2h3.666a2 2 0 0 1 2 2h-7.666a2 2 0 0 1 2-2zm2.572 20 6.261-3.13V23.4l-8.05 4.022L24.795 31z",
        }),
        a("path", { d: "M40.055 13h-3v23h3a2 2 0 0 0 2-2V15a2 2 0 0 0-2-2z" })
      ),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "m24.794 31 6.261-3.13v-4.473l-8.05 4.025L24.794 31zm12.261-18h-3v23h3V13zm-23 0h-3v23h3V13z",
      })
    );
  },
  K = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm39 7h5a2 2 0 0 0-1-1.72v-4.43a3 3 0 0 0-1.7-2.69l-3.19-1.59-3.28-7.38A2 2 0 0 0 33 12h-1a2.5 2.5 0 0 0-5 0H9a2 2 0 0 0-2 2v15.28A2 2 0 0 0 6 31h3a4 4 0 0 0 8 0h14a4 4 0 0 0 8 0z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-0",
        fill: "transparent",
        fillRule: "evenodd",
        d: "m40.45 24-3.82-1.91-.3-.66L33.05 14H9v15h.55a4 4 0 0 1 6.9 0h15.1a4 4 0 0 1 6.9 0H41v-4.15a1 1 0 0 0-.55-.85zm-20-2H18v3h-3v-3h-3v-3h3v-3h3v3h3.5l-1.05 3zm11.42-6H27v6h7.54l-2.67-6z",
      }),
      a("path", {
        className: "at-0 ttcw-2",
        fill: "#002677",
        d: "M43 29.28v-4.43a3 3 0 0 0-1.65-2.68l-3.19-1.59-3.28-7.38a2 2 0 0 0-1.83-1.2H9a2 2 0 0 0-2 2v15.28A2 2 0 0 0 6 31h3a4 4 0 0 0 8 0h14a4 4 0 0 0 8 0h5a2 2 0 0 0-1-1.72z",
      }),
      a("path", {
        d: "M35 33a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-22 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
      }),
      a("path", {
        className: "at-0 ot-2 ttc-1",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M39 31h5a2 2 0 0 0-1-1.72v-4.43a3 3 0 0 0-1.7-2.69l-3.19-1.59-3.28-7.38A2 2 0 0 0 33 12h-1a2.5 2.5 0 0 0-5 0H9a2 2 0 0 0-2 2v15.28A2 2 0 0 0 6 31h3a4 4 0 0 0 8 0h14a4 4 0 0 0 8 0zm-26-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm24 2a2 2 0 1 0-4 0 2 2 0 0 0 4 0zm3.45-7.04a1 1 0 0 1 .55.89V29h-2.55a4 4 0 0 0-6.9 0h-15.1a4 4 0 0 0-6.9 0H9V14h24.05l3.28 7.39.3.66 3.82 1.91z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        d: "M27 22v-6h4.87l2.67 6H27z",
      }),
      a("path", {
        className: "at-1 ot-2 otc-0",
        fill: "#fff",
        d: "M21.5 19H18v-3h-3v3h-3v3h3v3h3v-3h2.5l1-3z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        d: "M29.5 9.5A2.5 2.5 0 0 0 27 12h5a2.5 2.5 0 0 0-2.5-2.5z",
      })
    );
  },
  X = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm35 11a4 4 0 0 0 4-4h5a1.994 1.994 0 0 0-1-1.723V24.85a2.992 2.992 0 0 0-1.654-2.672l-3.184-1.592-3.281-7.385a2 2 0 0 0-1.827-1.192H9a2 2 0 0 0-2 2v15.27A1.994 1.994 0 0 0 6 31h3a4 4 0 0 0 8 0h14a4 4 0 0 0 4 4z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M43 24.849v4.428A1.994 1.994 0 0 1 44 31h-5a4 4 0 0 1-8 0H17a4 4 0 0 1-8 0H6a1.994 1.994 0 0 1 1-1.723V14.012a2 2 0 0 1 2-2h24.054a2 2 0 0 1 1.827 1.188l3.281 7.381 3.184 1.592A2.992 2.992 0 0 1 43 24.849zM11 31a2 2 0 1 0 4 0 2 2 0 0 0-4 0zm5-11H9v-5.992h7V20zm2 0h7v-5.992h-7V20zm9 0v-5.992h6.053L35.716 20H27zm6 11a2 2 0 1 0 4 0 2 2 0 0 0-4 0z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M43 29.277v-4.428a2.99 2.99 0 0 0-1.654-2.676l-3.184-1.592-3.281-7.381a2 2 0 0 0-1.827-1.188H9a2 2 0 0 0-2 2v15.265A1.994 1.994 0 0 0 6 31h3a4 4 0 0 0 8 0h14a4 4 0 0 0 8 0h5a1.994 1.994 0 0 0-1-1.723z",
      }),
      a("path", {
        d: "M13 33a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm22 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        className: "at-2 ttcw-1 ot-0",
        fill: "#002677",
      }),
      a("path", {
        d: "M16 14.008H9V20h7v-5.992zm17.053 0H27V20h8.716l-2.663-5.992zm-8.053 0h-7V20h7v-5.992z",
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
      })
    );
  },
  Y = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm2.728 26.429h-8.8v9.716H13.07v-24.29h4.858v9.716h10.96l-2.159 4.858zm3.345 9.716h4.855l.003-24.29h-4.858v24.29z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M38 8H10a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zM26.728 26.429h-8.8v9.716H13.07v-24.29h4.858v9.716h10.96l-2.159 4.858zm3.345 9.716h4.855l.003-24.29h-4.858v24.29z",
      }),
      a("path", {
        className: "at-0 ttcw-2",
        fill: "#002677",
        d: "M38 8H10a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z",
      }),
      a("path", {
        d: "M17.927 11.855h-4.858v24.29h4.858v-9.716h8.8l2.16-4.858h-10.96v-9.716zm17.004 0h-4.858v24.29h4.858v-24.29z",
        className: "at-3 ot-0 otc-0",
        fill: "#00BED5",
      })
    );
  },
  aa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm4 33h-4v7L12.47 30A11 11 0 0 1 20 11h8c6.075 0 11 4.925 11 11s-4.925 11-11 11z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 11h8c6.075 0 11 4.925 11 11s-4.925 11-11 11h-4v7L12.48 30A11 11 0 0 1 20 11zm-2.51 16h12l1-2h-13v2zm12-4h-12v-2h13l-1 2zm-12-4h12l1-2h-13v2z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "M29.49 27h-12v-2h13.02l-1.02 2zm0-4h-12v-2h13.02l-1.02 2zm0-4h-12v-2h13.02l-1.02 2z",
      })
    );
  },
  la = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24 24-10.7 24-24S37.3 0 24 0zm-1.4 38-1-.2c-2-.3-3.8-1.1-5.4-2.2-.1.4-.4.8-.7 1.1-1.2 1.2-3.1 1.2-4.2 0-1.2-1.2-1.2-3.1 0-4.2.3-.3.7-.5 1.1-.7-1.1-1.6-1.8-3.5-2.2-5.5l-.2-1 2-.3.2 1c.8 5 4.8 9 9.8 9.8l1 .2-.4 2zM12.2 22c.8-5 4.8-9 9.8-9.8l1-.1-.3-2-1 .2c-2 .4-3.9 1.1-5.5 2.2-.2-.4-.4-.8-.7-1.1-1.1-1.2-3-1.2-4.2 0-1.2 1.1-1.2 3 0 4.2.3.3.7.6 1.1.7-1.1 1.6-1.9 3.4-2.2 5.4l-.2 1 2 .3.2-1zm25.6 4.3c-.3 2-1.1 3.8-2.2 5.4.4.1.8.4 1.1.7 1.2 1.2 1.2 3.1 0 4.2-1.2 1.2-3.1 1.2-4.2 0-.3-.3-.5-.7-.7-1.1-1.6 1.1-3.5 1.8-5.5 2.2l-1 .2L25 36l1-.2c5-.8 9-4.8 9.8-9.8l.2-1 2 .3-.2 1zm-2-4.3.2 1 1.9-.3-.2-1c-.4-2-1.1-3.9-2.2-5.5.4-.2.8-.4 1.1-.7 1.2-1.1 1.2-3 0-4.2-1.1-1.2-3-1.2-4.2 0-.3.3-.6.7-.7 1.1-1.6-1.1-3.4-1.9-5.4-2.2l-1-.2-.3 2 1 .2c5 .8 9 4.8 9.8 9.8z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "M35.8 26c-.8 5-4.8 9-9.8 9.8l-1 .2.3 2 1-.2c2-.3 3.8-1.1 5.5-2.2.1.4.4.8.7 1.1 1.2 1.2 3.1 1.2 4.2 0 1.2-1.2 1.2-3.1 0-4.2-.3-.3-.7-.5-1.1-.7 1.1-1.6 1.8-3.4 2.2-5.4l.2-1-2-.4-.2 1zm-23.6-4c.8-5 4.8-9 9.8-9.8l1-.2-.3-2-1 .2c-2 .3-3.8 1.1-5.5 2.2-.1-.4-.4-.8-.7-1.1-1.2-1.2-3.1-1.2-4.2 0-1.2 1.2-1.2 3.1 0 4.2.3.3.7.5 1.1.7-1.1 1.6-1.8 3.4-2.2 5.4l-.2 1 2 .3.2-.9z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M26 12.2c5 .8 9 4.8 9.8 9.8l.2 1 2-.3-.2-1c-.3-2-1.1-3.8-2.2-5.5.4-.1.8-.4 1.1-.7 1.2-1.2 1.2-3.1 0-4.2-1.2-1.2-3.1-1.2-4.2 0-.3.3-.5.7-.7 1.1-1.6-1.1-3.4-1.8-5.4-2.2l-1-.2-.4 2 1 .2zm-4 23.6c-5-.8-9-4.8-9.8-9.8l-.2-1-2 .3.2 1c.3 2 1.1 3.8 2.2 5.5-.4.1-.8.4-1.1.7-1.2 1.2-1.2 3.1 0 4.2 1.2 1.2 3.1 1.2 4.2 0 .3-.3.5-.7.7-1.1 1.6 1.1 3.4 1.8 5.4 2.2l1 .2.3-2-.9-.2z",
      })
    );
  },
  ta = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        cx: 24,
        cy: 24,
        r: 23.9,
      }),
      a("path", {
        className: "ot-0 otc-0 ttc-2",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M29.316 12.15A6.434 6.434 0 0 0 24.5 10a6.5 6.5 0 0 0-.05 13 7.135 7.135 0 0 0 3.166-.685l-.366-1.066a6.937 6.937 0 0 1-2.734.533 5.184 5.184 0 1 1 5.167-5.25c0 1.451-.717 2.484-1.7 2.484-.4 0-.567-.167-.567-.6v-3.433c0-1.35-.966-2.05-2.816-2.05a3.697 3.697 0 0 0-2.417.684c-.493.392-.78.987-.783 1.617h1.583c.117-.801.584-1.168 1.517-1.168.916 0 1.367.334 1.367 1.033 0 .518-.3.7-1.267.817a5.671 5.671 0 0 0-2.667.651 1.744 1.744 0 0 0-.783 1.567c0 1.265.9 2.016 2.433 2.016a2.81 2.81 0 0 0 2.434-1.1c.233.75.8 1.05 1.9 1.05.81.04 1.595-.291 2.132-.9a4.4 4.4 0 0 0 .95-2.8 6.634 6.634 0 0 0-1.683-4.25zM24 19c-.817 0-1.284-.35-1.284-.967 0-.717.55-1 2.367-1.2.28-.007.55-.107.767-.283v.433C25.85 18.366 25.266 19 24 19z",
      }),
      a("path", {
        className: "ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M24.357 2.916a.764.764 0 0 0-.982.004L8 15.922v22.079h32V15.922L24.357 2.916zM24 9.656a6.434 6.434 0 0 1 4.816 2.149 6.634 6.634 0 0 1 1.683 4.25 4.4 4.4 0 0 1-.95 2.8 2.668 2.668 0 0 1-2.133.899c-1.1 0-1.666-.3-1.9-1.05a2.809 2.809 0 0 1-2.433 1.1c-1.533 0-2.433-.75-2.433-2.016a1.743 1.743 0 0 1 .784-1.566 5.673 5.673 0 0 1 2.666-.652c.966-.116 1.267-.299 1.267-.816 0-.7-.45-1.033-1.367-1.033-.933 0-1.4.367-1.517 1.168H20.9c.002-.63.29-1.225.783-1.617a3.697 3.697 0 0 1 2.417-.684c1.85 0 2.816.7 2.816 2.05v3.433c0 .433.167.6.567.6.983 0 1.7-1.033 1.7-2.483a5.183 5.183 0 1 0-5.166 5.248 6.934 6.934 0 0 0 2.733-.533l.366 1.067a7.134 7.134 0 0 1-3.166.683A6.5 6.5 0 0 1 24 9.655zM10 36h28V17.614l-13.375 11.31a.765.765 0 0 1-.982.005L10 17.586V36z",
      }),
      a("path", {
        className: "ot-2",
        fill: "transparent",
        d: "M22.217 17.688c0 .617.466.966 1.283.966 1.267 0 1.85-.634 1.85-2.016v-.433a1.273 1.273 0 0 1-.767.283c-1.816.2-2.366.483-2.366 1.2z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm8-8.078V38h32V15.922l-15.643-13a.763.763 0 0 0-.982 0L8 15.922z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M23.642 28.928 10 16.851 23.875 5.116 38 16.86 24.634 28.915l-.01.008a.752.752 0 0 1-.458.175c-.011.006-.021.006-.032.006a.764.764 0 0 1-.492-.176zm6.857-12.878a6.635 6.635 0 0 0-1.683-4.25A6.434 6.434 0 0 0 24 9.65a6.5 6.5 0 0 0-.05 13 7.13 7.13 0 0 0 3.166-.684L26.75 20.9a6.947 6.947 0 0 1-2.733.537 5.183 5.183 0 1 1 5.166-5.249c0 1.45-.717 2.483-1.7 2.483-.4 0-.567-.168-.567-.6v-3.434c0-1.35-.966-2.05-2.816-2.05a3.7 3.7 0 0 0-2.417.684c-.492.393-.78.987-.783 1.617h1.583c.117-.801.584-1.168 1.517-1.168.916 0 1.367.333 1.367 1.033 0 .517-.301.701-1.267.817a5.679 5.679 0 0 0-2.667.648 1.743 1.743 0 0 0-.784 1.567c0 1.265.9 2.016 2.433 2.016a2.812 2.812 0 0 0 2.434-1.1c.234.749.8 1.049 1.9 1.049a2.67 2.67 0 0 0 2.133-.9 4.4 4.4 0 0 0 .95-2.8z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        d: "M22.217 17.687c0 .617.466.967 1.283.967 1.267 0 1.85-.634 1.85-2.017V16.2a1.275 1.275 0 0 1-.767.283c-1.816.204-2.366.487-2.366 1.204z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M10 36h28V17.613L24.791 28.784l-.166.15a.764.764 0 0 1-.981.003l-.16-.14L10 17.585V36z",
      })
    );
  },
  ca = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm11 26h-4v4h4v4h-4v4H10V15l5-5h16v4h-4v4h4v4h4v4zm0-8h4v-4h-4v4z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M27 22v-2H15v-2h8v-4h4v-2H15v3h-3v21h15v-2h4v-4h-4v-4h4v-4h-4zm-4.52 8H15v-2h8.5l-1.02 2zM15 25h12v-2H15v2z",
      }),
      a("path", {
        className: "otc-0 ttc-3",
        fill: "#002677",
        d: "M12 15h3v-3h12v2h4v-4H15l-5 5v23h17v-2H12V15z",
      }),
      a("path", {
        className: "at-0 ttc-1",
        fill: "transparent",
        d: "M27 26V10H15l-5 5v23h17v-8h4v-4h-4z",
      }),
      a("path", {
        className: "at-0 ttc-3",
        fill: "transparent",
        d: "m15 10-5 5h5v-5z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M27.02 18H27v-4h-4v4h-8v2h12v2h4v-4h-3.98zm0 5H15v2h12.02v-2zM15 30h7.48l1.02-2H15v2z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "M39 14h-4v4h4v-4z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M35 22h-4v4h4v-4z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "M31 26h-4v4h4v-4zm4 4h-4v4h4v-4z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M31 34h-4v4h4v-4z",
      })
    );
  },
  ha = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M38.49 13.02c1.94 1.94 3.01 4.53 3.01 7.28 0 2.74-1.07 5.33-3.01 7.27l-.73.73c.01.06.01.12.01.18 0 .63-.23 1.26-.71 1.73-.95.95-2.51.95-3.46 0 .95.95.95 2.51 0 3.46-.95.95-2.51.95-3.46 0 .95.95.95 2.51 0 3.46-.64.64-1.55.85-2.37.63-.11.46-.35.87-.69 1.21l-2.12 2.13c-.51.51-1.19.77-1.86.77-.67 0-1.35-.26-1.86-.77-.49-.5-.76-1.16-.76-1.86 0-.14.01-.28.04-.42-.14.02-.29.04-.43.04-.67 0-1.34-.26-1.86-.77-.62-.62-.86-1.48-.73-2.29-.13.03-.27.05-.42.05-.7 0-1.36-.28-1.86-.77-.62-.62-.86-1.48-.73-2.29-.13.03-.27.05-.42.05-.7 0-1.36-.28-1.86-.77-.49-.5-.76-1.16-.76-1.86 0-.4.09-.78.25-1.13l-1.86-1.86c-3.83-3.82-3.83-10.02 0-13.85 3.8-3.8 9.97-3.82 13.79-.05l.3-.3s.01 0 .01-.01l.06-.06h.01c1.93-1.9 4.48-2.94 7.2-2.94 2.75 0 5.33 1.07 7.28 3.01zM12.92 31.36c.39.39.96.53 1.48.42.31-.06.6-.2.82-.42l2.13-2.12c.63-.64.63-1.67 0-2.31-.32-.31-.74-.47-1.16-.47-.41 0-.83.16-1.15.47l-2.12 2.13c-.23.22-.37.5-.43.81-.03.11-.04.22-.04.34 0 .44.16.85.47 1.15zm3.01 3.01a1.62 1.62 0 0 1 0-2.3l2.12-2.12a1.63 1.63 0 0 1 2.31 0c.36.36.51.85.45 1.32-.02.35-.17.7-.45.98l-2.13 2.12c-.61.61-1.69.61-2.3 0zm3.01.71c-.63.63-.63 1.67 0 2.3.63.64 1.67.64 2.3 0l2.13-2.12c.26-.27.42-.61.45-.98.02-.06.02-.11.02-.17 0-.44-.17-.85-.47-1.15-.35-.35-.84-.5-1.31-.44-.37.02-.74.17-1 .44l-2.12 2.12zm7.9 2.2c-.03.37-.2.72-.46.99l-2.13 2.12c-.63.64-1.67.64-2.3 0-.31-.3-.47-.71-.47-1.15 0-.44.16-.85.47-1.15l2.12-2.13c.28-.27.63-.42.98-.45.06-.02.11-.02.17-.02.42 0 .84.16 1.16.47.3.31.47.72.47 1.16 0 .05 0 .11-.01.16zm10.22-10.53c.15.14.27.3.37.47l.35-.35c3.62-3.63 3.62-9.52 0-13.14a9.22 9.22 0 0 0-6.57-2.72c-2.48 0-4.81.96-6.57 2.71l-.3.31-7.45 7.45a3.984 3.984 0 0 0 5.24-.33l4.66-4.67 10.27 10.27z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24zm37.76 4.3.73-.73c1.94-1.94 3.01-4.53 3.01-7.27 0-2.75-1.07-5.34-3.01-7.28a10.251 10.251 0 0 0-7.28-3.01c-2.72 0-5.27 1.04-7.2 2.94H24l-.06.06c0 .01-.01.01-.01.01l-.3.3c-3.82-3.77-9.99-3.75-13.79.05-3.83 3.83-3.83 10.03 0 13.85l1.86 1.86c-.16.35-.25.73-.25 1.13 0 .7.27 1.36.76 1.86.5.49 1.16.77 1.86.77.15 0 .29-.02.42-.05-.13.81.11 1.67.73 2.29.5.49 1.16.77 1.86.77.15 0 .29-.02.42-.05-.13.81.11 1.67.73 2.29.52.51 1.19.77 1.86.77.14 0 .29-.02.43-.04-.03.14-.04.28-.04.42 0 .7.27 1.36.76 1.86.51.51 1.19.77 1.86.77.67 0 1.35-.26 1.86-.77l2.12-2.13c.34-.34.58-.75.69-1.21.82.22 1.73.01 2.37-.63.95-.95.95-2.51 0-3.46.95.95 2.51.95 3.46 0 .95-.95.95-2.51 0-3.46.95.95 2.51.95 3.46 0 .48-.47.71-1.1.71-1.73 0-.06 0-.12-.01-.18z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        d: "M37.78 13.73a9.22 9.22 0 0 0-6.57-2.72c-2.48 0-4.81.96-6.57 2.71l-.3.31-7.45 7.45a3.984 3.984 0 0 0 5.24-.33l4.66-4.67 10.27 10.27c.15.14.27.3.37.47l.35-.35c3.62-3.63 3.62-9.52 0-13.14zM25.22 35.49c-.06 0-.11 0-.17.02-.35.03-.7.18-.98.45l-2.12 2.13c-.31.3-.47.71-.47 1.15 0 .44.16.85.47 1.15.63.64 1.67.64 2.3 0l2.13-2.12c.26-.27.43-.62.46-.99.01-.05.01-.11.01-.16 0-.44-.17-.85-.47-1.16-.32-.31-.74-.47-1.16-.47zm-4.41-4.22c.06-.47-.09-.96-.45-1.32a1.63 1.63 0 0 0-2.31 0l-2.12 2.12a1.62 1.62 0 0 0 0 2.3c.61.61 1.69.61 2.3 0l2.13-2.12c.28-.28.43-.63.45-.98zm3.01 3.01c.02-.06.02-.11.02-.17 0-.44-.17-.85-.47-1.15-.35-.35-.84-.5-1.31-.44-.37.02-.74.17-1 .44l-2.12 2.12c-.63.63-.63 1.67 0 2.3.63.64 1.67.64 2.3 0l2.13-2.12c.26-.27.42-.61.45-.98zm-6.47-7.35c-.32-.31-.74-.47-1.16-.47-.41 0-.83.16-1.15.47l-2.12 2.13c-.23.22-.37.5-.43.81-.03.11-.04.22-.04.34 0 .44.16.85.47 1.15.39.39.96.53 1.48.42.31-.06.6-.2.82-.42l2.13-2.12c.63-.64.63-1.67 0-2.31z",
      }),
      a("path", {
        className: "ot-0 otc-0",
        fill: "#00BED5",
        d: "M37.65 27.71c-.11-.36-.31-.68-.59-.96L23.68 13.37c-3.82-3.82-10.02-3.82-13.84 0-3.83 3.83-3.83 10.03 0 13.85l2.25 2.25c.1-.28.26-.54.48-.77l2.12-2.12a2.13 2.13 0 0 1 3.01 0c.83.83.83 2.18 0 3.01a2.13 2.13 0 0 1 3.01 0c.83.83.83 2.18 0 3.01a2.13 2.13 0 0 1 3.01 0c.83.83.83 2.18 0 3.01a2.13 2.13 0 0 1 3.01 0c.53.53.72 1.28.56 1.97.92.46 2.08.31 2.85-.45.95-.95.95-2.51 0-3.46.95.95 2.51.95 3.46 0 .95-.95.95-2.51 0-3.46.95.95 2.51.95 3.46 0 .48-.47.71-1.1.71-1.73 0-.26-.04-.52-.12-.77z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M38.13 13.37c-3.798-3.798-9.945-3.816-13.77-.063l-.004-.004-8.197 8.197a4.483 4.483 0 0 0 6.321 0l4.665-4.665 9.915 9.915c.28.28.48.6.59.96l.48-.49c3.83-3.82 3.83-10.02 0-13.85zM27.29 37.58c-.08.38-.27.74-.56 1.04l-2.12 2.12c-.83.83-2.19.83-3.01 0a2.13 2.13 0 0 1 0-3.01c-.83.83-2.19.83-3.01 0a2.13 2.13 0 0 1 0-3.01c-.83.83-2.19.83-3.01 0a2.13 2.13 0 0 1 0-3.01c-.83.83-2.19.83-3.01 0a2.09 2.09 0 0 1-.48-2.24c.1-.28.26-.54.48-.77l2.12-2.12a2.13 2.13 0 0 1 3.01 0c.83.83.83 2.18 0 3.01a2.13 2.13 0 0 1 3.01 0c.83.83.83 2.18 0 3.01a2.13 2.13 0 0 1 3.01 0c.83.83.83 2.18 0 3.01a2.13 2.13 0 0 1 3.01 0c.53.53.72 1.28.56 1.97z",
      })
    );
  },
  sa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24zm-15.136-3.233c-.655-4.098-4.072-7.333-8.197-7.797a9.847 9.847 0 0 0-2.182 0c-4.124.464-7.542 3.699-8.198 7.797-.498 3.11.532 5.995 2.455 8.024l.286.3c1.329 1.394 1.835 1.924 2.128 4.087l.162 2.339h8.516l.162-2.34c.294-2.162.8-2.692 2.128-4.086l.286-.3c1.923-2.03 2.952-4.913 2.454-8.024zM19.31 39.876h8.529v-3.045H19.31v3.045zm.003 1.314v.208c0 1.602 1.028 2.911 2.285 2.911h3.959c1.256 0 2.284-1.309 2.284-2.91v-.209h-8.528zm11.78-28.329 4.327-4.024 3.168.96-5.533 5.155-1.961-2.09zm-8.949-8.31v6.131h2.867V2.896l-2.867 1.655zm-8.21 10.885L9.36 11.615l.573-3.26 5.842 4.884-1.842 2.197z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1 ttcw-2",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.667 12.97c4.125.463 7.542 3.699 8.197 7.796.498 3.112-.53 5.996-2.454 8.025l-.286.3c-1.328 1.394-1.834 1.924-2.128 4.087l-.162 2.339h-8.516l-.162-2.34c-.293-2.162-.8-2.692-2.128-4.086l-.286-.3c-1.923-2.03-2.953-4.913-2.455-8.024.656-4.098 4.074-7.333 8.198-7.797a9.847 9.847 0 0 1 2.182 0zm-.79 4.107v-1.775c3.945 0 6.789 2.929 6.789 6.542l-1.701-.763c-.407-2.27-2.721-4.004-5.088-4.004z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
        d: "M27.838 39.876h-8.529v-3.045h8.529v3.045zm-8.526 1.314v.208c0 1.602 1.028 2.911 2.285 2.911h3.959c1.256 0 2.284-1.309 2.284-2.91v-.209h-8.528z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        d: "m35.419 8.837-4.326 4.024 1.96 2.091 5.534-5.156-3.168-.959zM22.143 4.551v6.131h2.867V2.896l-2.867 1.655zM9.36 11.615l4.573 3.82 1.842-2.196-5.842-4.884-.573 3.26z",
      }),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        d: "M23.877 15.302v1.775c2.367 0 4.681 1.735 5.088 4.004l1.701.763c0-3.613-2.844-6.542-6.789-6.542z",
      })
    );
  },
  ea = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zM10 33V17.657l12.844 11.134c.665.57 1.646.57 2.311 0L38 17.657V33H10zm14-5.854L38 15.01V15H10v.01l14 12.136z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-3",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 13v22h32V13H8zm30 2v.01L24 27.146 10 15.01V15h28zm-28 2.657V33h28V17.657L25.155 28.791c-.665.57-1.646.57-2.311 0L10 17.657z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M38 15v.01L24 27.146 10 15.01V15h28z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M38 33H10V17.657l12.844 11.134c.665.57 1.646.57 2.311 0L38 17.657V33z",
      })
    );
  },
  va = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm-1.849 16.886.143-.003A8.792 8.792 0 0 1 31.107 26h-2a6.817 6.817 0 0 0-6.816-7.117c-.1 0-.193 0-.29.009L22 16.89c.05 0 .102-.002.151-.004zm8.232 22.891a17.765 17.765 0 0 0 2.359-3.22 2.406 2.406 0 0 0-.626-3.153l-3.465-2.6a2.411 2.411 0 0 0-3.151.223l-2.788 2.785A14.263 14.263 0 0 1 17.6 30.4a14.264 14.264 0 0 1-3.408-5.11l2.783-2.784a2.41 2.41 0 0 0 .224-3.151l-2.6-3.465a2.4 2.4 0 0 0-3.153-.63 17.738 17.738 0 0 0-3.221 2.358l-.051.051a5.239 5.239 0 0 0-.9 5.3 26.009 26.009 0 0 0 6.919 10.841 26.01 26.01 0 0 0 10.839 6.918 5.237 5.237 0 0 0 5.3-.9l.051-.051zM33.913 26A11.583 11.583 0 0 0 22.3 14.078c-.1 0-.2 0-.3.005v-2.007h.3A13.58 13.58 0 0 1 35.92 26h-2.007zm.024-11.937A16.513 16.513 0 0 1 38.729 26h2.008A18.383 18.383 0 0 0 22.3 7.259H22v2.004h.3a16.347 16.347 0 0 1 11.637 4.8z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "M28.647 30.8a2.41 2.41 0 0 0-3.151.224l-2.784 2.783A14.264 14.264 0 0 1 17.6 30.4a14.264 14.264 0 0 1-3.412-5.111l2.784-2.789a2.41 2.41 0 0 0 .224-3.151l-2.6-3.465a2.4 2.4 0 0 0-3.153-.63 17.703 17.703 0 0 0-3.221 2.359l-.051.051a5.237 5.237 0 0 0-.9 5.3 26.008 26.008 0 0 0 6.918 10.839 26.007 26.007 0 0 0 10.839 6.918 5.237 5.237 0 0 0 5.3-.9l.051-.051a17.7 17.7 0 0 0 2.359-3.221 2.4 2.4 0 0 0-.63-3.153L28.647 30.8z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M35.359 12.641A18.346 18.346 0 0 0 22.3 7.255H22v2.012h.3A16.38 16.38 0 0 1 38.728 26h2.009a18.285 18.285 0 0 0-5.378-13.359z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M22.3 12.072H22v2.007c.1 0 .2-.005.3-.005A11.583 11.583 0 0 1 33.913 26h2.007A13.579 13.579 0 0 0 22.3 12.072z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M22.3 16.883c-.1 0-.2 0-.294.007v2c.1 0 .193-.008.29-.008A6.817 6.817 0 0 1 29.106 26h2a8.792 8.792 0 0 0-8.813-9.117h.007z",
      })
    );
  },
  oa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M48 24.004c0 13.254-10.746 24-24 24s-24-10.746-24-24 10.746-24 24-24 24 10.746 24 24zM27.238 36.258l-6.527 2.636.004 2.833c.11 2.347 2.156 3.023 2.156 3.023.961.367 1.844.324 2.676-.102 0 0 1.59-.636 1.691-2.789v-5.601zM12.61 9.652c2.512-3.672 6.696-5.668 11.782-5.668 8.05 0 13.398 4.77 13.398 11.98 0 4.509-1.484 6.95-6.957 11.524-2.004 1.559-3.004 3.012-3.445 5.196l-6.711 2.714c.152-6.496.832-7.77 6.422-12.738 2.511-2.383 3.414-4.12 3.414-6.695 0-3.735-2.45-6.121-6.184-6.121-4.637 0-6.953 2.77-7.277 8.629h-6.89c.19-3.989.902-6.5 2.448-8.82z",
      }),
      a("path", {
        className: "otc-0 ot-2 ttc-1",
        fill: "#00BED5",
        d: "m27.24 36.257-6.53 2.639.005 2.83c.11 2.35 2.156 3.025 2.156 3.025.962.367 1.844.324 2.676-.103 0 0 1.588-.638 1.693-2.787v-5.604z",
      }),
      a("path", {
        className: "otc-0 ttc-3",
        fill: "#002677",
        d: "M24.392 3.986c-5.086 0-9.271 1.993-11.783 5.668-1.547 2.318-2.255 4.83-2.45 8.82h6.892c.325-5.862 2.642-8.631 7.278-8.631 3.734 0 6.182 2.386 6.182 6.12 0 2.575-.901 4.315-3.413 6.696-5.59 4.97-6.27 6.243-6.423 12.738l6.713-2.713c.439-2.184 1.442-3.637 3.443-5.196 5.475-4.572 6.958-7.016 6.958-11.525 0-7.21-5.348-11.977-13.397-11.977z",
      })
    );
  },
  fa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        d: "M24 0a24 24 0 1 0 0 48 24 24 0 0 0 0-48zm6 31a2 2 0 0 1-2 2h-8v6l-6.93-6H10a2 2 0 0 1-2-2V15a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v16zm10-2a1 1 0 0 1-1.41.91L32 27v-7.9l6.59-2.94A1 1 0 0 1 40 17v12z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M38.59 16.13 32 19.07V27l6.59 2.94A1 1 0 0 0 40 29V17a1 1 0 0 0-1.41-.87z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "M28 13H10a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h3.07L20 39v-6h8a2 2 0 0 0 2-2V15a2 2 0 0 0-2-2z",
      })
    );
  },
  na = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24zm24 17.7V37c8.01 0 14.5-6.49 14.5-14.5 0-5.678-3.27-10.579-8.022-12.959-.088-.044-.177-.086-.266-.128a14.389 14.389 0 0 0-1.128-.478l-.07-.026a12.006 12.006 0 0 0-.433-.158 14.252 14.252 0 0 0-1.364-.38 8.738 8.738 0 0 0-.425-.096 14.031 14.031 0 0 0-1.49-.209C24.872 8.027 24.44 8 24 8c-.44 0-.872.027-1.302.066a14.49 14.49 0 0 0-1.49.209 4.96 4.96 0 0 0-.28.063c-.049.01-.097.022-.145.033a14.622 14.622 0 0 0-1.364.38c-.146.05-.29.103-.433.158l-.07.026c-.385.144-.76.303-1.128.478-.089.042-.178.084-.266.128C12.769 11.921 9.5 16.822 9.5 22.5c0 4.42 1.97 8.37 5.09 11.02L24 41.7z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m24 17.123 6.466-6.467C34.653 12.952 37.5 17.401 37.5 22.5 37.5 29.94 31.44 36 24 36c-.34 0-.67-.01-1-.04v3.55l-7.72-6.73A13.404 13.404 0 0 1 10.5 22.5c0-5.099 2.847-9.548 7.034-11.844L24 17.123zm-6.187 4.689h1.75l.875-2.624h-2.625V17h-2.625v2.187H13v2.625h2.188V24h2.625v-2.188z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00bed5",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38.433 21.183a14.483 14.483 0 0 0-.216-1.523l-.009-.05-.008-.05a14.377 14.377 0 0 0-.426-1.571 14.313 14.313 0 0 0-.336-.917l-.043-.107a9.286 9.286 0 0 0-.095-.231 14.68 14.68 0 0 0-.701-1.391 14.482 14.482 0 0 0-.37-.608 14.265 14.265 0 0 0-.474-.698 14.557 14.557 0 0 0-.396-.529 15.31 15.31 0 0 0-.737-.852 14.776 14.776 0 0 0-1.06-1.035 13.558 13.558 0 0 0-.905-.73l-.041-.031a14.414 14.414 0 0 0-17.234-.002l-.04.03c-.064.047-.128.094-.191.143-.211.163-.418.329-.619.502l-.091.082a14.776 14.776 0 0 0-1.065 1.039c-.103.111-.206.222-.305.336-.148.169-.292.34-.432.516-.121.152-.236.31-.35.467l-.046.062c-.164.228-.323.46-.474.698a14.482 14.482 0 0 0-1.071 1.999c-.033.077-.064.155-.095.232l-.043.106a14.538 14.538 0 0 0-.455 1.295c-.117.392-.223.788-.307 1.193l-.01.06a14.417 14.417 0 0 0-.223 1.564c-.038.435-.065.873-.065 1.318 0 .529.032 1.05.087 1.564.01.1.027.196.043.293l.029.176c.05.355.103.708.178 1.054.024.11.053.22.083.328l.047.178c.084.328.172.653.278.972.041.125.088.247.134.37l.039.102c.12.322.246.64.388.95.064.14.131.277.199.414a14.383 14.383 0 0 0 1.372 2.241l.062.083c.04.056.081.111.124.166a14.518 14.518 0 0 0 .895 1.044l.065.072c.34.355.695.694 1.069 1.014l.003.003-.048-.006L24 41.7V37c8.008 0 14.5-6.492 14.5-14.5 0-.445-.027-.883-.067-1.317zm-7.965-10.528L24 17.123l-6.468-6.468A13.412 13.412 0 0 1 24 9c2.342 0 4.546.601 6.468 1.655zM17.813 21.812h1.75l.875-2.624h-2.625V17h-2.625v2.187H13v2.625h2.188V24h2.625v-2.188z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M31.21 9.92 24 17.12l-7.21-7.2C18.91 8.7 21.38 8 24 8s5.09.7 7.21 1.92z",
      }),
      a("path", {
        className: "at-1 ot-0 otc-0",
        fill: "#fff",
        d: "M19.563 21.812h-1.75V24h-2.625v-2.188H13v-2.624h2.188V17h2.625v2.188h2.625l-.875 2.624z",
      })
    );
  },
  ia = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30 30h-4V11.514l-1 .4V8H14v19a11.985 11.985 0 0 0 11.992 11.984L26 39h4a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zM16 10h7v2.729l-7 2.834V10zm10 27h4v-5h-4v5z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm13.7 29.675-.127 1.111-4.229 1.539-.344-.94 4.7-1.71zM30 39a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-4V11.518l-1 .4V8H14v19a11.985 11.985 0 0 0 11.992 11.984L26 39h4zm7.229.325L33 37.786l.342-.94 4.7 1.71-.813.769zM34 35h4.5l.5-1h-5v1z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        d: "M30 32h-4v5h4v-5zM16 15.563l7-2.834V10h-7v5.563z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "M34 34v1h4.5l.5-1h-5zm-1 3.786 4.229 1.539.812-.77-4.699-1.71-.342.94zm4.571-7 .127-1.111L33 31.385l.342.94 4.229-1.539z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M30 30h-4V11.514l-12 4.86V27a11.984 11.984 0 0 0 11.992 11.984L26 39h4a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2z",
      }),
      a("path", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        d: "M30 37h-4v-5h4v5z",
      }),
      a("path", {
        className: "ot-0 otc-0",
        fill: "#00BED5",
        d: "M25 8H14v8.389l11-4.454V8z",
      })
    );
  },
  ma = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#FFF",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zM26.74 6.17a4.27 4.27 0 0 1-2.56 2.56.29.29 0 0 0 0 .53 4.31 4.31 0 0 1 2.56 2.57.29.29 0 0 0 .53 0 4.35 4.35 0 0 1 2.57-2.57.29.29 0 0 0 0-.53 4.31 4.31 0 0 1-2.57-2.56.29.29 0 0 0-.53 0zm-6.56-.36a2.84 2.84 0 0 0 1.69-1.68.18.18 0 0 1 .34 0 2.84 2.84 0 0 0 1.69 1.68.19.19 0 0 1 0 .35 2.88 2.88 0 0 0-1.69 1.69.18.18 0 0 1-.34 0 2.88 2.88 0 0 0-1.69-1.69.19.19 0 0 1-.02-.35h.02zM36.54 32H40a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9l4.75 4.74-.37.75-4.13-4.13A1.591 1.591 0 0 0 15 35.61l5.59 5.63A9.54 9.54 0 0 0 36.54 32z",
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        d: "M40 15H8a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8l-4.38-4.39a1.58 1.58 0 0 1 0-2.25 1.59 1.59 0 0 1 2.25 0l6.6 6.64h.23l.45-.45-8.44-8.44A1.605 1.605 0 1 1 15 19.86l8.4 8.44.56-.56L17.21 21a1.591 1.591 0 0 1 2.25-2.25l6.75 6.75.56-.57-3.37-3.38a1.591 1.591 0 0 1 2.25-2.25l8.43 8.44A9.56 9.56 0 0 1 36.22 31H40a1 1 0 0 0 1-1V16a1 1 0 0 0-1-1z",
      }),
      a("path", {
        className: "ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 14h32a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3.37a9.54 9.54 0 0 1-16 9.24L15 35.61a1.59 1.59 0 0 1 2.24-2.25l4.13 4.13.37-.75L17 32H8a2 2 0 0 1-2-2V16a2 2 0 0 1 2-2zm32 17a1 1 0 0 0 1-1V16a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h8l-4.41-4.39a1.58 1.58 0 0 1 0-2.25 1.59 1.59 0 0 1 2.25 0L20.47 31h.23l.49-.45-8.44-8.44A1.591 1.591 0 0 1 15 19.86l8.44 8.44.56-.56L17.21 21a1.595 1.595 0 0 1 2.25-2.26l6.75 6.75.56-.57-3.37-3.37a1.591 1.591 0 0 1 2.25-2.25l8.43 8.44A9.562 9.562 0 0 1 36.22 31H40z",
      }),
      a("path", {
        className: "ot-0 otc-0",
        fill: "#00BED5",
        d: "M6 16v14a2 2 0 0 0 2 2h32a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2z",
      }),
      a("path", {
        className: "ot-0 otc-0 ttc-1",
        fill: "#002677",
        d: "M23.4 19.3a1.59 1.59 0 0 0 0 2.25l3.37 3.37-.56.57-6.75-6.75A1.595 1.595 0 0 0 17.21 21L24 27.74l-.56.56L15 19.86a1.591 1.591 0 0 0-2.25 2.25l8.44 8.44-.56.56-6.75-6.75a1.59 1.59 0 0 0-2.25 0 1.58 1.58 0 0 0 0 2.25l10.08 10.13-.37.75-4.13-4.13A1.59 1.59 0 0 0 15 35.61l5.63 5.63a9.543 9.543 0 0 0 13.49-13.5l-8.47-8.44a1.59 1.59 0 0 0-2.25 0z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1",
        fill: "#002677",
        d: "M29.84 9.26a4.35 4.35 0 0 0-2.57 2.57.29.29 0 0 1-.53 0 4.31 4.31 0 0 0-2.56-2.57.29.29 0 0 1 0-.53 4.27 4.27 0 0 0 2.56-2.56.29.29 0 0 1 .53 0 4.31 4.31 0 0 0 2.57 2.56.29.29 0 0 1 0 .53zm-5.96-3.1a2.88 2.88 0 0 0-1.69 1.69.18.18 0 0 1-.34 0 2.88 2.88 0 0 0-1.69-1.69.19.19 0 0 1 0-.35 2.84 2.84 0 0 0 1.69-1.68.18.18 0 0 1 .34 0 2.84 2.84 0 0 0 1.69 1.68.19.19 0 0 1 0 .35z",
      })
    );
  },
  za = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#FFF",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 31h24V17H12v14zm4-8.5v-2h16l-1.15 2H16zm14.85 5 1.15-2H16v2h14.85z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm14 30v3H10v-3a6 6 0 0 1 0-12v-3h28v3a6 6 0 0 1 0 12z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M38 15v3a6 6 0 0 1 0 12v3H10v-3a6 6 0 0 1 0-12v-3h28zM6 24a4 4 0 0 0 4 4v-8a4 4 0 0 0-4 4zm30 7H12V17h24v14zm6-7a4 4 0 0 0-4-4v8a4 4 0 0 0 4-4z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M10 28a4 4 0 0 1 0-8v8zm28 0v-8a4 4 0 0 1 0 8z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M30.85 22.5H16v-2h16l-1.15 2zm0 5H16v-2h16l-1.15 2z",
      })
    );
  },
  da = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "ot-0 otc-2 ttc-2",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm11.05 13h6.7l-1.93-1.94L20 30.88l-2.86-2.86-4.19 4.18-1.9-1.9V37zm6.09-17L13 15.83l-1.92 1.91v-6.69h6.7l-2 1.95L20 17.16 17.14 20zm3.27 4.17c0 3.04 1.37 4.83 3.73 4.83h.01a3.34 3.34 0 0 0 3.43-3.46 3 3 0 0 0-3.06-3.22 2.47 2.47 0 0 0-2.18 1.09 5.42 5.42 0 0 1 .31-1.6c.32-.87.81-1.3 1.55-1.3a1.26 1.26 0 0 1 1.31 1.11h1.9A2.94 2.94 0 0 0 24.23 19c-2.37 0-3.81 2-3.82 5.17zM30.28 11H37v6.7l-1.93-1.94L30.85 20 28 17.16l4.2-4.2L30.28 11zm.02 26H37v-6.66l-1.96 1.92-4.21-4.21L28 30.88l4.3 4.17-2 1.95z",
      }),
      a("path", {
        className: "ot-2 otc-2",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 8h28a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2zm1.05 29h6.7l-1.93-1.94L20 30.88l-2.86-2.86-4.19 4.18-1.9-1.9V37zm6.09-17L13 15.83l-1.92 1.91v-6.69h6.7l-2 1.95L20 17.16 17.14 20zm3.27 4.17c0 3.04 1.37 4.83 3.73 4.83h.01a3.34 3.34 0 0 0 3.43-3.46 3 3 0 0 0-3.06-3.22 2.47 2.47 0 0 0-2.18 1.09 5.42 5.42 0 0 1 .31-1.6c.32-.87.81-1.3 1.55-1.3a1.26 1.26 0 0 1 1.31 1.11h1.9A2.94 2.94 0 0 0 24.23 19c-2.37 0-3.81 2-3.82 5.17zM30.28 11H37v6.7l-1.93-1.94L30.85 20 28 17.16l4.2-4.2L30.28 11zm.02 26H37v-6.66l-1.96 1.92-4.21-4.21L28 30.88l4.3 4.17-2 1.95z",
      }),
      a("path", {
        className: "ot-0 otc-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M17.76 11.05h-6.7v6.7l1.92-1.92 4.16 4.16 2.83-2.83L15.81 13l1.95-1.95zm17.31 21.21-4.21-4.21-2.83 2.83 4.21 4.21-1.95 1.95h6.69v-6.7l-1.91 1.92zm-4.22-12.27 4.2-4.2 1.93 1.94v-6.7h-6.69l1.93 1.93-4.2 4.2 2.83 2.83zm-13.71 8.06-4.19 4.18-1.9-1.9v6.7h6.7l-1.97-1.97 4.18-4.18-2.82-2.83z",
      }),
      a("path", {
        className: "ot-0 otc-0",
        fill: "#fff",
        d: "M25.51 21.62a1.26 1.26 0 0 0-1.31-1.11c-.74 0-1.23.43-1.55 1.3a5.422 5.422 0 0 0-.31 1.6 2.47 2.47 0 0 1 2.18-1.09 3 3 0 0 1 3.06 3.22A3.34 3.34 0 0 1 24.15 29c-2.36 0-3.73-1.79-3.73-4.83 0-3.17 1.44-5.17 3.81-5.17a2.94 2.94 0 0 1 3.18 2.62h-1.9z",
      }),
      a("path", {
        className: "at-2",
        fill: "#002677",
        d: "M22.51 25.62a1.63 1.63 0 0 0 1.54 1.79 1.65 1.65 0 0 0 1.56-1.79 1.65 1.65 0 0 0-1.54-1.79 1.62 1.62 0 0 0-1.54 1.76l-.02.03z",
      })
    );
  },
  pa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "ot-0 otc-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 23.9,
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm37.99-5.362a2.4 2.4 0 0 0 1.2-2.078c0-1.9-2.4-5.6-2.4-5.6s-2.4 3.7-2.4 5.6a2.4 2.4 0 0 0 3.6 2.078zM32 5.12s2.4 3.7 2.4 5.6a2.4 2.4 0 1 1-4.8 0c-.01-1.9 2.4-5.6 2.4-5.6zM26 30h15a2 2 0 1 0 0-4H26v-1h12a2 2 0 1 0 0-4H20l-.35-1H27a2 2 0 1 0 0-4H17c-6.627 0-12 5.373-12 12s5.373 12 12 12h15a2 2 0 1 0 0-4h-6v-1h12a2 2 0 1 0 0-4H26v-1z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "M41 25.95H26v-1h12a2 2 0 1 0 0-4H20l-.35-1H27a2 2 0 1 0 0-4H17c-6.627 0-12 5.373-12 12 0 6.628 5.373 12 12 12h15a2 2 0 1 0 0-4h-6v-1h12a2 2 0 1 0 0-4H26v-1h15a2 2 0 1 0 0-4z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M36.79 11s-2.4 3.7-2.4 5.6a2.4 2.4 0 1 0 4.8 0c0-1.9-2.4-5.6-2.4-5.6zM32 5.17s-2.4 3.7-2.4 5.6a2.4 2.4 0 1 0 4.8 0c-.01-1.9-2.4-5.6-2.4-5.6z",
      })
    );
  },
  wa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm0 6.026a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm-4.32 4.687-.93-1.787v.003A15.837 15.837 0 0 0 8.141 26.035l2.007-.089a13.855 13.855 0 0 1 9.532-15.233zm-7.173 22.413a3 3 0 1 1-2.995-5.199 3 3 0 0 1 2.995 5.199zm.64 2.624A15.922 15.922 0 0 0 24 40.026a15.922 15.922 0 0 0 10.852-4.276l-1.09-1.708c-5.424 5.312-14.1 5.312-19.524 0l-1.09 1.708zm26.444-3.724a3 3 0 1 1-5.196-3.007 3 3 0 0 1 5.196 3.01v-.003zm-1.739-6.08 2.007.089v.003A15.837 15.837 0 0 0 29.25 8.929l-.93 1.787a13.855 13.855 0 0 1 9.532 15.23z",
      }),
      a("path", {
        className: "otc-0 ttc-3",
        fill: "#002677",
        d: "M28.32 10.716a13.855 13.855 0 0 1 9.532 15.233l2.007.089a15.837 15.837 0 0 0-10.61-17.109l-.93 1.787zM10.148 25.949a13.855 13.855 0 0 1 9.532-15.233l-.93-1.787A15.837 15.837 0 0 0 8.141 26.038l2.007-.089zm23.614 8.093c-5.424 5.312-14.1 5.312-19.524 0l-1.09 1.708c6.11 5.699 15.589 5.699 21.7 0l-1.086-1.708z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1",
        fill: "#00BED5",
        d: "M24 12.026a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM9.507 27.931a3 3 0 1 0 3.001 5.195 3 3 0 0 0-3.001-5.195zm28.986 0a3 3 0 1 0-2.996 5.199 3 3 0 0 0 2.996-5.199z",
      })
    );
  },
  Ma = function (l) {
    return a(
      "svg",
      Object.assign(
        { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" },
        l
      ),
      a("circle", {
        className: "at-0 otc-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M24 0C10.75 0 0 10.75 0 24s10.75 24 24 24 24-10.75 24-24S37.25 0 24 0zm-1 4 2-1v7h-2V4zM9.86 8.44l4.95 4.95-1.41 1.41-4.24-4.24.7-2.12zM4 25l-1-2h7v2H4zm6.57 13.85-2.12-.71 4.95-4.95 1.41 1.41-4.24 4.25zm21.92-6.36c-4.69 4.69-12.28 4.69-16.97 0-4.69-4.69-4.69-12.28 0-16.97 4.69-4.69 12.28-4.69 16.97 0 4.68 4.68 4.68 12.28 0 16.97zm2.12-17.68L33.2 13.4l4.24-4.24 2.12.71-4.95 4.94z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M16.93 31.07c3.9 3.9 10.24 3.9 14.14 0 3.9-3.9 3.9-10.24 0-14.14L16.93 31.07z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1 ttcw-3",
        fill: "#00bed5",
        d: "m25 3-2 1v6h2zM14.81 13.39 9.86 8.44l-.71 2.12 4.24 4.25zM10 23H3l1 2h6zM8.44 38.14l2.13.71 4.24-4.24-1.42-1.42zM39.56 9.86l-2.13-.71-4.24 4.24 1.42 1.42z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        d: "M32.49 32.49c4.69-4.69 4.69-12.28 0-16.97L15.51 32.49c4.69 4.68 12.29 4.68 16.98 0z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00bed5",
        d: "M15.51 15.51c-4.69 4.69-4.69 12.28 0 16.97l16.97-16.97c-4.68-4.68-12.28-4.68-16.97 0z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        d: "M15.51 15.51c-4.69 4.69-4.69 12.28 0 16.97 4.69 4.69 12.28 4.69 16.97 0 4.69-4.69 4.69-12.28 0-16.97-4.68-4.68-12.28-4.68-16.97 0zm1.42 15.56c-3.9-3.9-3.9-10.24 0-14.14 3.9-3.9 10.24-3.9 14.14 0L16.93 31.07z",
      })
    );
  },
  ra = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm31 10h9a2 2 0 0 0 2-2V13a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v19a2 2 0 0 0 2 2h9v3a2 2 0 0 0-2 2h18a2 2 0 0 0-2-2v-3z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M40 11H8a2 2 0 0 0-2 2v19a2 2 0 0 0 2 2h9v3a2 2 0 0 0-2 2h18a2 2 0 0 0-2-2v-3h9a2 2 0 0 0 2-2V13a2 2 0 0 0-2-2zM8 13h28.8L8 26.09V13zm0 19h32v-3H8v3z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M40 11H8a2 2 0 0 0-2 2v19a2 2 0 0 0 2 2h9v3a2 2 0 0 0-2 2h18a2 2 0 0 0-2-2v-3h9a2 2 0 0 0 2-2V13a2 2 0 0 0-2-2z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M8 29h32v3H8v-3z",
      }),
      a("path", {
        className: "at-2",
        fill: "#002677",
        d: "M8 26.091V28h32V13h-3.2L8 26.091z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-0",
        fill: "#00BED5",
        d: "M8 13v13l29-13H8z",
      })
    );
  },
  Na = function (l) {
    return a(
      "svg",
      Object.assign(
        { viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" },
        l
      ),
      a("circle", {
        className: "at-0 otc-0 ttc-2 ttcw-1",
        fill: "#FFF",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "ot-0 otc-0",
        fill: "#00bed5",
        d: "M18 19h18v18H18z",
      }),
      a("path", {
        className: "at- otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm38 13a2 2 0 0 1-2 2H14.62A3.974 3.974 0 0 0 16 36V20a3.974 3.974 0 0 0-1.38-3V7H34v10h2a2 2 0 0 1 2 2v18zm-26 2a3.003 3.003 0 0 1-3-3V20a3 3 0 1 1 6 0v16a3.003 3.003 0 0 1-3 3z",
      }),
      a("path", {
        className: "at-0 ot-2 ttc-1 ttcw-2",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M34.065 17h1.968c1.086 0 1.967.895 1.967 2v18c0 1.104-.88 2-1.968 2h-21.03a4.002 4.002 0 0 0 1.357-3V20A4.003 4.003 0 0 0 15 17V7h19.065v10zm-1.967-8h-15.13v8h15.13V9zM22.26 34h-1.967a.992.992 0 0 1-.984-1c0-.553.44-1 .984-1h1.967c.543 0 .984.447.984 1 0 .552-.44 1-.984 1zm-1.967-4h1.967a.992.992 0 0 0 .984-1c0-.553-.44-1-.984-1h-1.967a.992.992 0 0 0-.984 1c0 .552.44 1 .984 1zm7.87 4h-1.968a.992.992 0 0 1-.984-1c0-.553.44-1 .984-1h1.968c.543 0 .983.447.983 1 0 .552-.44 1-.983 1zm-1.968-4h1.968a.992.992 0 0 0 .983-1c0-.553-.44-1-.983-1h-1.968a.992.992 0 0 0-.984 1c0 .552.44 1 .984 1zm7.87 4h-1.968a.992.992 0 0 1-.983-1c0-.553.44-1 .983-1h1.968c.543 0 .984.447.984 1 0 .552-.44 1-.984 1zm-1.968-4h1.968a.992.992 0 0 0 .984-1c0-.553-.44-1-.984-1h-1.968a.992.992 0 0 0-.983 1c0 .552.44 1 .983 1zm1.968-6H19.309v-3.978h16.06L34.065 24z",
      }),
      a("path", {
        className: "at-0 ot-2 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M12 17a3 3 0 0 1 3 3v16a3 3 0 1 1-6 0V20a3 3 0 0 1 3-3z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M32.098 17h-15.13V9h15.13v8zM35 20H19v4h14.7l1.3-4zM22 32h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm-12-4h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2zm6 0h-2a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z",
      })
    );
  },
  ua = function (l) {
    return a(
      "svg",
      Object.assign(
        { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" },
        l
      ),
      a("circle", {
        className: "at-0 otc-0 ttc-1 ttcw-1",
        fill: "#FFF",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "otc-2 ttc-2",
        fill: "transparent",
        d: "M24 0C10.75 0 0 10.75 0 24s10.75 24 24 24 24-10.75 24-24S37.25 0 24 0zM8 13.85C8 12.83 8.82 12 9.83 12h28.35c1.01 0 1.83.83 1.83 1.85V31h-2V15.08L10 28v3H8V13.85zM40.15 35H7.85C6.28 35 5 33.66 5 32h2.85v.01h12.82v.04c0 .58.43 1.05.95 1.05h4.75c.52 0 .95-.47.95-1.05v-.04h12.83V32H43c0 1.66-1.28 3-2.85 3z",
      }),
      a("path", {
        className: "otc-0 ttc-0",
        fill: "#002677",
        d: "M40 13.85c0-1.02-.82-1.85-1.83-1.85H9.83C8.82 12 8 12.83 8 13.85V31h32V13.85zm-2 1.23L10 28V14h28v1.08zM40.15 32l-12.83.01v.04c0 .58-.43 1.05-.95 1.05h-4.75c-.52 0-.95-.47-.95-1.05v-.04H7.85V32H5c0 1.66 1.28 3 2.85 3h32.3c1.57 0 2.85-1.34 2.85-3h-2.85z",
      }),
      a("path", {
        className: "ot-0 otc-0",
        fill: "#00BED5",
        d: "M38 15.08V14H10v14z",
      })
    );
  },
  Va = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm7 10a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v20z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M39 12H9a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2zm-1 6L10 31V14h28v4zm1.5 7.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-1 0v2a.5.5 0 0 0 .5.5z",
      }),
      a("path", {
        className: "at-2",
        fill: "#002677",
        d: "M38 18v16H10v-3l28-13z",
      }),
      a("path", {
        className: "at-2 ttcw-1 ot-0",
        fill: "#002677",
        d: "M39.5 22.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-.5-.5z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-0",
        fill: "#00BED5",
        d: "M10 14v17l28-13v-4H10z",
      })
    );
  },
  ga = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm10.5-9H6v4.5a4.505 4.505 0 0 0 4.5-4.5zM6 33v-4.5a4.505 4.505 0 0 1 4.5 4.5H6zm31.5 0H42v-4.5a4.505 4.505 0 0 0-4.5 4.5zm4.5-5.5a5.506 5.506 0 0 0-5.5 5.5h-25A5.507 5.507 0 0 0 6 27.5v-7a5.507 5.507 0 0 0 5.5-5.5h25a5.506 5.506 0 0 0 5.5 5.5v7zM42 15h-4.5a4.505 4.505 0 0 0 4.5 4.5V15z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#002677",
        d: "M6 15v18h36V15H6z",
      }),
      a("path", {
        d: "M21.875 24.145c0-3.142 1.333-4.996 3.606-4.996a3.157 3.157 0 0 1 2.78 1.578A7.22 7.22 0 0 1 29 24.13c0 3.099-1.332 4.967-3.533 4.967-2.26 0-3.591-1.84-3.591-4.953zm1.941.086c0 2.216.521 3.259 1.636 3.259 1.086 0 1.608-1.087 1.608-3.375 0-2.287-.507-3.359-1.608-3.359-1.158 0-1.636 1.014-1.636 3.475zm-3.281-1.773a3.32 3.32 0 0 0-1.4-.574v-1.402a.732.732 0 0 1 .658.76h1.122a1.753 1.753 0 0 0-1.78-1.68v-.606h-.465v.607a2.18 2.18 0 0 0-1.24.439 1.528 1.528 0 0 0-.591 1.274c0 .845.455 1.317 1.536 1.587l.082.02.053.014a.568.568 0 0 0 .11.034.387.387 0 0 0 .05.016v1.604a.989.989 0 0 1-.844-1.021v-.025h-1.122a1.946 1.946 0 0 0 1.966 1.966v.667h.464v-.667a2.16 2.16 0 0 0 1.528-.641c.292-.297.453-.698.447-1.115a1.53 1.53 0 0 0-.574-1.257zm-1.865-.684c-.549-.144-.709-.287-.709-.633a.653.653 0 0 1 .709-.659v1.292zm.464 2.777zm0 0c.565-.093.853-.355.853-.777 0-.355-.194-.515-.853-.7v1.477z",
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
      }),
      a("path", {
        d: "M37.5 33H42v-4.5a4.505 4.505 0 0 0-4.5 4.5zM6 28.5V33h4.5A4.505 4.505 0 0 0 6 28.5zM10.5 15H6v4.5a4.505 4.505 0 0 0 4.5-4.5zm27 0a4.505 4.505 0 0 0 4.5 4.5V15h-4.5z",
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M36.5 15h-25A5.507 5.507 0 0 1 6 20.5v7a5.507 5.507 0 0 1 5.5 5.5h25a5.506 5.506 0 0 1 5.5-5.5v-7a5.506 5.506 0 0 1-5.5-5.5zm-15.838 9.83a2.157 2.157 0 0 1-1.528.64v.668h-.464v-.667a1.946 1.946 0 0 1-1.966-1.966h1.122v.025a.989.989 0 0 0 .844 1.02v-1.603a.386.386 0 0 1-.05-.016.569.569 0 0 1-.11-.034l-.053-.013a1.793 1.793 0 0 1-.082-.021c-1.08-.27-1.536-.742-1.536-1.587-.022-.495.198-.97.59-1.274a2.18 2.18 0 0 1 1.24-.44v-.606h.465v.607a1.753 1.753 0 0 1 1.781 1.68h-1.122a.732.732 0 0 0-.659-.76v1.401c.505.081.985.277 1.401.574.38.304.594.77.574 1.257.006.417-.155.818-.447 1.115zm1.213-.685c0 3.112 1.333 4.952 3.592 4.952 2.2 0 3.533-1.869 3.533-4.967a7.22 7.22 0 0 0-.739-3.403 3.158 3.158 0 0 0-2.78-1.578c-2.273 0-3.606 1.854-3.606 4.995z",
      }),
      a("path", {
        d: "M17.96 21.141c0 .346.161.49.71.633v-1.292a.653.653 0 0 0-.71.66zm1.174 1.933v1.477c.566-.093.853-.355.853-.777 0-.355-.194-.515-.853-.7zm6.318-2.318c-1.158 0-1.636 1.014-1.636 3.475 0 2.216.521 3.259 1.636 3.259 1.086 0 1.608-1.087 1.608-3.375 0-2.287-.507-3.359-1.608-3.359z",
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
      })
    );
  },
  Ha = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm38 11a2 2 0 0 0 2-2V15a2 2 0 0 0-2-2H10a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h28z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M38 13H10a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V15a2 2 0 0 0-2-2zM18 30h-7v-7h7v7zm3 0h15l1.15-2H21v2zm15-5H21v-2h16.15L36 25zm-26-5.625h28V16H10v3.375z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-3",
        fill: "#00BED5",
        d: "M18 23h-7v7h7v-7zm18 7H21v-2h16.15L36 30zm-15-5h15l1.15-2H21v2z",
      }),
      a("path", {
        className: "ot-0 otc-2 ttc-3 ttcw-1",
        fill: "#fff",
        d: "M10 16h28v3.375H10V16z",
      }),
      a("path", {
        fill: "transparent",
        d: "M38 13H10a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V15a2 2 0 0 0-2-2z",
      })
    );
  },
  Aa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm10.5-9H6v4.5a4.505 4.505 0 0 0 4.5-4.5zM6 33v-4.5a4.505 4.505 0 0 1 4.5 4.5H6zm31.5 0H42v-4.5a4.505 4.505 0 0 0-4.5 4.5zm4.5-5.5a5.506 5.506 0 0 0-5.5 5.5h-25A5.507 5.507 0 0 0 6 27.5v-7a5.507 5.507 0 0 0 5.5-5.5h25a5.506 5.506 0 0 0 5.5 5.5v7zM42 15h-4.5a4.505 4.505 0 0 0 4.5 4.5V15z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#002677",
        d: "M6 15v18h36V15H6z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M26.721 23.852a5.546 5.546 0 0 0-2.34-.959v-2.34a1.22 1.22 0 0 1 1.1 1.268h1.875a2.927 2.927 0 0 0-2.976-2.806V18h-.775v1.015a3.646 3.646 0 0 0-2.073.733 2.553 2.553 0 0 0-.987 2.13c0 1.41.761 2.2 2.566 2.65.054.016.104.027.145.037.034.008.062.014.081.02a.97.97 0 0 0 .183.057c.027.012.056.02.085.027v2.68a1.653 1.653 0 0 1-1.41-1.705V25.6H20.32a3.253 3.253 0 0 0 3.285 3.285V30h.775v-1.114a3.609 3.609 0 0 0 2.553-1.072 2.599 2.599 0 0 0 .747-1.86 2.559 2.559 0 0 0-.959-2.102zm-3.116-1.143c-.916-.24-1.184-.479-1.184-1.057a1.09 1.09 0 0 1 1.184-1.1v2.157zm.775 2.173v2.468c.945-.156 1.425-.593 1.425-1.298 0-.592-.324-.86-1.425-1.17z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        d: "M6 28.5V33h4.5A4.505 4.505 0 0 0 6 28.5zM10.5 15H6v4.5a4.505 4.505 0 0 0 4.5-4.5zm27 18H42v-4.5a4.505 4.505 0 0 0-4.5 4.5zm0-18a4.505 4.505 0 0 0 4.5 4.5V15h-4.5z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M11.5 15h25a5.506 5.506 0 0 0 5.5 5.5v7a5.506 5.506 0 0 0-5.5 5.5h-25A5.507 5.507 0 0 0 6 27.5v-7a5.507 5.507 0 0 0 5.5-5.5zm12.88 13.886a3.609 3.609 0 0 0 2.553-1.072 2.599 2.599 0 0 0 .747-1.86 2.558 2.558 0 0 0-.959-2.102 5.545 5.545 0 0 0-2.34-.959v-2.34a1.22 1.22 0 0 1 1.1 1.268h1.875a2.927 2.927 0 0 0-2.976-2.806V18h-.775v1.015a3.646 3.646 0 0 0-2.073.733 2.553 2.553 0 0 0-.987 2.13c0 1.41.761 2.2 2.566 2.65.054.016.104.028.145.037.034.008.062.014.081.02a.97.97 0 0 0 .183.057c.028.012.056.02.085.027v2.68a1.653 1.653 0 0 1-1.41-1.705V25.6H20.32a3.253 3.253 0 0 0 3.285 3.285V30h.775v-1.114z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        d: "M24.38 24.882v2.468c.945-.156 1.425-.593 1.425-1.298 0-.592-.324-.86-1.425-1.17zm-1.96-3.23c0 .578.268.818 1.185 1.057v-2.156a1.09 1.09 0 0 0-1.185 1.099z",
      })
    );
  },
  xa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M7.03 40.97c9.373 9.373 24.568 9.373 33.94 0 9.373-9.372 9.373-24.567 0-33.94-9.372-9.372-24.567-9.372-33.94 0-9.372 9.373-9.372 24.568 0 33.94zm25.65-19.86c.774-.27 1.6-.424 2.464-.424 4.14 0 7.51 3.37 7.51 7.51s-3.37 7.51-7.51 7.51c-4.142 0-7.511-3.37-7.511-7.51 0-2.674 1.41-5.021 3.522-6.352l-2.592-5.322L22.1 28.887h-2.684c-.47 3.693-3.625 6.56-7.443 6.56-4.141 0-7.51-3.37-7.51-7.51s3.369-7.51 7.51-7.51c1.082 0 2.108.235 3.038.649l-1.498-3.748h-1.54a.95.95 0 0 1 0-1.9h3.769a.95.95 0 0 1 0 1.9h-1.205l.577 1.442h9.988l2.589-5.247h-3.035a.95.95 0 1 1 0-1.901h6.466l-1.628 3.118a.78.78 0 0 1 .195.23l2.99 6.14z",
      }),
      a("path", {
        d: "M35.144 33.806a5.616 5.616 0 0 1-5.61-5.61c0-1.924.975-3.625 2.457-4.635l2.496 5.125a.846.846 0 0 0 1.15.333.848.848 0 0 0 .334-1.151l-2.454-5.04a5.58 5.58 0 0 1 1.627-.242 5.617 5.617 0 0 1 5.609 5.61 5.616 5.616 0 0 1-5.61 5.61zm-23.17-.259a5.615 5.615 0 0 1-5.61-5.61 5.615 5.615 0 0 1 5.61-5.61c2.769 0 5.069 2.019 5.523 4.66h-5.523a.95.95 0 1 0 0 1.9h5.524c-.455 2.642-2.755 4.66-5.524 4.66z",
        className: "at-0 otc-2",
        fill: "transparent",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M21.049 26.987h-1.625a7.515 7.515 0 0 0-3.22-5.25.47.47 0 0 0-.014-.277l-.696-1.74h9.14l-3.585 7.267z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M32.686 21.14a7.447 7.447 0 0 1 2.463-.424c4.14 0 7.51 3.37 7.51 7.51s-3.37 7.51-7.51 7.51c-4.141 0-7.51-3.37-7.51-7.51a7.504 7.504 0 0 1 3.52-6.352l-2.591-5.323-6.461 12.366h-2.685c-.47 3.692-3.624 6.56-7.442 6.56-4.142 0-7.511-3.37-7.511-7.51s3.369-7.51 7.51-7.51c1.082 0 2.108.234 3.039.648l-1.498-3.748h-1.54a.95.95 0 1 1 0-1.9h3.768a.95.95 0 0 1 0 1.9h-1.205l.577 1.442h9.988l2.589-5.246h-3.035a.951.951 0 0 1 0-1.902h6.467l-1.63 3.118a.806.806 0 0 1 .196.23l2.99 6.14zm-3.147 7.086a5.617 5.617 0 0 0 5.61 5.61 5.616 5.616 0 0 0 5.61-5.61 5.616 5.616 0 0 0-5.61-5.61c-.566 0-1.11.086-1.626.242l2.453 5.04a.847.847 0 1 1-1.484.817l-2.496-5.125a5.606 5.606 0 0 0-2.457 4.636zm-8.485-1.21h-1.625a7.513 7.513 0 0 0-3.22-5.25.465.465 0 0 0-.014-.277l-.696-1.74h9.141l-3.586 7.268zm-14.684.95a5.616 5.616 0 0 0 5.61 5.61c2.768 0 5.07-2.018 5.522-4.66H11.98a.95.95 0 1 1 0-1.9h5.522c-.454-2.641-2.754-4.66-5.522-4.66a5.617 5.617 0 0 0-5.61 5.61z",
      }),
      a(
        "g",
        { className: "at-0 ttc-1 ttcw-2", fill: "#002677" },
        a("path", {
          d: "M15.71 22.1a.475.475 0 0 1-.442-.3l-1.912-4.782a.473.473 0 0 1 .265-.617.473.473 0 0 1 .617.264l1.912 4.784a.474.474 0 0 1-.44.65z",
        }),
        a("path", {
          d: "M15.703 17.316h-3.768a.95.95 0 0 1 0-1.9h3.768a.949.949 0 1 1 0 1.9z",
        })
      ),
      a("path", {
        d: "M11.935 35.435c-4.141 0-7.51-3.369-7.51-7.51 0-4.14 3.37-7.51 7.51-7.51 4.141 0 7.51 3.37 7.51 7.51 0 4.141-3.369 7.51-7.51 7.51zm23.17.259c-4.141 0-7.51-3.369-7.51-7.51 0-4.14 3.369-7.51 7.51-7.51 4.14 0 7.51 3.37 7.51 7.51 0 4.141-3.37 7.51-7.51 7.51z",
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
      }),
      a("path", {
        d: "M35.105 22.575a5.616 5.616 0 0 0-5.61 5.61 5.616 5.616 0 0 0 5.61 5.61 5.616 5.616 0 0 0 5.609-5.61 5.616 5.616 0 0 0-5.61-5.61zm-23.17-.26a5.616 5.616 0 0 0-5.609 5.61 5.616 5.616 0 0 0 5.61 5.61 5.616 5.616 0 0 0 5.608-5.61 5.616 5.616 0 0 0-5.609-5.61z",
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M35.932 27.855 29.65 14.96a.797.797 0 0 0-.195-.232l1.629-3.117h-6.467a.95.95 0 1 0 0 1.902h3.035l-2.59 5.245h-10.31v.951h9.843l-3.586 7.267h-9.075a.95.95 0 0 0 0 1.9h10.127l6.462-12.366 5.924 12.165a.847.847 0 1 0 1.484-.819z",
      })
    );
  },
  Ra = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm24 19c6.627 0 12-5.373 12-12V16a2 2 0 1 0-4 0v6h-1V10a2 2 0 1 0-4 0v12h-1V7a2 2 0 1 0-4 0v15h-1V10a2 2 0 1 0-4 0v15.615c.029-.034.055-.069.081-.103.042-.055.084-.11.134-.16a4.147 4.147 0 0 1 5.863 0l.922.921.922-.921a4.147 4.147 0 0 1 5.863 5.864L24.002 38 24 37.998l-.002.002-6.784-6.784a4.129 4.129 0 0 1-1.208-2.87L16 28.35V21a2 2 0 1 0-4 0v10c0 6.627 5.373 12 12 12z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
        d: "M34 14a2 2 0 0 0-2 2v6h-1V10a2 2 0 1 0-4 0v12h-1V7a2 2 0 1 0-4 0v15h-1V10a2 2 0 1 0-4 0v15.615c.073-.087.133-.18.215-.263a4.147 4.147 0 0 1 5.863 0l.922.921.922-.92a4.146 4.146 0 0 1 5.863 5.863L24.002 38 24 37.998l-.002.002-6.784-6.784a4.127 4.127 0 0 1-1.206-3.018l-.008.001V21a2 2 0 1 0-4 0v10c0 6.627 5.373 12 12 12s12-5.373 12-12V16a2 2 0 0 0-2-2z",
      }),
      a("path", {
        fill: "transparent",
        d: "M34 14a2 2 0 0 0-2 2v6h-1V10a2 2 0 1 0-4 0v12h-1V7a2 2 0 1 0-4 0v15h-1V10a2 2 0 1 0-4 0v18l-1 .349V21a2 2 0 1 0-4 0v10c0 6.627 5.373 12 12 12s12-5.373 12-12V16a2 2 0 0 0-2-2z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "M30.785 25.352a4.147 4.147 0 0 0-5.863 0l-.922.922-.922-.922a4.147 4.147 0 1 0-5.863 5.864L23.998 38l.002-.002.002.002 6.784-6.784a4.147 4.147 0 0 0 0-5.864z",
      })
    );
  },
  La = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24zm-12.806-1.338.01-5.279a.509.509 0 0 0-.053-.227l-2.796-5.515v-6.26a.5.5 0 0 0-1 0v6.38c0 .08.02.156.055.226l2.795 5.514-.01 5.136h-2.293l-2.105-4.524a.497.497 0 0 0-.145-.182l-4.869-3.81-2.652-5.67a.501.501 0 0 0-.665-.243.502.502 0 0 0-.242.665l2.703 5.78a.51.51 0 0 0 .146.181l4.869 3.81 1.857 3.993h-4.113l-2.093 4.701-4.146-.894c.094-.162.162-.34.162-.54a1.1 1.1 0 0 0-1.1-1.1H13.93l-.976 2.2h5.342l5.881 1.268-1.873 4.207h-8.11c0-.016.005-.03.01-.046a.2.2 0 0 0 .01-.055c0-.609-.492-1.1-1.1-1.1H7.539l-.977 2.2h3.823l.003.001H21.86l-1.54 3.458h14.385a7.15 7.15 0 0 0 7.15-7.15c0-3.783-2.941-6.873-6.661-7.125zm-.49 2.825a4.305 4.305 0 0 0-4.3 4.3c0 2.371 1.93 4.3 4.3 4.3 2.371 0 4.3-1.929 4.3-4.3 0-2.37-1.929-4.3-4.3-4.3zm0 6.6a2.302 2.302 0 0 1-2.3-2.3c0-1.268 1.031-2.3 2.3-2.3 1.27 0 2.3 1.032 2.3 2.3 0 1.268-1.03 2.3-2.3 2.3z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "m35.204 17.383-.01 5.28c3.719.251 6.661 3.341 6.661 7.124a7.15 7.15 0 0 1-7.151 7.15H20.32l1.54-3.458H10.388l-.006-.002H6.561l.977-2.199h5.577c.608 0 1.1.491 1.1 1.1 0 .02-.005.038-.01.057a.265.265 0 0 0-.011.044h8.111l1.873-4.207-5.881-1.269h-5.342l.976-2.2h5.578a1.1 1.1 0 0 1 1.1 1.1c0 .201-.068.38-.163.541l4.148.894 2.093-4.7H30.8l-1.859-3.994-4.868-3.81a.497.497 0 0 1-.145-.182l-2.703-5.779a.502.502 0 0 1 .241-.665.502.502 0 0 1 .665.242l2.653 5.67 4.868 3.811c.062.048.112.11.145.182l2.105 4.524h2.292l.01-5.136-2.794-5.514a.492.492 0 0 1-.054-.226v-6.38a.5.5 0 1 1 1 0v6.26l2.794 5.515c.036.07.054.148.054.227zm-4.8 12.404c0-2.37 1.93-4.3 4.3-4.3 2.371 0 4.3 1.93 4.3 4.3 0 2.371-1.929 4.3-4.3 4.3a4.305 4.305 0 0 1-4.3-4.3z",
      }),
      a(
        "g",
        { className: "at-0 ttc-3 ttcw-3", fill: "#00BED5" },
        a("path", {
          d: "M34.68 30.525a.468.468 0 0 1-.105-.01l-17.692-3.818a.501.501 0 0 1 .21-.977l17.692 3.817a.498.498 0 0 1-.105.988z",
        }),
        a("path", {
          d: "M34.68 30.525h-.002a.5.5 0 0 1-.498-.5l.024-12.523-2.794-5.515a.495.495 0 0 1-.054-.226v-6.38a.5.5 0 0 1 1 0v6.26l2.795 5.515c.035.07.053.148.053.226l-.024 12.645a.5.5 0 0 1-.5.498z",
        })
      ),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M34.704 22.638h-8.018l-6.366 14.3h14.384a7.15 7.15 0 0 0 0-14.3z",
      }),
      a(
        "g",
        { className: "at-0 ttc-3 ttcw-3", fill: "#00BED5" },
        a("path", {
          d: "M34.704 33.478H10.388a.499.499 0 1 1 0-1h24.316a.5.5 0 0 1 0 1zm-.024-3.191a.497.497 0 0 1-.453-.289l-5.285-11.354-4.868-3.81a.508.508 0 0 1-.146-.182l-2.703-5.779a.5.5 0 0 1 .906-.424l2.653 5.671 4.869 3.811c.06.047.11.11.144.182l5.336 11.463a.5.5 0 0 1-.453.711z",
        }),
        a("path", {
          d: "M34.704 25.487a4.305 4.305 0 0 0-4.3 4.3 4.306 4.306 0 0 0 4.3 4.3c2.371 0 4.3-1.93 4.3-4.3 0-2.371-1.929-4.3-4.3-4.3z",
        })
      ),
      a("path", {
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
        d: "M34.704 27.487a2.302 2.302 0 0 0-2.3 2.3 2.303 2.303 0 0 0 2.3 2.301 2.301 2.301 0 0 0 0-4.6z",
      }),
      a("path", {
        d: "M7.537 31.277h5.578a1.1 1.1 0 1 1 0 2.2H6.56l.977-2.2zm6.395-6.474h5.577a1.1 1.1 0 1 1 0 2.2h-6.555l.978-2.2z",
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
      })
    );
  },
  Ba = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm4.473 7.229a5.892 5.892 0 0 1 5.866.624A5.9 5.9 0 0 1 25 12a5.893 5.893 0 0 1 3.473-4.771zM34.42 29.67 36 26.124a8.146 8.146 0 0 0-11-10.645V12l-2 .887v2.591a8.146 8.146 0 0 0-11 10.646l1.578 3.546s2.122 4.775 2.222 4.959A6.254 6.254 0 0 0 24 37.41a6.256 6.256 0 0 0 8.2-2.781c.1-.184 2.22-4.959 2.22-4.959z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "M30.46 11.707a4.917 4.917 0 0 0 2.783-3.368 4.96 4.96 0 0 0-2.383-.618c-.683 0-1.358.144-1.981.422A4.92 4.92 0 0 0 26.1 11.51a4.95 4.95 0 0 0 2.383.619c.681 0 1.355-.144 1.977-.422z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        fillRule: "evenodd",
        d: "M34.339 7.853a5.9 5.9 0 0 1-3.473 4.768v.003A5.892 5.892 0 0 1 25 12a5.9 5.9 0 0 1 9.339-4.147zm-3.479-.132c-.683 0-1.358.144-1.98.422a4.92 4.92 0 0 0-2.78 3.367 4.948 4.948 0 0 0 2.378.619 4.87 4.87 0 0 0 1.982-.422 4.917 4.917 0 0 0 2.783-3.368 4.96 4.96 0 0 0-2.383-.618z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
        d: "M31.858 15.36a8.132 8.132 0 0 0-6.858.118V12l-2 .888v2.591a8.146 8.146 0 0 0-11 10.645l1.58 3.546s2.12 4.775 2.22 4.959A6.254 6.254 0 0 0 24 37.41a6.256 6.256 0 0 0 8.2-2.781 858.44 858.44 0 0 0 2.222-4.959L36 26.124a8.154 8.154 0 0 0-4.142-10.764z",
      })
    );
  },
  Ca = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0zm6.812 6.513 1.125.842-.848 4.69-1.237-.224.96-5.308zm-3.626 5.372-.793-4.752-1.344-.407.899 5.372 1.238-.213zM19.25 13.37c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37v8.512a2.367 2.367 0 0 0-1.38-.442c-.511 0-.982.167-1.37.445V13.37zM8 29.12C8 34.01 11.98 38 16.87 38c.716 0 1.41-.094 2.077-.255a9.823 9.823 0 0 1-.697-3.625v-10.3c0-.128.019-.251.038-.373h-.038V11.12c0-.76-.62-1.37-1.38-1.37-.76 0-1.37.61-1.37 1.37v12.32h-1V13.37c0-.76-.62-1.37-1.38-1.37-.76 0-1.37.61-1.37 1.37v10.07h-1v-4.62a1.374 1.374 0 1 0-2.75 0v10.3zm29 5c0 4.89-3.98 8.88-8.88 8.88-4.299 0-7.892-3.085-8.698-7.153l-.01-.061a.64.64 0 0 0-.009-.061 8.685 8.685 0 0 1-.108-.723 8.853 8.853 0 0 1-.045-.881v-10.3A1.374 1.374 0 1 1 22 23.82v4.62h1V18.37c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37v10.07h1V16.12c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37v12.327h1V18.37c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37v13.59l1 .35v-5.69c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37v7.5zm-3.502-20.73 1.085.632L37 9.895l-.769-1.176-2.733 4.67z",
      }),
      a("path", {
        d: "m31.089 12.045-1.237-.224.96-5.309 1.125.842-.848 4.691zM37 9.894l-.769-1.176-2.733 4.67 1.085.633L37 9.894zm-9.815 1.991-.793-4.752-1.344-.406.899 5.371 1.238-.213z",
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M38 34.12v-7.5a2.378 2.378 0 0 0-3.75-1.933V18.37a2.378 2.378 0 0 0-3.75-1.933v-.317a2.378 2.378 0 0 0-2.38-2.37 2.372 2.372 0 0 0-2.37 2.37v.32A2.372 2.372 0 0 0 22 18.37v-5c0-.76-.62-1.37-1.38-1.37-.76 0-1.37.61-1.37 1.37v8.515c-.506.363-.86.919-.962 1.562h-.038V11.12c0-.76-.62-1.37-1.38-1.37-.76 0-1.37.61-1.37 1.37v12.32h-1V13.37c0-.76-.62-1.37-1.38-1.37-.76 0-1.37.61-1.37 1.37v10.07h-1v-4.62a1.374 1.374 0 1 0-2.75 0v10.3C8 34.01 11.98 38 16.87 38c.716 0 1.41-.094 2.077-.255C20.395 41.402 23.957 44 28.12 44c5.448 0 9.88-4.432 9.88-9.88zm-1.109-8.035c.07.164.109.345.109.535v7.5a8.842 8.842 0 0 1-2.602 6.274 9.014 9.014 0 0 1-1.315 1.086A8.826 8.826 0 0 1 28.12 43a9.04 9.04 0 0 1-1.503-.137 8.844 8.844 0 0 1-1.154-.271l-.035-.013a8.848 8.848 0 0 1-1.289-.536 8.794 8.794 0 0 1-1.021-.598l-.011-.008a8.964 8.964 0 0 1-.966-.779l-.09-.082a8.899 8.899 0 0 1-1.556-1.944l-.034-.057a8.836 8.836 0 0 1-.555-1.12v-.001a8.814 8.814 0 0 1-.656-3.334v-10.3a1.374 1.374 0 1 1 2.75 0v4.62h1V18.37A1.365 1.365 0 0 1 24.37 17a1.386 1.386 0 0 1 1.271.835c.07.164.109.345.109.535v10.07h1V16.12a1.365 1.365 0 0 1 1.37-1.37 1.386 1.386 0 0 1 1.271.835c.07.164.109.345.109.535v12.327h1V18.37A1.365 1.365 0 0 1 31.87 17a1.386 1.386 0 0 1 1.271.835c.07.164.109.345.109.535v13.59l1 .35v-5.69a1.365 1.365 0 0 1 1.37-1.37 1.386 1.386 0 0 1 1.271.835z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        d: "M25.75 21.62v7.5c0 4.89-3.98 8.88-8.88 8.88C11.98 38 8 34.01 8 29.12v-10.3a1.374 1.374 0 1 1 2.75 0v4.62h1V13.37c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37v10.07h1V11.12c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37v12.327h1V13.37c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37v15.28l1 .35v-7.38c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M37 26.62v7.5c0 4.89-3.98 8.88-8.88 8.88-4.89 0-8.87-3.99-8.87-8.88v-10.3a1.374 1.374 0 1 1 2.75 0v4.62h1V18.37c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37v10.07h1V16.12c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37v12.327h1V18.37c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37v13.59l1 .35v-5.69c0-.76.61-1.37 1.37-1.37.76 0 1.38.61 1.38 1.37z",
      })
    );
  },
  Ia = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M24 0a24 24 0 1 0 0 48 24 24 0 0 0 0-48zm4.11 8.5a3.089 3.089 0 0 0 1.82-1.82.21.21 0 0 1 .38 0 3.09 3.09 0 0 0 1.82 1.82.2.2 0 0 1 0 .37 3.13 3.13 0 0 0-1.82 1.83.21.21 0 0 1-.38 0 3.129 3.129 0 0 0-1.82-1.83.2.2 0 0 1 0-.37zM22 17.91a5.698 5.698 0 0 0 3.35-3.39.37.37 0 0 1 .69 0 5.7 5.7 0 0 0 3.35 3.39.37.37 0 0 1 0 .69 5.71 5.71 0 0 0-3.32 3.4.37.37 0 0 1-.69 0A5.708 5.708 0 0 0 22 18.6a.37.37 0 0 1 0-.69zm1.6 23a17.55 17.55 0 0 1-6.38-33.9 18.55 18.55 0 0 0-2.12 8.63A18.74 18.74 0 0 0 37.53 34.1a17.52 17.52 0 0 1-13.9 6.9l-.03-.09z",
      }),
      a("path", {
        d: "M32.13 8.87a3.13 3.13 0 0 0-1.82 1.83.211.211 0 0 1-.302.088.21.21 0 0 1-.078-.088 3.13 3.13 0 0 0-1.82-1.83.2.2 0 0 1-.09-.296.2.2 0 0 1 .09-.074 3.09 3.09 0 0 0 1.82-1.82.21.21 0 0 1 .38 0 3.09 3.09 0 0 0 1.82 1.82.2.2 0 0 1 0 .37zm-2.71 9.73a5.709 5.709 0 0 0-3.35 3.4.37.37 0 0 1-.69 0A5.71 5.71 0 0 0 22 18.6a.37.37 0 0 1 0-.69 5.7 5.7 0 0 0 3.35-3.39.37.37 0 0 1 .69 0 5.698 5.698 0 0 0 3.35 3.39.37.37 0 0 1 .03.69z",
        className: "ot-2 otc-0 ttc-1 ttcw-3",
        fill: "#00BED5",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-3 ttcw-2",
        fill: "#002677",
        d: "M33.91 34.46a18.78 18.78 0 0 1-18.78-18.78 18.55 18.55 0 0 1 2.12-8.63A17.55 17.55 0 1 0 37.53 34.1a18.74 18.74 0 0 1-3.62.36z",
      })
    );
  },
  Da = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm36.178 11.014a2.329 2.329 0 0 0 1.81-2.27V7l-22 5v18.443l-5.579 1.274a4.4 4.4 0 0 0 1.948 8.573l3.821-.875a2.329 2.329 0 0 0 1.81-2.27v-16.6l18-4.09v9.587l-5.579 1.274a4.4 4.4 0 0 0 1.948 8.573l3.821-.875z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        d: "M17.988 12v18.441l-5.579 1.274A4.4 4.4 0 0 0 8.988 36a4.4 4.4 0 0 0 5.369 4.287l3.821-.875a2.329 2.329 0 0 0 1.81-2.27v-16.6l18-4.09v9.587l-5.579 1.274a4.4 4.4 0 0 0 1.948 8.573l3.821-.875a2.329 2.329 0 0 0 1.81-2.27V7l-22 5z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M16 12v9l22-5V7l-22 5z",
      }),
      a("path", {
        d: "M36 16.455h-.012v9.584l-5.579 1.274a4.4 4.4 0 0 0 1.948 8.573l3.821-.875a2.329 2.329 0 0 0 1.81-2.27V16L36 16.455zM16 21h-.012v9.441l-5.579 1.274a4.4 4.4 0 0 0 1.948 8.573l3.821-.875a2.329 2.329 0 0 0 1.81-2.27v-16.6L16 21z",
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
      })
    );
  },
  ba = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24c0 13.254 10.746 24 24 24s24-10.746 24-24S37.254 0 24 0 0 10.746 0 24zm38.902 13.918a4.154 4.154 0 0 1-.73 1.082l-15.094-.008a9.25 9.25 0 0 1-.646-.022l-11.55.073-1.355-1.438 8.557-.05a9.381 9.381 0 0 1-1.543-1.211l-8.287.05-1.356-1.433 8.201-.055L13.89 33.7l-8.038.047-1.356-1.434 7.958-.046-7.868-7.856a2 2 0 0 1 0-2.828l.23-.23 10.888 10.89h.003l1.37 1.374.571.572c.254.252.52.485.8.699h.017c.348.265.71.504 1.09.707a7.875 7.875 0 0 0 3.683.906h16.055a4.144 4.144 0 0 1-.39 1.418zM12.164 14.004l-.012.016-6.629 6.625L18.355 33.48a6.874 6.874 0 0 0 4.883 2.02h16.035c-.199-1.738-1.25-2.563-2.62-3.145L35.5 31.91a16.122 16.122 0 0 1-4.652-2.808l-.899.898h-2.828l2.293-2.293a16.657 16.657 0 0 1-1.383-1.746L26.992 27h-2.828l2.75-2.75-1.215-1.902-.594.586a6.762 6.762 0 0 1-9.562-.028 6.767 6.767 0 0 1-1.43-7.418.632.632 0 0 1 .037-.087 1.03 1.03 0 0 0 .112-.518 1.231 1.231 0 0 0-2.09-.883v-.004l-.008.008zm4.813.754 6.668-6.625 9.718 3.77-9.668 9.613a4.725 4.725 0 0 1-3.355 1.386c-1.281 0-2.48-.5-3.379-1.406a4.732 4.732 0 0 1-1.387-3.375 4.752 4.752 0 0 1 1.403-3.363z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-3",
        fill: "#002577",
        d: "M20.336 22.902c1.27 0 2.46-.492 3.36-1.386l9.667-9.61-9.718-3.777-6.668 6.629a4.754 4.754 0 0 0-1.403 3.367 4.73 4.73 0 0 0 1.387 3.371 4.721 4.721 0 0 0 3.375 1.406z",
      }),
      a(
        "g",
        { className: "at-0 ot-2", fill: "transparent" },
        a("path", {
          d: "M23.238 35.5h16.035c-.199-1.738-1.25-2.563-2.62-3.145L35.5 31.91a16.122 16.122 0 0 1-4.652-2.808l-.899.898h-2.828l2.293-2.293a16.657 16.657 0 0 1-1.383-1.746L26.992 27h-2.828l2.75-2.75-1.215-1.902-.594.586a6.766 6.766 0 0 1-9.566-.028 6.773 6.773 0 0 1-1.426-7.418c.016-.05.043-.097.055-.129a1.03 1.03 0 0 0 .094-.476 1.231 1.231 0 0 0-2.09-.883v-.004l-.008.008c-.004.004-.008.008-.012.016l-6.629 6.625L18.355 33.48a6.874 6.874 0 0 0 4.883 2.02z",
        }),
        a("path", {
          d: "M23.238 36.5a7.895 7.895 0 0 1-3.683-.906 8.128 8.128 0 0 1-1.09-.707 8.124 8.124 0 0 1-.817-.7l-.507-.507-1.434-1.438-10.89-10.89-.231.23a2 2 0 0 0 0 2.828l7.863 7.856-7.953.047 1.356 1.433 8.035-.05 1.21 1.21-8.199.055 1.356 1.434 8.293-.051c.476.46 1 .863 1.555 1.21l-8.575.051 1.356 1.438 11.734-.07c.156.004.309.02.461.02L38.172 39a4.22 4.22 0 0 0 .73-1.082c.223-.465.348-.945.391-1.418",
        })
      ),
      a("path", {
        d: "M17.857 33.715 16.47 32.28l-11.974.075 1.355 1.433 12.006-.073zm2.403 2.646-1.388-1.435-11.974.075 1.355 1.433 12.006-.073zm2.629 2.649-1.387-1.435-11.975.075 1.356 1.433 12.006-.073z",
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        d: "M39.308 36H23.237a7.407 7.407 0 0 1-5.235-2.168L5.17 20.999l-.584.584a1.999 1.999 0 0 0 .001 2.829l11.851 11.832a9.4 9.4 0 0 0 6.641 2.749l15.09.007h.002c.293-.307.542-.686.731-1.08a4.216 4.216 0 0 0 .412-1.832c0-.031-.006-.057-.006-.088z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M18.002 33.832A7.403 7.403 0 0 0 23.237 36h16.071c0 .03.006.057.006.088-.005-2.155-1.144-3.088-2.665-3.732L35.5 31.91a16.116 16.116 0 0 1-4.657-2.805L29.95 30h-2.828l2.285-2.285a16.391 16.391 0 0 1-1.374-1.755L26.992 27h-2.828l2.751-2.75-1.217-1.904-.592.588a6.763 6.763 0 0 1-10.99-7.446c.012-.05.04-.1.052-.13.07-.172.093-.262.093-.477a1.232 1.232 0 0 0-2.09-.882v-.001l-.006.006-.014.014-6.982 6.98 12.833 12.834z",
      })
    );
  },
  Ea = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M24 0a24 24 0 1 0 0 48 24 24 0 0 0 0-48zm0 40a16 16 0 0 1-1.5-31.92V6H21a1 1 0 1 1 0-2h6a1 1 0 1 1 0 2h-1.5v2.08a15.89 15.89 0 0 1 8.3 3.29l.79-.78a2 2 0 0 1 2.82 2.82l-.78.79A16 16 0 0 1 24 40z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M24 10a14 14 0 1 0 0 28 14 14 0 0 0 0-28zm0 14V12a12 12 0 0 1 12 12H24z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "#002677",
        d: "m36.63 14.2.78-.79a2 2 0 0 0-2.82-2.82l-.79.78a15.89 15.89 0 0 0-8.3-3.29V6H27a1 1 0 0 0 0-2h-6a1 1 0 1 0 0 2h1.5v2.08a16 16 0 1 0 14.13 6.12zM24 38a14 14 0 1 1 0-28 14 14 0 0 1 0 28zm12-14H24V12a12 12 0 0 1 12 12z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M21 6h1.5v2.08a14.1 14.1 0 0 1 3 0V6H27a1 1 0 1 0 0-2h-6a1 1 0 1 0 0 2zm15.63 8.2.78-.79a2 2 0 0 0-2.82-2.82l-.79.78c1.06.82 2.01 1.77 2.83 2.83z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M24 8a16 16 0 1 0 0 32 16 16 0 0 0 0-32zm0 30a14 14 0 1 1 0-28 14 14 0 0 1 0 28z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M36 24H24V12a12 12 0 0 1 12 12z",
      })
    );
  },
  Oa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24zm-24.01-1.969c5.82 0 11.276 1.542 15.997 4.23a16.2 16.2 0 0 0 .202-2.43c0-8.947-7.253-16.2-16.2-16.2s-16.2 7.253-16.2 16.2c0 .828.082 1.635.202 2.43a32.238 32.238 0 0 1 15.998-4.23zm5.4 4.5h8.1l-1.434 3.296c1.163.278 1.732.864 1.762.896a.45.45 0 0 1-.654.62c-.029-.03-.495-.48-1.474-.673l-1.328 3.061h-4.973c-1.944 0-3.6-1.612-3.6-3.6 0-.01.002-.019.003-.028a.174.174 0 0 0 .003-.029c-.395-.195-.993-.393-1.806-.393-.813 0-1.41.198-1.806.393 0 .01.002.02.003.029.002.01.003.018.003.028 0 1.988-1.654 3.6-3.6 3.6h-4.971l-1.33-3.06c-.983.192-1.45.646-1.473.671a.453.453 0 0 1-.635.012.449.449 0 0 1-.018-.63c.03-.033.597-.619 1.76-.897l-1.433-3.296h8.1c1.614 0 3.013 1.115 3.449 2.63a4.981 4.981 0 0 1 1.951-.38 4.99 4.99 0 0 1 1.953.38c.436-1.515 1.834-2.63 3.448-2.63z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M37.136 26.531h-8.1c-1.613 0-3.012 1.115-3.447 2.63a4.99 4.99 0 0 0-1.953-.38 4.99 4.99 0 0 0-1.953.38c-.435-1.515-1.834-2.63-3.447-2.63h-8.1l1.432 3.296c-1.162.278-1.73.864-1.76.896a.449.449 0 0 0 .329.755.453.453 0 0 0 .324-.136c.024-.025.49-.479 1.473-.672l1.33 3.06h4.972c1.944 0 3.6-1.61 3.6-3.599 0-.01-.002-.019-.003-.028a.174.174 0 0 1-.003-.029c.396-.195.993-.393 1.806-.393.813 0 1.41.198 1.806.393 0 .01-.002.02-.003.029a.133.133 0 0 0-.003.028c0 1.988 1.656 3.6 3.6 3.6h4.972l1.33-3.06c.978.192 1.445.642 1.472.671a.452.452 0 0 0 .634.017.45.45 0 0 0 .02-.636c-.03-.032-.598-.618-1.76-.896l1.432-3.296zm-18.9.9c1.186 0 2.248.813 2.582 1.978l.108.372.004.307c0 .03.002.06.006.09-.026 1.442-1.252 2.653-2.7 2.653h-4.381l-2.346-5.4h6.727zm17.528 0h-6.728c-1.186 0-2.248.813-2.582 1.978l-.108.372-.004.307-.001.061-.004.031c.027 1.442 1.252 2.651 2.699 2.651h4.381l2.347-5.4z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M23.99 22.034c5.82 0 11.277 1.543 15.999 4.23.119-.794.2-1.602.2-2.43 0-8.946-7.252-16.199-16.2-16.199-8.946 0-16.2 7.253-16.2 16.2 0 .827.083 1.635.202 2.428a32.255 32.255 0 0 1 15.999-4.229z",
      }),
      a(
        "g",
        { className: "at-0 ttc-1 ttcw-2", fill: "#002677" },
        a("path", {
          d: "M37.49 31.484a.45.45 0 0 1-.326-.14c-.038-.039-.77-.759-2.374-.759a.45.45 0 0 1 0-.9c2.028 0 2.988.998 3.028 1.041a.45.45 0 0 1-.328.758zm-27-.003a.448.448 0 0 1-.329-.755c.04-.043 1.001-1.042 3.028-1.042a.45.45 0 0 1 0 .901c-1.614 0-2.344.729-2.374.759a.454.454 0 0 1-.325.137zm16.2-.896a.448.448 0 0 1-.319-.132c-.03-.029-.81-.768-2.381-.768-1.571 0-2.352.739-2.384.77a.451.451 0 0 1-.636-.006.448.448 0 0 1 .002-.633c.041-.042 1.053-1.032 3.017-1.032s2.976.99 3.018 1.032a.45.45 0 0 1-.318.769z",
        }),
        a("path", {
          d: "M18.59 26.534h-8.1l3.128 7.2h4.972c1.944 0 3.6-1.611 3.6-3.6 0-1.988-1.656-3.6-3.6-3.6zm18.9 0h-8.1c-1.944 0-3.6 1.612-3.6 3.6 0 1.989 1.656 3.6 3.6 3.6h4.972l3.128-7.2z",
        })
      ),
      a("path", {
        d: "M18.59 27.434c1.463 0 2.7 1.237 2.7 2.701 0 1.462-1.237 2.699-2.7 2.699h-4.382l-2.346-5.4h6.728zm17.527 0-2.346 5.4H29.39c-1.463 0-2.7-1.237-2.7-2.699 0-1.464 1.237-2.701 2.7-2.701h6.727z",
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
      })
    );
  },
  ja = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M7.03 40.97c9.373 9.373 24.568 9.373 33.94 0 9.373-9.372 9.373-24.567 0-33.94-9.372-9.373-24.567-9.373-33.94 0-9.372 9.373-9.372 24.568 0 33.94zm25.674-6.45a1.255 1.255 0 0 0 2.508 0v-3.87l2.3-.457c1.507-.362 2.101-4.745 1.973-6.232-.128-1.486-1.442-2.384-2.96-2.036l-1.313.411V14.11a6.575 6.575 0 0 0-6.568-6.568h-9.377a1.253 1.253 0 1 0 0 2.507h9.377a4.065 4.065 0 0 1 4.06 4.061v9.013l-22.66 7.11.002.012a2.663 2.663 0 0 0 .728 5.228c.24 0 .47-.042.69-.102l21.24-4.222v3.372zm-21.93-3.438a1.72 1.72 0 1 0 .002 3.44 1.72 1.72 0 0 0-.001-3.44z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M32.748 34.564a1.255 1.255 0 0 0 2.508 0v-3.87l2.3-.458c1.507-.362 2.101-4.745 1.973-6.232-.128-1.486-1.442-2.384-2.96-2.036l-1.313.412v-8.226a6.575 6.575 0 0 0-6.568-6.569H19.31a1.253 1.253 0 1 0 0 2.507h9.377a4.065 4.065 0 0 1 4.06 4.061v9.014l-22.66 7.11.002.011a2.664 2.664 0 0 0-1.942 2.558 2.67 2.67 0 0 0 2.671 2.67c.24 0 .467-.042.69-.102l21.239-4.222v3.372zM9.1 32.846a1.72 1.72 0 1 1 3.44 0 1.72 1.72 0 0 1-3.44 0z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M34.155 35.818a1.255 1.255 0 0 1-1.254-1.254v-20.41a4.065 4.065 0 0 0-4.06-4.062h-9.377a1.253 1.253 0 1 1 0-2.507h9.377a6.575 6.575 0 0 1 6.568 6.568v20.411c0 .692-.562 1.254-1.254 1.254z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M39.682 24.004c-.128-1.486-1.442-2.384-2.96-2.036L10.24 30.277l.003.01a2.663 2.663 0 0 0 .728 5.229c.24 0 .468-.042.69-.102l26.048-5.178c1.507-.362 2.101-4.745 1.973-6.232z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "M9.252 32.846a1.72 1.72 0 1 1 3.44 0 1.72 1.72 0 0 1-3.44 0z",
      })
    );
  },
  Sa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm27.068-6.217A13.349 13.349 0 0 0 24 13a13.35 13.35 0 0 0-3.068 4.786A11.918 11.918 0 0 1 24 21.4a11.921 11.921 0 0 1 3.068-3.617zm-10.937-2.524 4.15 3.292a10.507 10.507 0 0 1 3.707 5.528A10.52 10.52 0 0 1 27.7 18.55l4.15-3.292a8.922 8.922 0 0 1 2.516 7.74h-.378a11.007 11.007 0 0 0-10 6.445 11 11 0 0 0-10-6.444h-.377a8.922 8.922 0 0 1 2.52-7.741zM24.001 34h6.8c5.522 0 10-4.477 10-10H34c-5.524 0-10 4.477-10 10zm0 0a10 10 0 0 0-10-10H7.2c0 5.523 4.476 10 10 10H24z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        d: "M13.988 23a11 11 0 0 1 10 6.444 11.007 11.007 0 0 1 10-6.444h.378a8.922 8.922 0 0 0-2.52-7.741L27.7 18.551a10.518 10.518 0 0 0-3.708 5.528 10.508 10.508 0 0 0-3.708-5.528l-4.149-3.292A8.922 8.922 0 0 0 13.611 23h.377z",
      }),
      a("path", {
        d: "M24 21.4a11.918 11.918 0 0 1 3.068-3.614A13.35 13.35 0 0 0 24 13a13.349 13.349 0 0 0-3.068 4.783A11.921 11.921 0 0 1 24 21.4zM14 24H7.2c0 5.523 4.477 10 10 10H24a10 10 0 0 0-10-10zm20 0c-5.523 0-10 4.477-10 10h6.8a10 10 0 0 0 10-10H34z",
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
      })
    );
  },
  ya = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm6.55 10 .77.81L29.78 15l-.94-.34L30.55 10zM27 9.5 26 9v5h1V9.5zm-4.21.93 1.54 4.23-.94.34-1.71-4.7 1.11.13zM29.88 26h9.21L43 17H29l-1 3h-5l.7-2.11.3-.89h-4.5a10.5 10.5 0 0 0-6.35 2.14L12 18a3.536 3.536 0 0 0-5 5l2.23 2.21a10.18 10.18 0 0 0-.26 2.29c0 5.799 4.7 10.5 10.5 10.5 5.799 0 10.5-4.701 10.5-10.5 0-.087.003-.174.007-.26a3.143 3.143 0 0 0-.007-.5 6.431 6.431 0 0 0-.037-.254A3.059 3.059 0 0 1 29.88 26zM9.5 22a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm1.5 5.5h1.48a7 7 0 0 0 6.07 6.93l.9 1.57A8.52 8.52 0 0 1 11 27.5z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "m25.99 9 1 .5V14h-1V9zm4.56.96.77.81L29.78 15l-.94-.34 1.71-4.7zm-6.23 4.7-1.54-4.23-1.11-.13 1.71 4.7.94-.34zM29 17h14l-3.88 9h-9.21c.09.24.09.49.09.74v.76C30 33.299 25.299 38 19.5 38 13.7 38 9 33.299 9 27.5c-.008-.76.07-1.518.23-2.26L7 23a3.536 3.536 0 1 1 5-5l1.12 1.17A10.5 10.5 0 0 1 19.5 17H24l-.3.89L23 20h5l1-3zM8 20.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm3 7h1.5a7 7 0 0 0 6.07 6.94l.9 1.57A8.52 8.52 0 0 1 11 27.5z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M43 17H29l-1 3h-5l.7-2.11.3-.89h-4.5a10.5 10.5 0 0 0-6.38 2.17L12 18a3.536 3.536 0 0 0-5 5l2.23 2.24c-.16.742-.238 1.5-.23 2.26C9 33.299 13.7 38 19.5 38 25.299 38 30 33.299 30 27.5v-.76c0-.25 0-.5-.09-.74h9.21L43 17z",
      }),
      a("path", {
        d: "M9.5 22a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm9.95 14A8.52 8.52 0 0 1 11 27.5h1.5a7 7 0 0 0 6.07 6.94l.88 1.56z",
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
      }),
      a("path", {
        d: "m26.99 9.5-1-.5v5h1V9.5zm4.33 1.27-.77-.81-1.71 4.7.94.34 1.54-4.23zm-7 3.89-1.54-4.23-1.11-.13 1.71 4.7.94-.34z",
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
      })
    );
  },
  Fa = function (l) {
    return a(
      "svg",
      Object.assign(
        { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" },
        l
      ),
      a("circle", {
        className: "at-0 otc-0 ttc-2 ttcw-1",
        fill: "#FFF",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "at-0 ot-2 tt-2 ttc-2 ttcw-2",
        fill: "#002677",
        d: "M38 13H10c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2V15c0-1.1-.9-2-2-2zm-9.5 15H26v3h-4v-3h-3v-4h3v-3h4v3h3.5l-1 4zm9.5-9.99H10V15h28v3.01z",
      }),
      a("path", {
        className: "at-0 tt-3 ttc-3 ttcw-3",
        fill: "#00bed5",
        d: "M38 13H10c-1.1 0-2 .9-2 2v3.01h32V15c0-1.1-.9-2-2-2z",
      }),
      a("path", {
        className: "at-0 ttc-1",
        fill: "transparent",
        d: "M38 33H10V18.01H8V33c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2V18.01h-2V33z",
      }),
      a("path", {
        className: "at-0 ttc-1",
        fill: "#FFF",
        d: "M29.5 24H26v-3h-4v3h-3v4h3v3h4v-3h2.5z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M10 33h28V18.01H10V33zm9-10h3v-3h4v3h3.5l-1 4H26v3h-4v-3h-3v-4z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M24 0C10.75 0 0 10.75 0 24s10.75 24 24 24 24-10.75 24-24S37.25 0 24 0zm16 33c0 1.1-.9 2-2 2H10c-1.1 0-2-.9-2-2V15c0-1.1.9-2 2-2h28c1.1 0 2 .9 2 2v18z",
      })
    );
  },
  Pa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-1 ot-0 otc-0",
        fill: "#fff",
        d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z",
      }),
      a("path", {
        className: "at-0 ttc-2 otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm5 0c0 10.493 8.507 19 19 19a19 19 0 0 0 19-19c0-10.493-8.507-19-19-19S5 13.507 5 24z",
      }),
      a("path", {
        className: "at-2 ttcw-1 ot-0",
        fill: "#fff",
        fillRule: "evenodd",
        d: "m35.38 23.11.79 1.78 3.44.05a15.58 15.58 0 0 1-4.14 9.73l-1.91-1.9-.47 1.23 1.52 1.47a15.55 15.55 0 0 1-9.73 4.14v-4.23l-1.78.79v3.44a15.58 15.58 0 0 1-9.73-4.14l2-2-1.23-.47-1.61 1.59a15.55 15.55 0 0 1-4.14-9.73h4.23l-.79-1.78H8.39a15.58 15.58 0 0 1 4.14-9.73l1.88 1.88.48-1.23-1.52-1.47a15.55 15.55 0 0 1 9.73-4.14v4.23l1.78-.79V8.39a15.55 15.55 0 0 1 9.73 4.14l-1.84 1.84 1.23.48 1.47-1.47a15.55 15.55 0 0 1 4.14 9.73h-4.23zm-13.66 3L24 33.7l2.28-7.59a3.12 3.12 0 0 1-3.47.77 3.17 3.17 0 0 1-1.09-.77zM22.2 24a1.8 1.8 0 1 1 1.8 1.8 1.79 1.79 0 0 1-1.8-1.8zm-.52-2.06a3.12 3.12 0 0 1 3.52-.83l-.01.01c.434.185.82.465 1.13.82L24 14.2l-2.32 7.74z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        d: "M24.89 11.83V5.49h-1.78v7.13l1.78-.79zm-1.78 24.34v6.34h1.78v-7.13l-1.78.79zm13.06-11.28h6.34v-1.78h-7.13l.79 1.78zm-24.34-1.78H5.49v1.78h7.13l-.79-1.78z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#002677",
        d: "m24 33.7-2.28-7.59a3.17 3.17 0 0 0 1.09.77 3.12 3.12 0 0 0 3.47-.77L24 33.7zm1.19-12.58a3.12 3.12 0 0 0-3.52.83L24 14.2l2.32 7.74a3.14 3.14 0 0 0-1.13-.82z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#00BED5",
        d: "M22.2 24a1.8 1.8 0 1 1 1.8 1.8 1.79 1.79 0 0 1-1.8-1.8z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        d: "M24 5C13.507 5 5 13.507 5 24s8.507 19 19 19 19-8.507 19-19A19 19 0 0 0 24 5zm11.47 29.62-1.91-1.9-.47 1.28 1.53 1.52c-5.983 5.574-15.257 5.574-21.24 0l2-2-1.24-.52-1.61 1.61c-5.574-5.983-5.574-15.257 0-21.24l1.88 1.88.48-1.25-1.51-1.5c5.983-5.574 15.257-5.574 21.24 0l-1.84 1.84 1.23.48 1.46-1.47c5.574 5.983 5.574 15.257 0 21.24v.03z",
      })
    );
  },
  Za = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm5 0c0 10.493 8.507 19 19 19a19 19 0 0 0 19-19c0-10.493-8.507-19-19-19S5 13.507 5 24z",
      }),
      a("path", {
        d: "M18.969 7.761a17.061 17.061 0 0 0-9.017 6.7H15a16.882 16.882 0 0 1 3.969-6.7zM15.4 22.916H23v-6.457h-6.648a28.565 28.565 0 0 0-.952 6.457zm1.6-8.457h6V7.5c-2.446.575-4.611 3.219-6 6.959zM23 40.5v-7.128h-6.065C18.326 37.2 20.518 39.917 23 40.5zm-6.7-9.128H23v-6.456h-7.6a28.75 28.75 0 0 0 .9 6.456zm-1.888-14.913H8.779a16.843 16.843 0 0 0-1.734 6.457h6.476a30.46 30.46 0 0 1 .891-6.457zm-.894 8.457h-6.48A16.844 16.844 0 0 0 8.7 31.372h5.669a30.584 30.584 0 0 1-.851-6.456zm-3.683 8.456a17.068 17.068 0 0 0 9.134 6.867 17.035 17.035 0 0 1-4.019-6.867H9.835zm24.644-10.456h6.476a16.842 16.842 0 0 0-1.734-6.457h-5.633a30.46 30.46 0 0 1 .891 6.457zm.003 2a30.577 30.577 0 0 1-.849 6.456H39.3a16.843 16.843 0 0 0 1.66-6.456h-6.478zm-5.451 15.323a17.068 17.068 0 0 0 9.134-6.867H33.05a17.035 17.035 0 0 1-4.019 6.867zm9.017-25.78a17.061 17.061 0 0 0-9.017-6.7 16.882 16.882 0 0 1 3.969 6.7h5.048zM25 33.372V40.5c2.482-.582 4.674-3.3 6.065-7.127L25 33.372zM25 7.5v6.958h6c-1.389-3.739-3.554-6.383-6-6.958zm6.648 8.959H25v6.457h7.6a28.565 28.565 0 0 0-.952-6.457zm.952 8.457H25v6.456h6.7a28.75 28.75 0 0 0 .9-6.456z",
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
      }),
      a("path", {
        className: "at-0 ot-2",
        fillRule: "evenodd",
        d: "M24 5C13.507 5 5 13.507 5 24s8.507 19 19 19 19-8.507 19-19A19 19 0 0 0 24 5zm-1 17.916h-7.6c.07-2.182.389-4.348.952-6.457H23v6.457zm8.648-6.457H25v6.457h7.6a28.565 28.565 0 0 0-.952-6.457zm-18.127 6.457H7.045c.14-2.247.73-4.442 1.734-6.457h5.633a30.474 30.474 0 0 0-.891 6.457zm.849 8.456a30.589 30.589 0 0 1-.849-6.456H7.04a16.844 16.844 0 0 0 1.66 6.456h5.67zm1.03-6.456H23v6.456h-6.7a28.755 28.755 0 0 1-.9-6.456zm17.199 0h-7.6L25 31.372h6.693c.546-2.11.85-4.277.906-6.456zm1.883 0h6.479a16.843 16.843 0 0 1-1.66 6.456h-5.668a30.62 30.62 0 0 0 .849-6.456zm-.892-8.457a30.46 30.46 0 0 1 .89 6.457h6.477a16.842 16.842 0 0 0-1.734-6.457H33.59zm4.458-2H33a16.883 16.883 0 0 0-3.965-6.7 17.061 17.061 0 0 1 9.013 6.7zm-13.048 0h6.005C29.611 10.719 27.446 8.075 25 7.5v6.959zM23 7.5v6.958h-6c1.389-3.739 3.554-6.383 6-6.958zM9.952 14.459a17.061 17.061 0 0 1 9.016-6.698A16.882 16.882 0 0 0 15 14.46H9.952zm-.117 18.913h5.115a17.034 17.034 0 0 0 4.019 6.867 17.068 17.068 0 0 1-9.134-6.867zm13.165 0h-6.065C18.326 37.2 20.518 39.917 23 40.5v-7.128zm2 7.128v-7.128h6.065C29.674 37.2 27.482 39.917 25 40.5zm4.032-.261-.001.001v-.001h.001zm0 0a17.068 17.068 0 0 0 9.133-6.866H33.05a17.036 17.036 0 0 1-4.018 6.866z",
        fill: "#002677",
      }),
      a("path", {
        d: "M41.953 22.916H6.047c-.016.31-.047.616-.047.931 0 .361.033.713.054 1.069h35.892c.021-.356.054-.708.054-1.069 0-.315-.031-.621-.047-.931zm-2.665-8.457H8.712c-.404.643-.765 1.31-1.083 2H40.37c-.318-.69-.68-1.357-1.083-2zM8.8 33.372h30.4c.409-.643.776-1.31 1.1-2H7.7c.324.69.691 1.357 1.1 2z",
        className: "at-3 ot-0 otc-0",
        fill: "#00BED5",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        d: "M24 5C13.507 5 5 13.507 5 24s8.507 19 19 19 19-8.507 19-19A19 19 0 0 0 24 5zM7 24A17.03 17.03 0 0 1 18.969 7.761C15.711 10.9 13.5 17 13.5 24s2.211 13.1 5.469 16.239A17.03 17.03 0 0 1 7 24zm8.373 0c0-8.361 3.4-15.508 7.627-16.5v33c-4.225-.992-7.627-8.139-7.627-16.5zM25 40.5v-33c4.225.991 7.627 8.138 7.627 16.5S29.225 39.508 25 40.5zm4.031-.26C32.289 37.1 34.5 31.005 34.5 24c0-7.005-2.211-13.1-5.469-16.239a17 17 0 0 1 0 32.478v.001z",
        fill: "#002677",
      })
    );
  },
  ka = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.666 4.045a24 24 0 1 1 26.668 39.91 24 24 0 0 1-26.668-39.91zM24 41l10.26-14.73a12.36 12.36 0 1 0-20.52 0L24 41z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-2",
        fill: "#00bed5",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.985 13.353A7.22 7.22 0 0 1 24 12.14a7.211 7.211 0 0 1 7.21 7.21 7.22 7.22 0 1 1-11.225-5.997zM25.5 21H28l1-3h-3.5v-3h-3v3h-3v3h3v3h3v-3z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M35.031 13.803a12.36 12.36 0 0 1 1.329 5.557 12.311 12.311 0 0 1-2.11 6.91L24 41 13.74 26.27a12.36 12.36 0 1 1 21.29-12.467zm-15.6 12.386A8.22 8.22 0 1 0 28.55 12.51a8.22 8.22 0 0 0-9.12 13.68z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M34.26 26.27a12.36 12.36 0 1 0-20.52 0L24 41l10.25-14.73h.01z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M31.21 19.35a7.21 7.21 0 1 1-14.42 0 7.21 7.21 0 0 1 14.42 0z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-1",
        fill: "#fff",
        d: "M29 18h-3.5v-3h-3v3h-3v3h3v3h3v-3H28l1-3z",
      })
    );
  },
  Ta = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        d: "M24 0a24 24 0 1 0 0 48 24 24 0 0 0 0-48zm10.26 26.27L24 41 13.74 26.27a12.36 12.36 0 1 1 20.52 0z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "transparent",
        d: "M36.36 19.36a12.36 12.36 0 1 0-22.62 6.91L24 41l10.25-14.73a12.311 12.311 0 0 0 2.11-6.91zm-10.21-8.08a3.17 3.17 0 0 1 3.19.34 3.211 3.211 0 0 1-5.08 2.25 3.22 3.22 0 0 1 1.89-2.59zm4.09 10.27-.86 1.92s-1.16 2.6-1.21 2.7a3.41 3.41 0 0 1-3 1.83 3.45 3.45 0 0 1-1.44-.32 3.45 3.45 0 0 1-1.44.32 3.41 3.41 0 0 1-3-1.83c-.05-.1-1.2-2.7-1.2-2.7l-.86-1.92a4.43 4.43 0 0 1 2.25-5.85 4.38 4.38 0 0 1 3.73.06v-1.41l1.08-.48v1.89a4.43 4.43 0 0 1 6 5.79h-.05z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M34.26 26.27a12.36 12.36 0 1 0-20.52 0L24 41l10.25-14.73h.01z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "M27.45 14.21a3.2 3.2 0 0 0 1.89-2.59 3.17 3.17 0 0 0-3.19-.34 3.22 3.22 0 0 0-1.89 2.59 3.22 3.22 0 0 0 3.19.34z",
      }),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        d: "M28 15.7a4.381 4.381 0 0 0-3.73.06v-1.89l-1.08.48v1.41a4.38 4.38 0 0 0-3.73-.06 4.43 4.43 0 0 0-2.25 5.85l.86 1.92s1.15 2.6 1.2 2.7a3.41 3.41 0 0 0 3 1.83 3.45 3.45 0 0 0 1.44-.32c.451.21.943.318 1.44.32a3.41 3.41 0 0 0 3-1.83c.05-.1 1.21-2.7 1.21-2.7l.86-1.92A4.419 4.419 0 0 0 28 15.7z",
      })
    );
  },
  Ga = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.03 40.97c9.373 9.373 24.568 9.373 33.941 0 9.372-9.372 9.372-24.567 0-33.94-9.373-9.372-24.568-9.372-33.941 0-9.372 9.373-9.372 24.568 0 33.94zm18.98-29.697c2.895-2.895 7.759-2.96 10.718 0 2.96 2.959 2.895 7.823 0 10.718L21.99 36.727c-2.895 2.896-7.76 2.96-10.718 0-2.96-2.958-2.895-7.822 0-10.717L26.01 11.271z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.233 17.878a1.992 1.992 0 0 1 1.414-.583c.513 0 1.025.194 1.414.583l5.062 5.062c.778.777.778 2.05 0 2.828l-5.062 5.06c-.39.39-.901.585-1.414.585a1.989 1.989 0 0 1-1.414-.584l-5.062-5.061a2.005 2.005 0 0 1 0-2.828l5.062-5.062zm2.12.707a.992.992 0 0 0-.706-.29.992.992 0 0 0-.707.29l-5.062 5.062a1.003 1.003 0 0 0 0 1.414l5.062 5.06a.989.989 0 0 0 .707.292c.269 0 .52-.103.707-.291l5.062-5.061a1.003 1.003 0 0 0 0-1.414l-5.062-5.062z",
      }),
      a("path", {
        className: "at-0 ot-2 ttc-1 ttcw-2",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.01 11.272c2.894-2.895 7.758-2.96 10.718 0s2.895 7.823 0 10.718L21.99 36.727c-2.894 2.895-7.758 2.96-10.718 0-2.96-2.959-2.895-7.823 0-10.718L26.01 11.272zM22.232 30.83a2.006 2.006 0 0 0 2.829 0l5.062-5.062a2.007 2.007 0 0 0 0-2.828l-5.062-5.061a2.005 2.005 0 0 0-2.828 0l-5.062 5.061a2.007 2.007 0 0 0 0 2.828l5.06 5.062zm-3.293 4.597a.587.587 0 1 1-.83-.831.587.587 0 0 1 .83.83zm-3.597-2.768a.587.587 0 1 0 .83-.831.587.587 0 0 0-.83.831zm-1.937-2.767a.587.587 0 1 1-.83-.83.587.587 0 0 1 .83.83zm2.93-1.032a.587.587 0 1 0 .83-.83.587.587 0 0 0-.83.83zm3.64 2.81a.587.587 0 1 1-.83-.831.587.587 0 0 1 .83.83zm-5.623 4.792a.587.587 0 1 0 .83-.831.587.587 0 0 0-.83.83zm-1.98-2.81a.587.587 0 1 1-.83-.83.587.587 0 0 1 .83.83zM33.89 19.645a.587.587 0 1 0 .83-.83.587.587 0 0 0-.83.83zm-1.937-2.766a.587.587 0 1 1-.83-.831.587.587 0 0 1 .83.83zm-3.597-2.768a.587.587 0 1 0 .83-.83.587.587 0 0 0-.83.83zm4.59-1.032a.587.587 0 1 1-.83-.831.587.587 0 0 1 .83.831zm1.98 2.81a.587.587 0 1 0 .83-.831.587.587 0 0 0-.83.83zm-3.963 4.792a.587.587 0 1 1-.83-.83.587.587 0 0 1 .83.83zm-3.64-2.81a.587.587 0 1 0 .83-.831.587.587 0 0 0-.83.831z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-1",
        fill: "#fff",
        d: "M25.06 30.83a2.006 2.006 0 0 1-2.828 0l-5.061-5.063a2.007 2.007 0 0 1 0-2.828l5.062-5.06a2.005 2.005 0 0 1 2.828 0l5.062 5.06a2.007 2.007 0 0 1 0 2.828L25.06 30.83z",
      }),
      a(
        "g",
        { className: "at-2 ot-0 ttcw-3", fill: "#00BED5" },
        a("circle", { cx: 15.75, cy: 32.243, r: 0.601 }),
        a("circle", { cx: 30.545, cy: 20.284, r: 0.601 }),
        a("circle", { cx: 27.74, cy: 17.471, r: 0.601 }),
        a("circle", { cx: 31.531, cy: 16.483, r: 0.601 }),
        a("circle", { cx: 34.315, cy: 19.243, r: 0.601 }),
        a("circle", { cx: 28.768, cy: 13.711, r: 0.601 }),
        a("circle", { cx: 32.534, cy: 12.666, r: 0.601 }),
        a("circle", { cx: 35.349, cy: 15.489, r: 0.601 }),
        a("circle", { cx: 13.015, cy: 29.471, r: 0.601 }),
        a("circle", { cx: 11.952, cy: 33.247, r: 0.601 }),
        a("circle", { cx: 14.764, cy: 36.059, r: 0.601 }),
        a("circle", { cx: 18.514, cy: 35.014, r: 0.601 }),
        a("circle", { cx: 19.534, cy: 31.268, r: 0.601 }),
        a("circle", { cx: 16.748, cy: 28.461, r: 0.601 })
      )
    );
  },
  Wa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm40 5v4h2V23a3 3 0 0 0-3-3H20a4 4 0 0 0-4-4h-6v-4H8v21h2v-4h30z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M39 20H20a4 4 0 0 0-4-4h-6v-4H8v21h2v-4h30v4h2V23a3 3 0 0 0-3-3zm-23-2a2.002 2.002 0 0 1 2 2h-8v-2h6zm-6 9h5.872l2.975-5H10v5z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M39 20H10v-8H8v21h2v-4h30v4h2V23a3 3 0 0 0-3-3z",
      }),
      a("path", {
        className: "at-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        d: "M10 27h5.872l2.975-5H10v5z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M10 16h6a4 4 0 0 1 4 4H10v-4z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M16 18h-6v2h8a2.002 2.002 0 0 0-2-2z",
      })
    );
  },
  Ua = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M31.92 21.83c0 1.64-1.07 3-2.38 3a2.74 2.74 0 0 1-2.39-3v-4.59h4.77v4.59zm0-5.74h-4.77v-5.9h4.77v5.9zM18.15 29.78c1.31 0 2.38-1.36 2.38-3V22.2h-4.76v4.58c0 1.66 1.07 3 2.38 3zm-2.38-8.74h4.76v-5.9h-4.76v5.9z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm9.13-41.17a10.57 10.57 0 0 1-7.19 0 1.4 1.4 0 0 0-1.4 1.4 1.41 1.41 0 0 0 1.4 1.41v12.14a4.06 4.06 0 0 0 3 4.12v6.89l-.55.25v1.81a1.16 1.16 0 0 0 1.18 1.27c.7 0 1.13-.52 1.13-1.39V32l-.55.25V25.9a4.06 4.06 0 0 0 3-4.12V9.64a1.41 1.41 0 0 0 0-2.81h-.02zm-14.9 5.58a10.6 10.6 0 0 0 3.51-.63h.02a1.41 1.41 0 1 1 0 2.81v12.14a4.07 4.07 0 0 1-3 4.12v6.34l.56-.25v2.74c0 .87-.43 1.39-1.13 1.39A1.169 1.169 0 0 1 17 39.8V38l.55-.26v-6.89a4.06 4.06 0 0 1-3-4.12V14.59a1.41 1.41 0 0 1 0-2.81 10.64 10.64 0 0 0 3.68.63z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M25.92 9.64v12.15a4.06 4.06 0 0 0 3 4.12v6.89l1.21-.55v-6.34a4.06 4.06 0 0 0 3-4.12V9.64a12.08 12.08 0 0 0-7.21 0zm6 12.15a2.73 2.73 0 0 1-2.38 3 2.73 2.73 0 0 1-2.39-3v-4.54h4.77v4.54zm0-5.74h-4.8v-5.86h4.77l.03 5.86z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1",
        fill: "#002677",
        d: "M33.1 6.84c-1.13.408-2.32.62-3.52.63a10.81 10.81 0 0 1-3.67-.63 1.4 1.4 0 0 0-1.4 1.4 1.41 1.41 0 0 0 1.4 1.41 12.08 12.08 0 0 1 7.17 0 1.41 1.41 0 0 0 0-2.81h.02zm-4.75 26.21v1.8a1.17 1.17 0 0 0 1.18 1.28c.7 0 1.13-.52 1.13-1.39V32l-2.31 1.05z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "M14.53 14.66v12.15a4.06 4.06 0 0 0 3 4.12v6.89l1.2-.55v-6.34a4.07 4.07 0 0 0 3-4.12V14.67a12 12 0 0 0-7.2-.01zm6 12.15c0 1.64-1.07 3-2.38 3-1.31 0-2.38-1.34-2.38-3v-4.54h4.73l.03 4.54zm0-5.74h-4.79v-5.85h4.76l.03 5.85z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1",
        fill: "#002677",
        d: "M21.71 11.86a10.6 10.6 0 0 1-3.51.63 10.66 10.66 0 0 1-3.68-.63 1.41 1.41 0 0 0 0 2.81 12 12 0 0 1 7.18 0 1.41 1.41 0 1 0 0-2.81h.01zM17 38.07v1.81a1.168 1.168 0 0 0 1.19 1.27c.7 0 1.13-.52 1.13-1.39V37L17 38.07z",
      }),
      "--\x3e"
    );
  },
  Qa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm0 38a38.86 38.86 0 0 1-15.5-3.21v-4.23a3 3 0 0 0 5.5 1.6 3 3 0 0 0 2.5 1.34 3 3 0 0 0 2.5-1.35 3 3 0 0 0 5 0 3 3 0 0 0 5 0 3 3 0 0 0 5 0 3 3 0 0 0 5.5-1.66v4.29A38.86 38.86 0 0 1 24 38zm-7.51-20v4h7v-4a3.5 3.5 0 1 0-7 0zm7 10v2.5a2 2 0 1 1-4 0V28h4zm-5 2.5V28h-4v2.5a2 2 0 0 0 4 0zm-3-8.5h-6v-3.5a3 3 0 1 1 6 0V22zm-2 8.5V28h-4v2.5a2 2 0 1 0 4 0zm19-8.5v-3.5a3 3 0 0 1 6 0V22h-6zm6 8.5V28h-4v2.5a2 2 0 0 0 4 0zm-5-2.5v2.5a2 2 0 1 1-4 0V28h4zm-9-6h7v-4a3.5 3.5 0 1 0-7 0v4zm4 6v2.5a2 2 0 1 1-4 0V28h4zm8.153-13.35a4 4 0 0 1 2.847 3.835l.01-5.995a36.16 36.16 0 0 0-31 0v5.94a4 4 0 0 1 7.33-2.15 4.51 4.51 0 0 1 8.17-.35 4.5 4.5 0 0 1 8.15.35 4 4 0 0 1 4.493-1.63z",
      }),
      a("path", {
        d: "M39.49 27h-31v7.79A38.86 38.86 0 0 0 24 38a38.929 38.929 0 0 0 15.5-3.21L39.49 27zm-5 1h4v2.5a2 2 0 1 1-4 0V28zm-1 0h-4v2.5a2 2 0 0 0 4 0V28zm-9 0h4v2.5a2 2 0 1 1-4 0V28zm-1 0h-4v2.5a2 2 0 0 0 4 0V28zm-9 0h4v2.5a2 2 0 1 1-4 0V28zm-1 0h-4v2.5a2 2 0 1 0 4 0V28zm26.02-15.51a36.16 36.16 0 0 0-31 0L8.49 23h31l.02-10.51zM9.49 22v-3.5a3 3 0 1 1 6 0V22h-6zm7-4v4h7v-4a3.5 3.5 0 1 0-7 0zm15 4h-7v-4a3.5 3.5 0 1 1 7 0v4zm1-3.5V22h6v-3.5a3 3 0 1 0-6 0z",
        className: "at-0 ot-2",
        fill: "#002677",
        fillRule: "evenodd",
      }),
      a("path", {
        d: "M35.49 14.5a4 4 0 0 0-3.34 1.79 4.5 4.5 0 0 0-8.15-.35 4.51 4.51 0 0 0-8.17.35 4 4 0 0 0-7.33 2.15V23h31v-4.5a4 4 0 0 0-4.01-4zm-27 16.06a3 3 0 0 0 5.5 1.6 3 3 0 0 0 2.5 1.34A3 3 0 0 0 19 32.15a3 3 0 0 0 5 0 3 3 0 0 0 5 0 3 3 0 0 0 5 0 3 3 0 0 0 5.5-1.66V27h-31l-.01 3.56z",
        className: "at-0 ttc-2 ttcw-2",
        fill: "#002677",
      }),
      a("path", {
        d: "M31.49 18a3.5 3.5 0 1 0-7 0v4h7v-4zm-16 .5a3 3 0 0 0-6 0V22h6v-3.5zm4.51-4a3.5 3.5 0 0 0-3.5 3.5v4h7v-4a3.5 3.5 0 0 0-3.5-3.5zm15.49 1a3 3 0 0 0-3 3V22h6v-3.5a3 3 0 0 0-3-3zm-16 15a2 2 0 1 0 4 0V28h-4v2.5zm5 0a2 2 0 1 0 4 0V28h-4v2.5zm10 0a2 2 0 1 0 4 0V28h-4v2.5zm-5 0a2 2 0 1 0 4 0V28h-4v2.5zm-15 0a2 2 0 1 0 4 0V28h-4v2.5zm-5 0a2 2 0 1 0 4 0V28h-4v2.5z",
        className: "at-0 ttc-1 ttcw-1",
        fill: "#fff",
      }),
      a("path", {
        d: "M36.49 33.5A3 3 0 0 1 34 32.16a3 3 0 0 1-5 0 3 3 0 0 1-2.5 1.35 3 3 0 0 1-2.5-1.35 3 3 0 0 1-5 0 3 3 0 0 1-2.5 1.35 3 3 0 0 1-2.5-1.35 3 3 0 0 1-5.5-1.6v4.23A38.86 38.86 0 0 0 24 38a38.86 38.86 0 0 0 15.5-3.21V30.5a3 3 0 0 1-3.01 3zm-24-19a4 4 0 0 1 3.33 1.79 4.51 4.51 0 0 1 8.18-.35 4.5 4.5 0 0 1 8.16.35 4 4 0 0 1 7.34 2.21v-6a36.16 36.16 0 0 0-31 0v6a4 4 0 0 1 3.99-4z",
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
      })
    );
  },
  $a = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24zm36 17V11a2 2 0 0 0 0-4H12a2 2 0 0 0 0 4v30h9a3 3 0 1 0 6 0h9z",
      }),
      a("path", {
        className: "ot-0 otc-2",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M14 39h20V11H14v28zm9.926-3.89c-1.127 0-1.878-.797-1.878-1.987 0-1.207.745-1.992 1.9-1.992 1.088 0 1.839.814 1.839 1.992 0 1.184-.75 1.987-1.861 1.987zm7.05-.792h-1.423c-.205 0-.375.006-.762.024l.245-.26c.114-.12.131-.139.177-.196l1.695-2.032v-.632H27.91v.7h1.264c.2 0 .341-.005.602-.014l.086-.003a6.688 6.688 0 0 0-.348.364l-1.747 2.089v.66h3.21v-.7zm-1.572-10.463c.443.296.677.771.677 1.37 0 .537-.194.973-.56 1.284-.319.265-.7.374-1.292.374h-1.168v1.868h-1.128v-5.19h2.086c.708 0 1.058.076 1.385.294zm-2.41-10.071h-5.439v7.256h5.515v-1.338h-3.938v-1.773h3.547v-1.251h-3.547v-1.556h3.862v-1.338zm-8.24 9.776h3.649v.957h-2.521v1.206h2.195v.895h-2.195v2.132h-1.128v-5.19zm1.351 7.662H16.98v.7h1.145v3.096h.825v-3.096h1.155v-.7z",
      }),
      a("path", {
        d: "M28.719 25.824c.155-.124.249-.334.249-.583 0-.249-.102-.459-.288-.583-.14-.101-.343-.14-.669-.14h-.95v1.471h1.012c.311-.002.513-.048.646-.165zm-4.781 5.996c-.648 0-1.053.495-1.053 1.298 0 .802.398 1.303 1.047 1.303.626 0 1.019-.506 1.019-1.315 0-.779-.399-1.286-1.013-1.286z",
        className: "at-1 ot-0 otc-2",
        fill: "#fff",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M12 7h24a2 2 0 0 1 0 4v30h-9a3 3 0 1 1-6 0h-9V11a2 2 0 0 1 0-4zm2 32h20V11H14v28z",
      }),
      a(
        "g",
        { className: "at-2 otc-0", fill: "#002677" },
        a("path", {
          d: "M27.071 19.703h-3.939V17.93h3.547v-1.252h-3.547v-1.555h3.863v-1.339h-5.44v7.257h5.516v-1.338zm-7.189 6.915h2.196v-.895h-2.196v-1.206h2.522v-.957h-3.65v5.19h1.128v-2.132z",
        }),
        a("path", {
          fillRule: "evenodd",
          d: "M27.061 28.75h-1.128v-5.19h2.086c.708 0 1.058.076 1.385.294.444.296.677.771.677 1.37 0 .537-.195.973-.56 1.284-.319.265-.7.374-1.292.374h-1.168v1.868zm.95-4.233h-.95v1.47h1.012c.311 0 .513-.047.646-.164.155-.124.249-.334.249-.583 0-.249-.101-.458-.288-.583-.14-.1-.343-.14-.669-.14z",
        }),
        a("path", {
          d: "M18.125 35.019h.825v-3.097h1.155v-.7H16.98v.7h1.145v3.097z",
        }),
        a("path", {
          fillRule: "evenodd",
          d: "M22.049 33.123c0-1.207.745-1.992 1.9-1.992 1.088 0 1.839.814 1.839 1.992 0 1.184-.751 1.987-1.861 1.987-1.127 0-1.878-.797-1.878-1.987zm.836-.005c0 .802.399 1.303 1.047 1.303.626 0 1.019-.506 1.019-1.315 0-.779-.4-1.286-1.013-1.286-.65 0-1.053.495-1.053 1.298z",
        }),
        a("path", {
          d: "M30.908 31.854v-.632h-2.999v.7h1.264c.222 0 .37-.006.688-.017a7.13 7.13 0 0 0-.348.364l-1.747 2.089v.66h3.21v-.7h-1.423c-.205 0-.375.006-.763.023.348-.37.354-.37.422-.456l1.696-2.031z",
        })
      ),
      a("path", {
        d: "M24 44a3 3 0 0 0 3-3h-6a3 3 0 0 0 3 3zM36 7H12a2 2 0 0 0 0 4h24a2 2 0 0 0 0-4z",
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M34 11v28H14V11h-2v30h24V11h-2z",
      })
    );
  },
  _a = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm27.354 11.46A7.992 7.992 0 0 0 34 39a7.981 7.981 0 0 0 7.202-11.462h.007l-8-17.817a1 1 0 0 0-1.317-.5L27 11.394v2.189l4.795-2.13 5.51 12.27a7.952 7.952 0 0 0-9.7 2.489 5.97 5.97 0 0 0-7.211 0A7.953 7.953 0 0 0 10.7 23.72l5.51-12.268 4.765 2.119v-2.19l-4.857-2.156a1 1 0 0 0-1.318.5l-8 17.817a8 8 0 1 0 14.6.425 3.978 3.978 0 0 1 5.2 0 7.992 7.992 0 0 0 .754 7.492z",
      }),
      a("path", {
        d: "M14 37a6 6 0 1 0 0-12 6 6 0 0 0 0 12zm20 0a6 6 0 1 0 0-12 6 6 0 0 0 0 12z",
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M41.2 27.544h.007l-8-17.817a1 1 0 0 0-1.317-.5L27 11.394v2.189l4.793-2.13 5.507 12.27a7.952 7.952 0 0 0-9.7 2.489 5.97 5.97 0 0 0-7.212 0A7.953 7.953 0 0 0 10.7 23.72l5.51-12.268 4.758 2.114v-2.19L16.111 9.22a1 1 0 0 0-1.318.5l-8 17.817a8 8 0 1 0 14.6.425 3.978 3.978 0 0 1 5.2 0 8 8 0 1 0 14.6-.424l.007.005zM14 37a6 6 0 1 1 6-6 6.006 6.006 0 0 1-6 6zm14-6a6 6 0 0 0 6 6 6.006 6.006 0 0 0 6-6 6 6 0 0 0-12 0z",
      }),
      a("path", {
        d: "M39.26 28.11 28.34 33a6 6 0 1 0 10.92-4.89zM8.34 33a6 6 0 1 0 10.92-4.89L8.34 33z",
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
      })
    );
  },
  qa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm24 14.75 12.906-12.903a7.886 7.886 0 0 0-11.153-11.153L24 16.446l-1.753-1.752A7.886 7.886 0 1 0 11.1 25.85L24 38.75z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "M16.671 14.384a5.886 5.886 0 0 0-4.162 10.049l1.752 1.753 8.325-8.325-1.753-1.753a5.85 5.85 0 0 0-4.162-1.724z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        fillRule: "evenodd",
        d: "M31.33 12.384a7.886 7.886 0 0 1 5.57 13.465L24 38.749 11.094 25.847a7.886 7.886 0 0 1 11.153-11.153L24 16.446l1.753-1.752a7.886 7.886 0 0 1 5.576-2.31zm-16.912 2.449a5.887 5.887 0 0 0-1.909 9.6l1.752 1.753 8.325-8.325-1.753-1.753a5.887 5.887 0 0 0-6.415-1.275z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        d: "M36.906 14.694a7.887 7.887 0 0 0-11.154 0L12.847 27.6 24 38.749l12.9-12.9a7.888 7.888 0 0 0 .006-11.155z",
      })
    );
  },
  Ja = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M24 0a24 24 0 1 0 0 48 24 24 0 0 0 0-48zm-7 43h-2c0-4 2.53-6.38 5.59-8.37.64.4 1.3.78 1.94 1.16C19.48 37.64 17 39.65 17 43zm14 0a5.94 5.94 0 0 0-.8-3h-8.53L21 38.5h8.07a25.33 25.33 0 0 0-5.57-3.88C19.32 32.2 15 29.7 15 24.5c0-4 2.53-6.38 5.59-8.37.64.4 1.3.78 1.94 1.16a17.393 17.393 0 0 0-3.6 2.71H27l-.67 1.5h-8.54a6 6 0 0 0-.74 2.25h11.62l-.67 1.5H17c.098.794.356 1.56.76 2.25H27l-.67 1.5h-7.4a25.332 25.332 0 0 0 5.57 3.88C28.68 35.3 33 37.8 33 43h-2zm-3.59-10.13c-.64-.4-1.3-.78-1.94-1.16C28.52 29.86 31 27.85 31 24.5c0-4.05-3.64-6.15-7.5-8.38C19.32 13.7 15 11.2 15 6h2c0 4.05 3.64 6.15 7.5 8.38C28.68 16.8 33 19.3 33 24.5c0 3.98-2.53 6.38-5.59 8.37zm0-18.5c-.64-.4-1.3-.78-1.94-1.16a17.39 17.39 0 0 0 3.6-2.71h-7.4L21 9h9.21A5.93 5.93 0 0 0 31 6h2c0 4-2.53 6.38-5.59 8.37z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        d: "M28 25.25H16v-1.5h12.67l-.67 1.5zM27 20H17v1.5h9.33L27 20zm0 7.5H17V29h9.33l.67-1.5zM21 9l.67 1.5H31V9H21zm.67 31H31v-1.5H21l.67 1.5z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        d: "M27.41 14.37c-.64-.4-1.3-.78-1.94-1.16C28.52 11.36 31 9.35 31 6h2c0 4-2.53 6.38-5.59 8.37zM24.5 32.88c-3.86-2.23-7.5-4.33-7.5-8.38 0-3.35 2.48-5.36 5.53-7.21-.64-.38-1.3-.76-1.94-1.16-3.06 2-5.59 4.39-5.59 8.37 0 5.2 4.32 7.7 8.5 10.12C27.36 36.85 31 39 31 43h2c0-5.2-4.32-7.7-8.5-10.12zM15 43h2c0-3.35 2.48-5.36 5.53-7.21-.64-.38-1.3-.76-1.94-1.16C17.53 36.62 15 39 15 43zm9.5-28.62C20.64 12.15 17 10.05 17 6h-2c0 5.2 4.32 7.7 8.5 10.12 3.86 2.23 7.5 4.33 7.5 8.38 0 3.35-2.48 5.36-5.53 7.21.64.38 1.3.76 1.94 1.16 3.06-2 5.59-4.39 5.59-8.37 0-5.2-4.32-7.7-8.5-10.12z",
      })
    );
  },
  Ka = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 48 48",
        },
        l
      ),
      a(
        "g",
        { clipPath: "url(#a)" },
        a("circle", {
          className: "at-0 otc-0 ttc-2 ttcw-1",
          fill: "#fff",
          cx: 24,
          cy: 24,
          r: 24,
        }),
        a("path", {
          className: "ot-0 otc-2",
          fill: "#00BED5",
          d: "M16 28a8 8 0 0 0 16 0V17l-16 7v4z",
        }),
        a("path", {
          className: "otc-0 ttc-1",
          fill: "#002677",
          fillRule: "evenodd",
          d: "M25 12h7a2 2 0 0 1 2 2v14a10 10 0 0 1-7 9.54v.55a3 3 0 0 1-2 2.82v3.78l-2-1v-2.75a3 3 0 0 1-2-2.82v-.55A10 10 0 0 1 14 28V14a2 2 0 0 1 2-2h7V9.82A3 3 0 0 1 21 7V6h2v1a1 1 0 0 0 2 0V6h14.88a21.2 21.2 0 0 1 2 2H26.82A3 3 0 0 1 25 9.82V12zm-6.657 21.657A8 8 0 0 1 16 28v-4l16-7v11a8 8 0 0 1-13.657 5.657z",
        }),
        a("path", {
          className: "at-0 ot-0 otc-2 tt-0 ttc-0 ttcw-0",
          d: "m16 24 16-7v11a8 8 0 1 1-16 0v-4zM41.88 8H26.82A3 3 0 0 1 25 9.82V12h7a2 2 0 0 1 2 2v14a10 10 0 0 1-7 9.57v.55a3 3 0 0 1-2 2.82v3.75l-2-1v-2.78a3 3 0 0 1-2-2.82v-.55A10 10 0 0 1 14 28V14a2 2 0 0 1 2-2h7V9.82A3 3 0 0 1 21 7V6h2v1a1 1 0 0 0 2 0V6h14.86a24 24 0 1 0 2 2h.02z",
        })
      ),
      a(
        "defs",
        null,
        a(
          "clipPath",
          { id: "a" },
          a("path", { fill: "#fff", d: "M0 0h48v48H0z" })
        )
      )
    );
  },
  Xa = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M24 0a24 24 0 1 0 0 48 24 24 0 0 0 0-48zm-6.65 17.23 4.88-11a1 1 0 0 1 1.32-.5l4.56 2a1 1 0 0 1 .51 1.32l-1.47 3.3A10 10 0 0 1 31 27.51a5.51 5.51 0 0 0-4.17-4.85 3.91 3.91 0 0 0-2.1-4.76l-1 2.17a1 1 0 0 1-1.32.51l-4.57-2a1 1 0 0 1-.49-1.35zm-.26 3.16.4-.91 4.52 2-.4.92a1 1 0 0 1-1.32.5l-2.7-1.2a1 1 0 0 1-.5-1.31zM35.5 38h-23a1.5 1.5 0 1 1 0-3H22v-6h-9l-1-2h10.16A3.49 3.49 0 0 1 29 28v.44A6.55 6.55 0 0 0 35.56 35h-.06a1.5 1.5 0 1 1 0 3z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
        d: "m22 21.49-.4.92a1 1 0 0 1-1.32.5l-2.7-1.2a1 1 0 0 1-.5-1.32l.4-.91 4.52 2v.01zm1.73-1.42 1-2.17a3.91 3.91 0 0 1 2.1 4.76A5.51 5.51 0 0 1 31 27.51a9.998 9.998 0 0 0-3.83-15.1l1.47-3.3a1 1 0 0 0-.51-1.32l-4.56-2a1 1 0 0 0-1.32.5l-4.88 11a1 1 0 0 0 .5 1.32l4.57 2a1 1 0 0 0 1.3-.54h-.01zM37 36.5a1.5 1.5 0 0 1-1.5 1.5h-23a1.5 1.5 0 1 1 0-3H22v-6h-9l-1-2h10.16A3.49 3.49 0 0 1 29 28v.44A6.55 6.55 0 0 0 35.56 35h-.06a1.5 1.5 0 0 1 1.5 1.5zM27 28a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-0",
        fill: "#00BED5",
        d: "m22.42 20.58-.81 1.83a1 1 0 0 1-1.32.51l-2.7-1.2a1 1 0 0 1-.5-1.32l.81-1.83 4.52 2.01zM12 27l1 2h9v-1a3.27 3.27 0 0 1 .15-1H12z",
      }),
      a("circle", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        cx: 25.5,
        cy: 28,
        r: 1.6,
      })
    );
  },
  Ya = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm31.58 10.42V13.58a7.58 7.58 0 0 0-15.16 0v20.84a7.58 7.58 0 0 0 15.16 0z",
      }),
      a("path", {
        className: "ot-0 otc-2 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M24 8a5.65 5.65 0 0 0-5.58 5.58v12.8l11.16-4.84v-8A5.65 5.65 0 0 0 24 8z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        fillRule: "evenodd",
        d: "M16.42 13.58A7.64 7.64 0 0 1 24 6a7.64 7.64 0 0 1 7.58 7.58v20.84a7.58 7.58 0 0 1-15.16 0V13.58zM24 8a5.58 5.58 0 0 0-5.58 5.58v12.8l11.16-4.8v-8A5.58 5.58 0 0 0 24 8z",
      }),
      a("path", {
        className: "at-2 ttc-3 otc-0",
        fill: "#002677",
        d: "M16.42 34.42a7.58 7.58 0 0 0 15.16 0V20.67l-15.16 6.58v7.17z",
      })
    );
  },
  al = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 0C10.75 0 0 10.75 0 24c0 10.81 7.16 19.96 17 22.96 2.21.68 4.56 1.04 7 1.04 2.44 0 4.79-.36 7-1.04 9.84-3 17-12.15 17-22.96C48 10.75 37.25 0 24 0zm-6.37 11.99c1.79 1.44 4.05 2.24 6.37 2.24 2.32 0 4.58-.8 6.37-2.24l1.42 1.42-.08.06a12.152 12.152 0 0 1-15.42 0l-.08-.06 1.42-1.42zM5 24.62C8.63 31.39 15.78 36 24 36s15.37-4.61 19-11.38l-10.5-10.5-.11.09-.04.03A13.157 13.157 0 0 1 24 17.23c-3.04 0-6.01-1.06-8.31-2.96l-.08-.06-.11-.09L5 24.62z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m25.407 21.778.212-.21a5.316 5.316 0 0 1 7.537 0 5.281 5.281 0 0 1 1.564 3.767c0 1.37-.514 2.73-1.564 3.78l-.16.16c-4.967 4.966-13.03 4.966-17.996 0-.092-.092-.178-.189-.263-.284l-.125-.139a5.747 5.747 0 0 1-1.29-3.608c0-.73.148-1.45.445-2.124v-.023c.069-.137.137-.262.206-.388.229-.41.514-.799.868-1.142.149-.149.297-.286.457-.4a3.045 3.045 0 0 1 .468-.343c.033-.018.065-.038.098-.057.07-.041.14-.082.21-.114a.238.238 0 0 1 .103-.057 1.29 1.29 0 0 1 .285-.137 2.9 2.9 0 0 1 .4-.16.64.64 0 0 0 .045-.017l.046-.017c.125-.046.25-.08.388-.103.229-.068.469-.102.697-.125a4.75 4.75 0 0 1 .57-.034c1.37 0 2.73.525 3.769 1.564l.212.211a2 2 0 0 0 2.818 0zM24 30.012l2.514-2.513a1.463 1.463 0 1 0-2.07-2.071l-.444.444-.444-.444a1.463 1.463 0 1 0-2.07 2.07L24 30.012z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 36c8.22 0 15.37-4.61 19-11.38l-10.5-10.5-.11.09-.04.03A13.157 13.157 0 0 1 24 17.23c-3.04 0-6.01-1.06-8.31-2.96l-.08-.06-.11-.09L5 24.62C8.63 31.39 15.78 36 24 36zm9.155-14.433a5.281 5.281 0 0 1 1.564 3.768 5.312 5.312 0 0 1-1.563 3.78l-.16.16c-4.967 4.967-13.03 4.967-17.996 0-.092-.091-.178-.188-.263-.283l-.125-.139a5.747 5.747 0 0 1-1.29-3.608c0-.73.148-1.45.445-2.124v-.023c.069-.137.137-.262.206-.388.229-.41.514-.799.868-1.142.149-.149.297-.286.457-.4a3.045 3.045 0 0 1 .468-.343c.033-.018.065-.037.098-.057.07-.041.14-.082.21-.114a.238.238 0 0 1 .103-.057 1.29 1.29 0 0 1 .285-.137 2.9 2.9 0 0 1 .4-.16.64.64 0 0 0 .045-.017l.046-.017c.125-.046.25-.08.388-.103.229-.069.469-.103.697-.126a4.75 4.75 0 0 1 .57-.034c1.37 0 2.73.525 3.769 1.564l.212.211a2 2 0 0 0 2.818 0l.212-.21a5.313 5.313 0 0 1 7.536 0z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "M26.514 27.499 24 30.013l-2.514-2.514a1.463 1.463 0 1 1 2.07-2.07l.444.443.444-.444a1.463 1.463 0 1 1 2.07 2.071z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        d: "m31.79 13.41-.08.06a12.152 12.152 0 0 1-15.42 0l-.08-.06 1.42-1.42c1.79 1.44 4.05 2.24 6.37 2.24 2.32 0 4.58-.8 6.37-2.24l1.42 1.42z",
      })
    );
  },
  ll = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24Zm38 12a3 3 0 0 0 3-3 2.992 2.992 0 0 0-2-2.815v-9.7a6.5 6.5 0 0 0 4-6A6.254 6.254 0 0 0 42 11a7.113 7.113 0 0 1-5 2H18a3.992 3.992 0 0 0-1 7.858V30H2.334L5 36h33Z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M41 14.485c0-.127 0-.252-.013-.374A9.358 9.358 0 0 1 37 15H18a2 2 0 0 0 0 4l18.5-.015a4.505 4.505 0 0 0 4.5-4.5Z",
      }),
      a("path", {
        d: "M19 30h3v-9h-3v9Zm15-9.013V30h3v-9.041c-.166.013-.331.026-.5.026l-2.5.002ZM24 30h3v-9.007h-3V30Zm5 0h3v-9.012h-3V30Z",
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M42 11a6.254 6.254 0 0 1 1 3.485 6.5 6.5 0 0 1-4 5.999v9.7A2.993 2.993 0 0 1 38 36H5l-2.666-6H17v-9.142A3.992 3.992 0 0 1 18 13h19a7.113 7.113 0 0 0 5-2Zm-24 4a2 2 0 0 0 0 4l18.5-.015a4.505 4.505 0 0 0 4.487-4.874 9.36 9.36 0 0 1-3.987.89H18Zm1 15v-9h3v9h-3Zm5-9v9h3v-9h-3Zm5 9v-9.009h3v9.01h-3Zm5 0h3v-9.04l-.003.001c-.165.013-.329.026-.497.026H34V30Z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M42 11a7.113 7.113 0 0 1-5 2H18a4 4 0 0 0 0 8l18.5-.015a6.5 6.5 0 0 0 6.5-6.5A6.254 6.254 0 0 0 42 11Z",
      }),
      a("path", {
        className: "at-0 ttc-3",
        fill: "transparent",
        d: "M38 30H2.334L5 36h33a3 3 0 0 0 0-6Z",
      })
    );
  },
  tl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm40 5v4h2V23a3 3 0 0 0-3-3H20a4 4 0 0 0-4-4h-6v-4H8v21h2v-4h30z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M39 20H20a4 4 0 0 0-4-4h-6v-4H8v21h2v-4h30v4h2V23a3 3 0 0 0-3-3zm-23-2a2.002 2.002 0 0 1 2 2h-8v-2h6zm-6 9h5.872l2.975-5H10v5z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M39 20H10v-8H8v21h2v-4h30v4h2V23a3 3 0 0 0-3-3z",
      }),
      a("path", {
        className: "at-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        d: "M10 27h5.872l2.975-5H10v5z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M10 16h6a4 4 0 0 1 4 4H10v-4z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M16 18h-6v2h8a2.002 2.002 0 0 0-2-2z",
      })
    );
  },
  cl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm12 28.816V34.5a8.5 8.5 0 0 1-17 0v-8.559A9 9 0 0 1 11 17V9a2 2 0 0 1 2-2h2a1 1 0 1 1 0 2h-2v8a7 7 0 1 0 14 0V9h-2a1 1 0 1 1 0-2h2a2 2 0 0 1 2 2v8a9 9 0 0 1-8 8.941V34.5a6.5 6.5 0 1 0 13 0v-5.684a3 3 0 1 1 2 0zM36 26a1 1 0 1 1-2 0 1 1 0 0 1 2 0z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M32.045 25.486A2.993 2.993 0 0 1 35 23a2.993 2.993 0 0 1 1 5.816V34.5a8.5 8.5 0 0 1-17 0v-8.559A9 9 0 0 1 11 17V9a2 2 0 0 1 2-2h2a1 1 0 1 1 0 2h-2v8a7 7 0 1 0 14 0V9h-2a1 1 0 1 1 0-2h2a2 2 0 0 1 2 2v8a9 9 0 0 1-8 8.941V34.5a6.5 6.5 0 1 0 13 0v-5.684a2.993 2.993 0 0 1-1.955-3.33zM34 26a1 1 0 1 0 2 0 1 1 0 0 0-2 0z",
      }),
      a("path", {
        d: "M34 34.5a6.5 6.5 0 1 1-13 0v-8.559A9 9 0 0 0 29 17h-2a7 7 0 1 1-14 0h-2a9 9 0 0 0 8 8.941V34.5a8.5 8.5 0 0 0 17 0V31h-2v3.5zM25 9h1V7h-1a1 1 0 1 0 0 2zm-9-1a1 1 0 0 0-1-1h-1v2h1a1 1 0 0 0 1-1z",
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
      }),
      a("path", {
        d: "M11 9v8h2V9h1V7h-1a2 2 0 0 0-2 2zm16-2h-1v2h1v8h2V9a2 2 0 0 0-2-2zm8 16a2.993 2.993 0 0 0-1 5.816V31h2v-2.184A2.993 2.993 0 0 0 35 23z",
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
      }),
      a("path", {
        className: "at-2 ot-0 ttc-3",
        fill: "#002677",
        d: "M35 27a1 1 0 1 1 0-2 1 1 0 0 1 0 2z",
      })
    );
  },
  hl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm7 36.423V37.5a4.5 4.5 0 1 1-9 0v-5.051A4.49 4.49 0 0 1 18 28v-5a1 1 0 0 1 1-1h1v1h-1v5a3.5 3.5 0 1 0 7 0v-5h-1v-1h1a1 1 0 0 1 1 1v5a4.49 4.49 0 0 1-4 4.449V37.5a3.5 3.5 0 1 0 7 0v-1.065a2.008 2.008 0 1 1 1-.012zM35 20h1v-7.058A1.941 1.941 0 0 0 34.058 11H20a2 2 0 0 0-2-2h-5.993V7H11v12.945h1.007V17H35v3z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M18 10.015h-5.978v.97h6.963a.986.986 0 0 0-.985-.97z",
      }),
      a("path", {
        d: "M34.058 11H20a2 2 0 0 0-2-2h-5.993V7H11v12.945h1.007V17H35v3h1v-7.058A1.941 1.941 0 0 0 34.058 11zm-22.035-.985H18c.538 0 .977.432.985.97h-6.962v-.97zm-.008 5.97h5.256l2.174-3.97h-7.43v3.97zM28.493 34.25A2 2 0 1 1 31 36.424V37.5a4.5 4.5 0 1 1-9 0v-5.051A4.49 4.49 0 0 1 18 28v-5a1 1 0 0 1 1-1h1v1h-1v5a3.5 3.5 0 1 0 7 0v-5h-1v-1h1a1 1 0 0 1 1 1v5a4.49 4.49 0 0 1-4 4.449V37.5a3.5 3.5 0 1 0 7 0v-1.065a2 2 0 0 1-1.507-2.184zm1.992 1.25h.015a1.003 1.003 0 1 0 0-2.007h-.015a1.004 1.004 0 0 0 0 2.007z",
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M34.058 11H12.007V7H11v12.945h1.007V17H35v3h1v-7.058A1.941 1.941 0 0 0 34.058 11zM30 37.5a3.5 3.5 0 1 1-7 0v-5.051A4.49 4.49 0 0 0 27 28v-5a1 1 0 0 0-1-1h-1v1h1v5a3.5 3.5 0 1 1-7 0v-5h1v-1h-1a1 1 0 0 0-1 1v5a4.49 4.49 0 0 0 4 4.449V37.5a4.5 4.5 0 1 0 9 0V36h-1v1.5z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M17.985 9 12 9.015V11h7.985a2 2 0 0 0-2-2zm12.496 23.493a2 2 0 1 0 2 2 2.007 2.007 0 0 0-2-2z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M12.015 15.985h5.256l2.174-3.97h-7.43v3.97z",
      }),
      a("path", {
        className: "at-2 ot-0",
        fill: "#002677",
        d: "M30.5 33.493h-.015a1.004 1.004 0 0 0 0 2.007h.015a1.004 1.004 0 0 0 0-2.007z",
      })
    );
  },
  sl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm32-12h1V6a1 1 0 0 0-1-1H16a1 1 0 0 0-1 1v6h1v28a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V12z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M30 34H18V18h12v16zm-7.054-12.483h-2.93l.004 6.067h1.32V25.2h1.36l1.856 2.634-1.829 2.65h1.56l1.05-1.526 1.057 1.525h1.59l-1.857-2.676 1.65-2.34h-1.538l-.833 1.325-1.362-1.917a1.423 1.423 0 0 0 .134-.07c.475-.263.8-.733.876-1.27.021-.16.023-.322.006-.483a1.656 1.656 0 0 0-.643-1.173 1.433 1.433 0 0 0-.133-.089 2.412 2.412 0 0 0-1.338-.273z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M23.456 24.056a.763.763 0 0 0 .318-.664c0-.573-.346-.828-1.12-.828h-1.319v1.665H22.6c.296.034.596-.026.856-.173z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-3 ttcw-2",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M16 5h16a1 1 0 0 1 1 1v6h-1v28a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2V12h-1V6a1 1 0 0 1 1-1zm2 29h12V18H18v16z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-1",
        fill: "#fff",
        d: "M30 34H18V18h12v16z",
      }),
      a("path", {
        className: "at-2 otc-0",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M22.7 25.2h-1.365v2.384h-1.32v-6.07h2.931a2.41 2.41 0 0 1 1.338.273 1.657 1.657 0 0 1 .776 1.262c.017.16.015.323-.006.483a1.728 1.728 0 0 1-.876 1.27 1.395 1.395 0 0 1-.134.071l1.362 1.916.833-1.326h1.542l-1.649 2.341 1.857 2.676H26.4l-1.058-1.525-1.05 1.525h-1.559l1.83-2.649-1.862-2.63zm-.046-2.639h-1.319v1.665H22.6c.296.034.596-.026.856-.173a.763.763 0 0 0 .318-.664c0-.573-.346-.828-1.12-.828z",
      }),
      a("path", {
        fill: "transparent",
        d: "M16 12v28a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V12H16z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M16 5h16a1 1 0 0 1 1 1v6H15V6a1 1 0 0 1 1-1z",
      })
    );
  },
  el = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm30.024.763a7.188 7.188 0 0 1 5.998-3.223 7.19 7.19 0 0 1 5.964 3.168 8.72 8.72 0 0 1 .016-.272c.009-.136.018-.272.018-.41-.007-9.933-8.062-17.982-17.994-17.982-9.933 0-17.987 8.049-17.995 17.981 0 .139.01.275.019.41.006.091.012.181.016.273a7.196 7.196 0 0 1 11.962.055A7.195 7.195 0 0 1 23 21.619V39a1 1 0 1 1-2 0v-2l-2 .89V39a3 3 0 0 0 6 0V21.609a7.2 7.2 0 0 1 5.024 3.154z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M11.301 11.301A17.994 17.994 0 0 1 42.02 24.025c0 .139-.01.274-.019.41-.006.09-.012.181-.016.272a7.196 7.196 0 0 0-11.962.055A7.198 7.198 0 0 0 25 21.61V39a3 3 0 0 1-6 0v-1.11l2-.89v2a1 1 0 0 0 2 0V21.618a7.195 7.195 0 0 0-4.973 3.145 7.196 7.196 0 0 0-11.962-.056 8.94 8.94 0 0 0-.016-.271 6 6 0 0 1-.018-.41c0-4.773 1.896-9.35 5.27-12.725zM10.848 18a14.513 14.513 0 0 1 12.375-8.438L24 8.032A16.011 16.011 0 0 0 9.22 18h1.628z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M24.025 21.54a7.184 7.184 0 0 0-1.025.079V39a1 1 0 1 1-2 0v-2l-2 .89V39a3 3 0 1 0 6 0V21.609a7.222 7.222 0 0 0-.975-.069z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M24.025 6.031A17.994 17.994 0 0 0 6.031 24.025c0 .23.026.454.034.682a7.196 7.196 0 0 1 11.962.055 7.194 7.194 0 0 1 11.997 0 7.196 7.196 0 0 1 11.962-.055c.008-.228.034-.451.034-.681A17.995 17.995 0 0 0 24.025 6.03z",
      }),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        d: "M24 8.032A16.011 16.011 0 0 0 9.22 18h1.628a14.514 14.514 0 0 1 12.374-8.438L24 8.032z",
      })
    );
  },
  vl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.74 10.74 0 24 0s24 10.74 24 24-10.74 24-24 24S0 37.26 0 24zm27.78 7.02L38 41.24v-8.48l-5.98-5.98a12.91 12.91 0 0 0 1.94-6.8C33.96 12.81 28.15 7 20.98 7 13.81 7 8 12.81 8 19.98c0 7.17 5.81 12.98 12.98 12.98 2.5 0 4.82-.72 6.8-1.94z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M10 19.98C10 13.93 14.93 9 20.98 9c6.06 0 10.98 4.93 10.98 10.98 0 6.05-4.93 10.98-10.98 10.98-6.05 0-10.98-4.93-10.98-10.98zm12.98 2h3.95l1.53-4h-5.48v-5h-4v5h-5v4h5v5h4v-5z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M27.78 31.02 38 41.24v-8.48l-5.98-5.98a12.91 12.91 0 0 0 1.94-6.8C33.96 12.81 28.15 7 20.98 7 13.81 7 8 12.81 8 19.98c0 7.17 5.81 12.98 12.98 12.98 2.5 0 4.82-.72 6.8-1.94zM10 19.98C10 13.93 14.93 9 20.98 9c6.06 0 10.98 4.93 10.98 10.98 0 6.05-4.93 10.98-10.98 10.98-6.05 0-10.98-4.93-10.98-10.98z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        d: "M38 41.24 27.78 31.02a12.91 12.91 0 0 1-6.8 1.94C13.81 32.96 8 27.15 8 19.98 8 12.81 13.81 7 20.98 7c7.17 0 12.98 5.81 12.98 12.98 0 2.5-.72 4.82-1.94 6.8L38 32.76v8.48z",
      }),
      a("path", {
        className: "at-0 ttc-2 ttcw-3",
        fill: "#00BED5",
        d: "M20.98 9C14.93 9 10 13.93 10 19.98c0 6.05 4.93 10.98 10.98 10.98 6.05 0 10.98-4.93 10.98-10.98C31.96 13.93 27.04 9 20.98 9z",
      }),
      a("path", {
        className: "at-1 ot-2 otc-0",
        fill: "#fff",
        d: "M26.93 21.98h-3.95v5h-4v-5h-5v-4h5v-5h4v5h5.48l-1.53 4z",
      })
    );
  },
  ol = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24zm-19.56-9.86-3.76-3.75h12.99v12.99l-3.75-3.75-17.99 17.98h-5.6v-5.36l18.11-18.11zm-12.95-3.75 1.67 1.67-6.83 6.83v4.88l9.27-9.27 1.67 1.67v-5.78h-5.78zm18.07 18.13-1.67-1.67h5.78v5.78L36 30.96l-6.65 6.65h-4.88l9.09-9.09z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        d: "m24.68 10.39 3.76 3.75-18.11 18.11v5.36h5.6l17.99-17.98 3.75 3.75V10.39H24.68z",
      }),
      a("path", {
        d: "m15.49 10.39 1.67 1.67-6.83 6.83v4.88l9.27-9.27 1.67 1.67v-5.78h-5.78zm16.4 16.46 1.67 1.67-9.09 9.09h4.88L36 30.96l1.67 1.67v-5.78h-5.78z",
        className: "at-3 ot-2 otc-0",
        fill: "#002677",
      })
    );
  },
  fl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a(
        "g",
        { className: "at-2 ot-0 ttcw-1", fill: "#fff" },
        a("path", {
          d: "M24 13.248 29.592.662a23.96 23.96 0 0 0-11.184 0L24 13.248z",
        }),
        a("path", {
          d: "m34.758 2.547-6.025 13.554A2.998 2.998 0 0 1 31 19v1.143a12.5 12.5 0 0 1-8.446 22.775 12.464 12.464 0 0 1-10.885-10.335A12.592 12.592 0 0 1 17 20.143V19a2.998 2.998 0 0 1 2.268-2.899L13.242 2.547a24 24 0 1 0 21.516 0z",
        })
      ),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M26.111 18H28a1 1 0 0 1 1 1v2.265a10.501 10.501 0 0 1-6.222 19.666A10.5 10.5 0 0 1 19 21.265V19a1 1 0 0 1 1-1h.111L21 20h6l-.889-2zm.289 13.453 3.6-2.87-4.517-.096L24 24l-1.483 4.487-4.517.097 3.6 2.87L20.292 36 24 33.287 27.708 36 26.4 31.453z",
      }),
      a("path", {
        className: "at-2 otc-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M31 19v1.143a12.5 12.5 0 0 1-8.446 22.775A12.464 12.464 0 0 1 11.67 32.583 12.592 12.592 0 0 1 17 20.143V19a2.998 2.998 0 0 1 2.267-2.899L13.242 2.547A23.83 23.83 0 0 1 18.408.662L24 13.248 29.592.662a23.857 23.857 0 0 1 5.166 1.885l-6.025 13.554A2.998 2.998 0 0 1 31 19zm-8.222 21.93A10.501 10.501 0 0 0 29 21.265v-2.264a1 1 0 0 0-1-1h-1.889L27 20h-6l-.889-2H20a1 1 0 0 0-1 1v2.265a10.5 10.5 0 0 0 3.778 19.666z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M29 21.25v-2.265a1 1 0 0 0-1-1h-1.889l.889 2h-6l-.889-2H20a1 1 0 0 0-1 1v2.264a10.5 10.5 0 1 0 10 0z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        d: "m27 19.985-.889-2h1.778l6.863-15.44A23.79 23.79 0 0 0 29.586.66L24 13.232 18.414.66a23.794 23.794 0 0 0-5.166 1.885L21 19.985h6z",
      }),
      a("path", {
        className: "at-2 otc-0 ttcw-1",
        fill: "#fff",
        d: "M25.483 28.487 24 24l-1.483 4.487-4.517.096 3.6 2.87L20.292 36 24 33.287 27.708 36 26.4 31.453l3.6-2.87-4.517-.096z",
      })
    );
  },
  nl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00bed5",
        cx: 24,
        cy: 24,
        r: 23,
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24 0C10.7 0 0 10.7 0 24s10.7 24 24 24 24-10.7 24-24S37.3 0 24 0zm-1.4 36.7C21 38.3 19 39 16.9 39s-4.1-.8-5.7-2.3c-3.1-3.1-3.1-8.2 0-11.3 1.6-1.6 3.6-2.3 5.7-2.3.7 0 1.4.1 2.1.3l5.7 5.7c.7 2.6 0 5.5-2.1 7.6zm4.9-10.6 6.4-2.3c5.3-1.9 6.8-8.6 2.8-12.5-3.9-4-10.6-2.5-12.5 2.8l-2.3 6.4-4.6-4.6c-.6-.6-1.5-.6-2.1 0-.6.6-.6 1.5 0 2.1L30 32.8c.6.6 1.5.6 2.1 0 .6-.6.6-1.5 0-2.1l-4.6-4.6z",
      }),
      a("path", {
        className: "ot-0 otc-2 ttc-3",
        fill: "#fff",
        d: "m27 12.8 1.1 1.1c.6-.6 1.4-1.1 2.2-1.3.9-.2 1.8-.1 2.6.2.2.1.5.2.7.4l1.8-.5-.1-.1c-2.5-2.3-6.2-2.1-8.3.2z",
      }),
      a("path", {
        className: "ot-0 otc-2 ttc-2 ttcw-1",
        fill: "#fff",
        d: "m21.2 29.7-2.8-2.8c-.5-.5-.6-1.1-.6-1.7-.3 0-.6-.1-.9-.1-1.6 0-3.1.6-4.2 1.8-1.1 1.1-1.8 2.6-1.8 4.2s.6 3.1 1.8 4.2c1.1 1.1 2.6 1.8 4.2 1.8s3.1-.6 4.2-1.8c1.4-1.4 1.9-3.3 1.7-5.1-.5.1-1.2-.1-1.6-.5z",
      }),
      a("path", {
        className: "ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.2 14.1c1.8-5.2 8.6-6.7 12.5-2.8 4 3.9 2.5 10.6-2.8 12.5l-6.4 2.3 4.6 4.6c.6.6.6 1.5 0 2.1-.6.6-1.5.6-2.1 0L15.2 18c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l4.6 4.6 2.3-6.4zm8.756-1.228c.18.08.391.175.544.328l1.9-.5-.1-.1c-2.4-2.3-6.2-2.1-8.3.2l1 1.1c.6-.7 1.3-1.1 2.2-1.3.9-.2 1.8-.1 2.6.2.047.023.1.047.156.072zM16.9 23c.7 0 1.4.1 2.1.3l5.7 5.6c.7 2.6 0 5.6-2.1 7.7-1.6 1.5-3.6 2.3-5.7 2.3s-4.1-.7-5.7-2.3c-3.1-3.1-3.1-8.2 0-11.3 1.6-1.5 3.7-2.3 5.7-2.3zm.1 14.1c1.6 0 3.1-.7 4.2-1.8 1.4-1.4 1.9-3.3 1.8-5-.6 0-1.2-.1-1.7-.6l-2.8-2.8c-.5-.5-.7-1.1-.6-1.7-.3-.1-.6-.1-.9-.1-1.6 0-3.1.7-4.2 1.8-1.2 1.1-1.8 2.6-1.8 4.2s.7 3.1 1.8 4.2c1.1 1.2 2.6 1.8 4.2 1.8z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-2",
        fill: "#002677",
        d: "M30 32.8 15.2 18c-.6-.6-.6-1.5 0-2.1.6-.6 1.5-.6 2.1 0l14.8 14.8c.6.6.6 1.5 0 2.1-.6.6-1.5.6-2.1 0zm-8.8-3.1-2.8-2.8c-.8-.8-.8-2 0-2.8l.7-.7 5.7 5.7-.8.6c-.8.7-2 .7-2.8 0z",
      })
    );
  },
  il = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        cx: 24,
        cy: 24,
        r: 23,
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm34.94-10.19 1.38-3.89a.7.7 0 0 0-.43-.92L32 7.67l.58-1.62a2.06 2.06 0 0 0-1-2.7 2.06 2.06 0 0 0-2.5 1.44l-.57 1.63-3.86-1.37a.69.69 0 0 0-.88.42l-1.38 3.89a.69.69 0 0 0 .06.58 7.55 7.55 0 0 0-3.12 3.88l-3.21 9.06 7.51 2.66-1.36 1.1-6.65-2.34-1.12 3.14L21.56 30l-1.36 1.1-6.2-2.24-1.16 3.26 7 2.49-1.36 1.1-6.15-2.18-.26.75a7.6 7.6 0 0 0 4.62 9.68l1 .35a7.6 7.6 0 0 0 9.68-4.61l7.24-20.46a7.45 7.45 0 0 0 0-5.06.67.67 0 0 0 .33-.37z",
      }),
      a("path", {
        className: "ot-0 otc-2 ttc-3",
        fill: "#fff",
        d: "M23.45 10.48a6.37 6.37 0 0 0-2.86 3.41l-2.07 5.85L33.88 16a6.33 6.33 0 0 0-.44-2l-9.99-3.52z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "m28.79 6.71.66-1.84A2.06 2.06 0 0 1 32 3.42a2.06 2.06 0 0 1 1 2.7L32.33 8a2.05 2.05 0 0 1-2.5 1.45 2.06 2.06 0 0 1-1.04-2.74z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m29.37 9.28 1 .35A7.62 7.62 0 0 1 35 19.32l-7.25 20.41a7.61 7.61 0 0 1-9.69 4.62l-1-.35a7.62 7.62 0 0 1-4.61-9.65l.27-.74 6.14 2.18 1.37-1.11-7-2.49 1.15-3.26 6.2 2.25 1.36-1.11-7.05-2.55L16 24.37l6.64 2.35 1.36-1.1L16.48 23l3.2-9.1a7.62 7.62 0 0 1 9.69-4.62zM21 14l-2.12 5.81 15.4-3.69a6.43 6.43 0 0 0-4.25-5.72l-.84-.3A6.43 6.43 0 0 0 21 14z",
      }),
      a("path", {
        className: "otc-0 ttc-1",
        fill: "#002677",
        d: "M36.261 9.118 25.017 5.132a.69.69 0 0 0-.881.42l-1.38 3.892a.69.69 0 0 0 .42.881l11.244 3.986a.69.69 0 0 0 .881-.42L36.681 10a.69.69 0 0 0-.42-.881z",
      }),
      a("path", {
        className: "at-0 ttcw-3",
        fill: "#00BED5",
        d: "m23.64 25.5-7.34-2.59-.49 1.38 6.5 2.29 1.33-1.08zm-2.02 4.36-6.9-2.5-.49 1.38 6.06 2.2 1.33-1.08zm-1.67 4.51-6.85-2.43-.49 1.37 6 2.14 1.34-1.08z",
      })
    );
  },
  ml = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        d: "M48 24a24 24 0 1 1-8.14-18 21.21 21.21 0 0 1 2 2A23.89 23.89 0 0 1 48 24Z",
      }),
      a("path", {
        className: "at-0 otc-2",
        d: "M41.88 8a21.176 21.176 0 0 0-2-2 24 24 0 1 0 2 2Zm-.52 19-.91-2H24.89L24 23h3.86a4 4 0 1 0-.76 3.5h4.49a8 8 0 1 1 .34-3.5h4a12 12 0 1 0-.22 3.5h4.05A16 16 0 1 1 40 23h.5l.91-2H46l-1.36 3L46 27h-4.64Z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        d: "M39.78 26.5A16 16 0 1 1 40 23h-4a12 12 0 1 0-.22 3.5h4ZM24 16a8 8 0 1 0 7.59 10.5H27.1a4 4 0 1 1 .76-3.5h4.07A8 8 0 0 0 24 16Z",
      }),
      a("path", {
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
        d: "M46 21h-4.64l-.91 2H24l.89 2h15.56l.91 2H46l-1.36-3L46 21Z",
      })
    );
  },
  zl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm8.808 1.229L19.579 36l21.543-21.543h-8.976L19.58 27.024l-6.284-6.283-4.487 4.488z",
      }),
      a("path", {
        className: "ot-2 otc-0",
        fill: "#00BED5",
        d: "m19.579 27.024-6.284-6.283-4.488 4.488 6.284 6.283 4.488-4.488z",
      }),
      a("path", {
        className: "ot-2 otc-0 ttc-1",
        fill: "#002677",
        d: "M32.146 14.457 15.09 31.512 19.579 36l21.543-21.543h-8.976z",
      })
    );
  },
  dl = function (l) {
    return a(
      "svg",
      Object.assign(
        { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" },
        l
      ),
      a("circle", {
        className: "at-0 otc-2 ttc-2 ttcw-1",
        fill: "#FFF",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "at-3 otc-1 ot-2",
        fill: "#00BED5",
        d: "M19.145 7.056v11.456a4.444 4.444 0 0 1-4.428 4.444l-.061-.006a4.443 4.443 0 0 1-4.401-4.438v-7.498l8.89-3.958z",
      }),
      a("path", {
        className: "at-2 otc-1 ttc-1",
        fill: "#002677",
        d: "M20.165 6.961v11.551a5.465 5.465 0 0 1-5.465 5.465c-.024 0-.065-.005-.091-.008a5.462 5.462 0 0 1-1.404-.206c.022.114.044.224.062.308.639 2.955 3.382 4.981 6.405 4.981h.013a8.633 8.633 0 0 1 1.547-1.568l7.778-7.777v6.068a9.286 9.286 0 0 1 4.378 1.688c2.948-1.847 3.809-5.12 3.794-8.858-.004-.803-.675-1.443-1.477-1.443h-1.81c-1.784 0-2.298-1.257-2.53-2.82-.792-5.311-7.342-6.904-11.2-7.381z",
      }),
      a("path", {
        className: "at-3 otc-1 ot-2",
        fill: "#00BED5",
        d: "M36.092 33.533c-.271-2.348-1.883-4.274-3.81-5.468a8.14 8.14 0 0 0-3.392-1.196l-.98-.108v-4.396l-5.898 5.898-.05.049-.055.043a7.55 7.55 0 0 0-.772.698 7.402 7.402 0 0 0-2.131 5.205c0 4.12 3.352 7.471 7.472 7.471h5.194c3.362 0 6.149-2.51 6.585-5.755-1.01-1.139-2.089-1.795-2.163-2.441",
      })
    );
  },
  pl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm-5.76 37H9.76a1.749 1.749 0 0 1-1.735-1.583L6 15h16l-2.025 20.417A1.749 1.749 0 0 1 18.24 37zM22 26c0 6.075 4.925 11 11 11s11-4.925 11-11h-5.491l5.052-4.42a1.5 1.5 0 1 0-2.122-2.122L35.729 26H22z",
      }),
      a(
        "g",
        { className: "at-0 ot-2", fill: "#002677" },
        a("path", {
          fillRule: "evenodd",
          d: "M8.025 35.417 6 15h16l-2.025 20.417A1.749 1.749 0 0 1 18.24 37H9.76a1.749 1.749 0 0 1-1.735-1.583zM8.506 20h10.988l.298-3H8.206l.3 3z",
        }),
        a("path", {
          d: "m38.509 26 5.052-4.42a1.5 1.5 0 1 0-2.122-2.122L35.729 26H22c0 6.075 4.925 11 11 11s11-4.925 11-11h-5.491z",
        })
      ),
      a("path", {
        className: "at-0 ttc-1 ttcw-3",
        fill: "#00BED5",
        d: "M8.025 35.417A1.75 1.75 0 0 0 9.76 37h8.48c.9-.003 1.65-.688 1.735-1.583L22 15H6l2.025 20.417z",
      }),
      a("path", {
        className: "at-2 ot-0 ttc-3",
        fill: "#002677",
        d: "M18.483 35.269a.25.25 0 0 1-.243.231H9.76a.25.25 0 0 1-.243-.231L8 20h12l-1.517 15.269z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M22 26c0 6.075 4.925 11 11 11s11-4.925 11-11H22z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M43.561 19.458a1.5 1.5 0 0 0-2.122 0L35.729 26h2.78l5.052-4.42a1.5 1.5 0 0 0 0-2.122z",
      })
    );
  },
  wl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        cx: 24,
        cy: 24,
        r: 24,
      }),
      a("path", {
        className: "ot-2",
        fill: "transparent",
        d: "M37 11H11a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2V13a2 2 0 0 0-2-2zM19 34h-8v-2h8v2zm17.11 0H21v-2h16l-.89 2zm.89-5H11V13h26v16zm-7.5-8L20 26.62V15.38L29.5 21z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M11 29h26V13H11v16zm9-13.62L29.5 21 20 26.62V15.38zM21 32h16l-.89 2H21v-2zM41.88 8a21.176 21.176 0 0 0-2-2 24 24 0 1 0 2 2zM39 35a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V13a2 2 0 0 1 2-2h26a2 2 0 0 1 2 2v22zm-28-3h8v2h-8v-2z",
      }),
      a("path", {
        className: "ot-0 otc-0 ttc-1",
        fill: "#002677",
        d: "M37 13v16H11V13h26zm0-2H11a2 2 0 0 0-2 2v22a2 2 0 0 0 2 2h26a2 2 0 0 0 2-2V13a2 2 0 0 0-2-2z",
      }),
      a("path", {
        className: "ot-0 otc-0 ttc-2",
        fill: "#fff",
        d: "M37 32H20v2h16.11l.89-2z",
      }),
      a("path", {
        className: "ot-0 otc-0",
        fill: "#00BED5",
        d: "M20 32h-9v2h9v-2zm9.5-11L20 26.61V15.38L29.5 21z",
      })
    );
  },
  Ml = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm20.672 11.05L38 17.727a5.502 5.502 0 0 0-7.783-7.779L12.89 27.271 8.9 38.535a.409.409 0 0 0 .1.4.381.381 0 0 0 .223.11c.02.006.042.01.063.012a.41.41 0 0 0 .115-.016l11.272-3.99z",
      }),
      a("path", {
        className: "at-0 otc-2",
        fill: "transparent",
        d: "M34.107 10.337a3.477 3.477 0 0 0-2.475 1.025l-1 1 4.95 4.95 1-1a3.5 3.5 0 0 0-2.475-5.975zM14.016 28.595l-2.281 6.439 1.174 1.174 6.476-2.293.027-.124-5.226-5.227-.17.031z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M38 9.948a5.5 5.5 0 0 0-7.779 0L12.893 27.272 8.9 38.536a.409.409 0 0 0 .1.4.38.38 0 0 0 .223.11.45.45 0 0 0 .063.012.41.41 0 0 0 .115-.016l11.271-3.992L38 17.727a5.5 5.5 0 0 0 0-7.779zM19.385 33.915l-6.476 2.293-1.174-1.174 2.28-6.434.17-.03 5.227 5.226-.027.12zm16.2-16.6 1-1a3.5 3.5 0 0 0-4.95-4.95l-1 1 4.95 4.95z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "m38 17.726-1 1-7.778-7.778.995-1a5.5 5.5 0 0 1 7.78 0A5.5 5.5 0 0 1 38 17.726z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "m37 18.722-7.778-7.778-16.328 16.328L8.9 38.536a.409.409 0 0 0 .1.4.381.381 0 0 0 .223.11c.02.005.042.01.063.012a.41.41 0 0 0 .115-.016l11.271-3.992L37 18.722z",
      }),
      a("path", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#fff",
        d: "m19.385 33.915-6.476 2.293-1.174-1.174 2.28-6.434.17-.031 5.227 5.227-.027.119z",
      })
    );
  },
  rl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24zm-29.75.76c3.14-4.51 8.29-4.51 11.43 0l3.6 5.15c3.15 4.52 1.22 8.21-4.28 8.21H18.94c-5.5 0-7.43-3.69-4.28-8.21l3.59-5.15zM34 26.82a3.23 3.23 0 0 1-1.52-2 3.27 3.27 0 0 1 .33-2.47l.54-.93.54-.94a3.24 3.24 0 0 1 4.44-1.19 3.26 3.26 0 0 1 1.19 4.44l-.52.97-.54.93A3.24 3.24 0 0 1 34 26.82zm-7.87-8.15a3.57 3.57 0 0 0 2.2 1.69 3.63 3.63 0 0 0 2.75-.36 3.67 3.67 0 0 0 1.69-2.21l.45-1.68.44-1.67A3.62 3.62 0 0 0 31.1 10a3.62 3.62 0 0 0-2.75.37 3.67 3.67 0 0 0-1.69 2.2l-.45 1.68-.45 1.67a3.62 3.62 0 0 0 .37 2.75zM14 26.82a3.23 3.23 0 0 0 1.52-2 3.27 3.27 0 0 0-.33-2.47l-.54-.93-.54-.94a3.24 3.24 0 0 0-4.44-1.19 3.26 3.26 0 0 0-1.17 4.47l.5.94.54.93A3.24 3.24 0 0 0 14 26.82zm8.42-11.05a3.76 3.76 0 0 1-2.65 4.59l.01-.01a3.75 3.75 0 0 1-4.6-2.65l-.41-1.55-.42-1.56A3.76 3.76 0 0 1 17 10a3.77 3.77 0 0 1 4.59 2.66l.41 1.56.42 1.55z",
      }),
      a(
        "g",
        { className: "at-2 ttc-1 otc-0", fill: "#002677" },
        a("path", {
          fillRule: "evenodd",
          d: "M18.25 24.76c3.14-4.51 8.29-4.51 11.43 0l3.6 5.15c3.15 4.52 1.22 8.21-4.28 8.21H18.94c-5.5 0-7.43-3.69-4.28-8.21l3.59-5.15zm6.3 2.85a2.64 2.64 0 0 1 3.73 0 2.64 2.64 0 0 1 .04 3.73L24 35.65l-4.31-4.31a2.64 2.64 0 0 1 3.73-3.73l.58.59.55-.59z",
        }),
        a("path", {
          d: "M34 26.82a3.23 3.23 0 0 1-1.52-2 3.27 3.27 0 0 1 .33-2.47l.54-.93.54-.94a3.24 3.24 0 0 1 4.44-1.19 3.26 3.26 0 0 1 1.19 4.44l-.52.97-.54.93A3.24 3.24 0 0 1 34 26.82zm-5.67-6.46a3.57 3.57 0 0 1-2.2-1.69 3.62 3.62 0 0 1-.37-2.75l.45-1.67.45-1.68a3.67 3.67 0 0 1 1.69-2.2A3.62 3.62 0 0 1 31.1 10a3.62 3.62 0 0 1 2.56 4.44l-.44 1.67-.45 1.68A3.67 3.67 0 0 1 31.08 20a3.63 3.63 0 0 1-2.75.36zM14 26.82a3.23 3.23 0 0 0 1.52-2 3.27 3.27 0 0 0-.33-2.47l-.54-.93-.54-.94a3.24 3.24 0 0 0-4.44-1.19 3.26 3.26 0 0 0-1.17 4.47l.5.94.54.93A3.24 3.24 0 0 0 14 26.82zm5.77-6.46a3.76 3.76 0 0 0 2.65-4.59L22 14.22l-.41-1.56A3.77 3.77 0 0 0 17 10a3.76 3.76 0 0 0-2.65 4.59l.42 1.56.41 1.55a3.75 3.75 0 0 0 4.6 2.65l-.01.01z",
        })
      ),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "M28.28 27.61a2.64 2.64 0 0 0-3.73 0l-.55.59-.58-.59a2.64 2.64 0 0 0-3.73 3.73L24 35.65l4.32-4.31a2.64 2.64 0 0 0-.04-3.73z",
      })
    );
  },
  Nl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm26.876 5.268 9.752-11.134a8.45 8.45 0 0 0 5.03-.623l-11.14-11.14a8.438 8.438 0 0 0-.633 4.985l-11.153 9.77a10.675 10.675 0 0 0-6.672.727l6.077 6.072-6.317 6.317a7.78 7.78 0 0 0-1.962 3.9 7.79 7.79 0 0 0 3.895-1.962l6.317-6.317 6.077 6.077a10.682 10.682 0 0 0 .729-6.672z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        d: "M30.519 6.371a8.438 8.438 0 0 0-.634 4.985l-11.153 9.769a10.675 10.675 0 0 0-6.672.728l6.077 6.077-6.317 6.317a7.78 7.78 0 0 0-1.962 3.9 7.79 7.79 0 0 0 3.895-1.962l6.317-6.317 6.077 6.077a10.683 10.683 0 0 0 .729-6.672l9.752-11.134a8.45 8.45 0 0 0 5.03-.623L30.519 6.371z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "m18.858 27.209-7.038 7.038a7.78 7.78 0 0 0-1.962 3.9 7.78 7.78 0 0 0 3.895-1.962l7.038-7.038-1.933-1.938z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M12.06 21.853 26.147 35.94a10.684 10.684 0 0 0 .73-6.672l9.751-11.134a8.443 8.443 0 0 0 5.031-.623L30.52 6.371a8.436 8.436 0 0 0-.634 4.985l-11.153 9.768a10.682 10.682 0 0 0-6.672.729z",
      })
    );
  },
  ul = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0zm6.448 12.04 3.233-4.45 3.014.955-3.82 5.255a1.5 1.5 0 1 1-2.427-1.763v.003zm-12.895 0-3.82-5.259-1.84 2.573 3.233 4.446a1.5 1.5 0 0 0 2.427-1.76zm-5.485 16.88-5.231 1.7-1.878-2.544 6.184-2.01a1.5 1.5 0 0 1 .927 2.854h-.002zM22.5 36.5V43l3-1v-5.5a1.5 1.5 0 0 0-3 0zm1.5-5.3-9.091 4.78 1.734-10.124-7.352-7.169 10.164-1.477L24 8l4.543 9.21 10.164 1.477-7.355 7.169 1.736 10.123L24 31.2zm10.915-3.394a1.5 1.5 0 0 0 1.018 1.114l6.18 2.01-.023-3.163-5.23-1.7a1.5 1.5 0 0 0-1.945 1.739z",
      }),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        d: "M38.709 18.687 28.545 17.21 24 8l-4.546 9.21-10.163 1.477 7.354 7.169-1.736 10.123L24 31.199l9.091 4.78-1.736-10.123 7.354-7.169z",
      }),
      a("path", {
        d: "M24 35a1.5 1.5 0 0 0-1.5 1.5V43l3-1v-5.5A1.5 1.5 0 0 0 24 35zm18.09-7.233-5.231-1.7a1.5 1.5 0 1 0-.927 2.853l6.182 2.009-.024-3.162zM30.779 14.135a1.5 1.5 0 0 0 2.1-.332L36.7 8.545l-3.02-.955-3.233 4.45a1.5 1.5 0 0 0 .332 2.095zm-13.558 0a1.5 1.5 0 0 0 .331-2.1l-3.82-5.259-1.839 2.578 3.232 4.446a1.5 1.5 0 0 0 2.096.335zm-6.08 11.932-6.182 2.009 1.878 2.544 5.231-1.7a1.5 1.5 0 0 0-.927-2.853z",
        className: "at-3 ot-2 otc-0",
        fill: "#00BED5",
      })
    );
  },
  Vl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("circle", {
        className: "at-0 ttc-2 ttcw-1",
        fill: "#FFF",
        cx: 24,
        cy: 24,
        r: 23,
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm29.08 6.52a7.27 7.27 0 0 0 5.28 2.25 7.33 7.33 0 0 0 2.34-14.28c-.182-6.72-5.566-12.136-12.285-12.358-6.718-.223-12.448 4.825-13.075 11.518a6.91 6.91 0 1 0 6.12 12.11 12.662 12.662 0 0 0 4.17 1.57V42a2.37 2.37 0 0 0 4.74 0V31.36a12.541 12.541 0 0 0 2.71-.84z",
      }),
      a("path", {
        className: "ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.097 6.007c6.718.223 12.102 5.639 12.284 12.359v.03a7.33 7.33 0 1 1-7.62 12c-.869.381-1.778.663-2.71.84v10.64a2.37 2.37 0 0 1-4.74 0v-10.67a12.66 12.66 0 0 1-4.17-1.57 6.91 6.91 0 1 1-6.12-12.11c.627-6.694 6.357-11.741 13.076-11.519zm.964 35.868v-17.46l5.21-5.22h-1.77l-3.44 3.44v-6.46l-2.76 1.2v9.2l-3.79-3.79h-1.78l5.57 5.57v13.52a1.38 1.38 0 0 0 2.76 0z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M36.7 18.49c-.182-6.72-5.566-12.136-12.285-12.358-6.718-.223-12.448 4.825-13.075 11.518a6.91 6.91 0 1 0 6.12 12.11 12.68 12.68 0 0 0 11.62.76 7.33 7.33 0 1 0 7.62-12v-.03z",
      }),
      a("path", {
        className: "ot-0 ttc-1",
        fill: "#002677",
        d: "m25.38 24.54 5.21-5.22h-1.77l-3.44 3.44V16.3l-2.76 1.2v9.2l-3.79-3.79h-1.78l5.57 5.57V42a1.38 1.38 0 0 0 2.76 0V24.54z",
      })
    );
  },
  gl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-0 ttc-1 ttcw-1",
        fill: "#fff",
        d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm11 13a2 2 0 0 0-2 2h30a2 2 0 0 0-2-2V10h-6V7H17v3h-6v27z",
      }),
      a("path", {
        className: "at-0 ot-2 otc-2",
        fill: "#002677",
        fillRule: "evenodd",
        d: "M18.5 8.5h11v11h-11v-11zm6.85 6.82h1.77l.88-2.64h-2.65v-2.21h-2.64v2.21H20.5v2.64h2.21v2.21h2.64v-2.21z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M37 37V10h-6v11H17V10h-6v27a2 2 0 0 0-2 2h30a2 2 0 0 0-2-2zm-14 0h-5V27h5v10zm2 0h5V27h-5v10z",
      }),
      a("path", {
        className: "ot-0 otc-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M37 37V10h-6v11H17V10h-6v27a2 2 0 0 0-2 2h30a2 2 0 0 0-2-2z",
      }),
      a("path", {
        d: "M23 27h-5v10h5V27zm7 0h-5v10h5V27z",
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
      }),
      a("path", {
        className: "at-2 ot-0 otc-0",
        fill: "#002677",
        d: "M18.5 8.5v11h11v-11h-11z",
      }),
      a("path", {
        className: "at-1 ot-0 otc-0",
        fill: "#fff",
        d: "M27.12 15.32h-1.77v2.21h-2.64v-2.21H20.5v-2.64h2.21v-2.21h2.64v2.21H28l-.88 2.64z",
      })
    );
  },
  Hl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24zm36.98 15.004a2 2 0 0 0 2-2v-26a2 2 0 0 0-2-2h-26a2 2 0 0 0-2 2v26a2 2 0 0 0 2 2h26z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M38 8H10a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zM22.136 30.992h-10.63V17.008H21.99v2.579h-7.442v2.997h6.42l-1.07 2.412h-5.35v3.418h7.59v2.578zm10.814-1.887c-.012.647.11 1.289.357 1.887h3.186l-.125-.168a3.947 3.947 0 0 1-.42-1.803c-.21-3.229-.65-4.15-2.201-4.633a3.456 3.456 0 0 0 2.222-3.418 3.718 3.718 0 0 0-1.824-3.333 5.551 5.551 0 0 0-3.082-.63h-6.75v13.985h3.04v-5.493h2.746c2.18 0 2.704.67 2.851 3.606z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M38 8H10a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2z",
      }),
      a(
        "g",
        { className: "at-3 ot-0 otc-2", fill: "#00BED5" },
        a("path", {
          d: "M15.02 24.996h5.349l1.072-2.411H15.02v-2.998h7.443v-2.579H11.98v13.984h10.629v-2.579H15.02v-3.417z",
        }),
        a("path", {
          fillRule: "evenodd",
          d: "M34.22 24.388c1.552.482 1.992 1.404 2.202 4.633a3.947 3.947 0 0 0 .42 1.803l.125.168H33.78a4.716 4.716 0 0 1-.356-1.887c-.147-2.935-.671-3.606-2.851-3.606h-2.747v5.493h-3.04V17.008h6.75a5.55 5.55 0 0 1 3.083.629 3.718 3.718 0 0 1 1.824 3.333 3.457 3.457 0 0 1-2.222 3.418zm-3.48-1.132a3.25 3.25 0 0 0 1.97-.399 1.76 1.76 0 0 0 .735-1.53c0-1.32-.797-1.908-2.58-1.908h-3.039v3.837h2.914z",
        })
      ),
      a("path", {
        className: "at-2 ttc-1 otc-0",
        fill: "#002677",
        d: "M30.392 19.419h-3.04v3.837h2.914a3.251 3.251 0 0 0 1.971-.398c.49-.351.768-.929.734-1.53 0-1.322-.796-1.909-2.579-1.909z",
      })
    );
  },
  Al = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zM12 10.625h4v4.125L12 18v-7.375zM11 35a2 2 0 0 0-2 2h30a2 2 0 0 0-2-2V23h3L24 10 8 23h3v12z",
      }),
      a(
        "g",
        { className: "at-0 ot-2", fill: "transparent" },
        a("path", { d: "M16 10.625h-4V18l4-3.25v-4.125z" }),
        a("path", {
          fillRule: "evenodd",
          d: "M40 23h-3v12a2 2 0 0 1 2 2H9a2 2 0 0 1 2-2V23H8l16-13 16 13zm-26 6h4v-4h-4v4zm7 6v-7a3 3 0 1 1 6 0v7h-6zm9-6h4v-4h-4v4z",
        })
      ),
      a("path", {
        d: "M37 35V23h3L24 10 8 23h3v12a2 2 0 0 0-2 2h30a2 2 0 0 0-2-2zM16 10.625h-4V18l4-3.25v-4.125z",
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
      }),
      a("path", {
        d: "M34 25h-4v4h4v-4zm-16 0h-4v4h4v-4zm6 0a3 3 0 0 0-3 3v7h6v-7a3 3 0 0 0-3-3z",
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
      })
    );
  },
  xl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24A24 24 0 0 0 24 0zm4 38H15v-5h-3v5h-2V15l18-8v31zm6 0h5V11H29v27h2v-5h3v5z",
      }),
      a("path", {
        d: "M11 40H9V17l18-8v31H14v-5h-3v5zm14-20H11v2h14v-2zm-14 5h14v2H11v-2zm14 5H11v2h14v-2zm3-17v27h2v-5h3v5h5V13H28zm4 19h-2v-2h2v2zm-2-5h2v-2h-2v2zm2-5h-2v-2h2v2zm2 10h2v-2h-2v2zm2-10h-2v-2h2v2zm-2-5h2v-2h-2v2z",
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
      }),
      a("path", {
        d: "M10 38h18V7l-18 7.997V38zm29-27H29v27h10V11z",
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
      }),
      a("path", {
        d: "M33 23h-2v2h2v-2zm4-10h-2v2h2v-2zM26 28H12v2h14v-2zm0-10H12v2h14v-2zm0 5H12v2h14v-2zm11 5h-2v2h2v-2zm0-10h-2v2h2v-2zm-4 10h-2v2h2v-2zm0-10h-2v2h2v-2zM15 33h-3v5h3v-5zm19 0h-3v5h3v-5z",
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
      })
    );
  },
  Rl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm10 12a2 2 0 0 0-2 2h32a2 2 0 0 0-2-2V9H10v27z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M38 36V9H10v27a2 2 0 0 0-2 2h32a2 2 0 0 0-2-2z",
      }),
      a("path", {
        d: "M36 24h-7v9h7v-9zm-17 0h-7v9h7v-9zm8 0h-6v12h6V24z",
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        d: "M32 12H16a4 4 0 0 0 0 8h16a4 4 0 0 0 0-8z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M38 37V10H10v27a2 2 0 0 0-2 2h32a2 2 0 0 0-2-2zm-19-3h-7v-9h7v9zm2 3h6V25h-6v12zm15-3h-7v-9h7v9zM16 21h16a4 4 0 0 0 0-8H16a4 4 0 0 0 0 8z",
      })
    );
  },
  Ll = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm33.428 1.885-2.356-4.714 7.07-7.07A3 3 0 0 0 33.9 9.856l-7.071 7.072-3.771-1.886a1.333 1.333 0 1 0-1.886-1.886l-.628.63-7.857-3.93-2.121 2.122 10.606 10.606-8.23 10.38-5.205-2.601-1.414 1.414 9.9 9.9 1.414-1.415-2.603-5.204 10.38-8.23 10.607 10.605 2.122-2.12-3.457-6.915.864-.864a1.333 1.333 0 1 0-1.886-1.885l-.236.235z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        d: "M35.227 27.556a1.333 1.333 0 1 0-1.885-1.885l-.236.236-2.357-4.714 7.07-7.072a3 3 0 1 0-4.242-4.242l-7.07 7.071-3.772-1.886a1.333 1.333 0 0 0-1.886-1.886l-.628.63-7.857-3.93L10.243 12l10.606 10.607-8.23 10.38-5.205-2.602L6 31.799l9.9 9.9 1.414-1.415-2.603-5.204 10.38-8.23L35.7 37.455l2.12-2.121-3.456-6.914.864-.865z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M38.142 9.858a3 3 0 0 0-4.242 0L21.172 22.586 10.565 36.02l1.415 1.414 13.435-10.607L38.142 14.1a3 3 0 0 0 0-4.242z",
      }),
      a("path", {
        d: "m34.685 28.4.865-.865a1.333 1.333 0 0 0 0-1.885 1.333 1.333 0 0 0-1.886 0l-.236.236-2.357-4.714-5.656 5.656L36.02 37.435l2.121-2.121-3.457-6.914zM23.058 15.043a1.333 1.333 0 0 0-1.886-1.885l-.629.628-7.856-3.928-2.122 2.121 10.607 10.607 5.657-5.657-3.771-1.886zM7.737 30.364l-1.414 1.414 4.242 4.243 2.376-3.055-5.204-2.602zm4.242 7.071 4.243 4.243 1.414-1.415-2.602-5.204-3.055 2.376z",
        className: "at-3 ot-0 otc-0",
        fill: "#00BED5",
      })
    );
  },
  Bl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm35 11a4 4 0 0 0 4-4h5a2 2 0 0 0-1-1.72v-4.43a3 3 0 0 0-1.7-2.69l-3.19-1.59-3.28-7.38A2 2 0 0 0 33 12H9a2 2 0 0 0-2 2v15.28A2 2 0 0 0 6 31h3a4 4 0 0 0 8 0h14a4 4 0 0 0 4 4z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M43 29.28v-4.43a3 3 0 0 0-1.65-2.68l-3.19-1.59-3.28-7.38a2 2 0 0 0-1.83-1.2H9a2 2 0 0 0-2 2v15.28A2 2 0 0 0 6 31h3a4 4 0 0 0 8 0h14a4 4 0 0 0 8 0h5a2 2 0 0 0-1-1.72z",
      }),
      a("path", {
        className: "at-3 ot-0 otc-2",
        fill: "#00BED5",
        d: "M33.05 14.01H27V20h8.72l-2.67-5.99z",
      }),
      a("path", {
        d: "M35 33a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm-22 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
      }),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M18.65 18.85h1.88l-2.02 2.87L20.79 25h-1.95l-1.3-1.87L16.25 25h-1.91l2.24-3.25-2.28-3.22h-1.69v2.91H11V14h3.61a3 3 0 0 1 1.67.34l.16.11a2 2 0 0 1 .79 1.44 2.13 2.13 0 0 1-1.07 2.15l-.16.09 1.65 2.34 1-1.62zm-4.49-1.52a1.7 1.7 0 0 0 1.05-.21.93.93 0 0 0 .39-.79c0-.69-.42-1-1.37-1h-1.62v2h1.55z",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M43 29.28v-4.43a3 3 0 0 0-1.65-2.68l-3.19-1.59-3.28-7.38a2 2 0 0 0-1.83-1.2H9a2 2 0 0 0-2 2v15.28A2 2 0 0 0 6 31h3a4 4 0 0 0 8 0h14a4 4 0 0 0 8 0h5a2 2 0 0 0-1-1.72zM13 33a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm4.54-9.87 1.3 1.87h1.95l-2.29-3.32 2-2.87h-1.88l-1 1.62-1.66-2.34.16-.09c.57-.32.96-.884 1.06-1.53a2.32 2.32 0 0 0 0-.59 2 2 0 0 0-.79-1.44l-.16-.11a3 3 0 0 0-1.64-.33H11v7.45h1.63v-2.92h1.67l2.28 3.22L14.34 25h1.91l1.29-1.87zM27 20v-6h6l2.67 6H27zm6 11a2 2 0 1 0 4 0 2 2 0 0 0-4 0z",
      }),
      a("path", {
        className: "at-2 otc-0 ttc-1",
        fill: "#002677",
        d: "M14.23 15.29h-1.62v2h1.55a1.7 1.7 0 0 0 1.05-.21.93.93 0 0 0 .39-.81c0-.67-.42-.98-1.37-.98z",
      })
    );
  },
  Cl = function (l) {
    return a(
      "svg",
      Object.assign(
        {
          viewBox: "0 0 48 48",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
        l
      ),
      a("path", {
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
        fillRule: "evenodd",
        d: "M0 24C0 10.745 10.745 0 24 0a24 24 0 0 1 24 24c0 13.255-10.745 24-24 24S0 37.255 0 24zm31.543 13a4.5 4.5 0 0 0 4.45 4A4.5 4.5 0 0 0 37 32.12V23l-2.4-6.011H18V7.983h-7.043a1 1 0 1 0 0 2H16v13.048a9 9 0 1 0 9.057 4.932L35 28v4.116A4.5 4.5 0 0 0 31.543 37z",
      }),
      a("path", {
        className: "at-0 ttc-1 ttcw-2",
        fill: "#002677",
        d: "M37 32.12V23l-2.4-6.011H18V9.983h-2V23.03a9 9 0 1 0 2 0V19h15.4l1.6 4v9.116a4.5 4.5 0 1 0 2 0v.004z",
      }),
      a("path", {
        d: "M35.993 39.197a2.699 2.699 0 1 0 0-5.398 2.699 2.699 0 0 0 0 5.398zM18 25.053v5.2a2 2 0 1 1-2 0v-5.2a7 7 0 1 0 2 0zM35 23h.002l-1.6-4.004H18v4.009l17 .041V23z",
        className: "at-2 ot-0 ttcw-1",
        fill: "#fff",
      }),
      a("path", {
        className: "at-0 ot-2",
        fill: "transparent",
        fillRule: "evenodd",
        d: "M37 23v9.12a4.5 4.5 0 1 1-2 0V28l-9.943-.041A8.994 8.994 0 1 1 16 23.03V9.983h-5.043a1 1 0 1 1 0-2H18v9.006h16.6l2.4 6.01zm-26.928 9.475A7 7 0 0 0 17 38.973a7 7 0 0 0 1-13.92v5.2a2 2 0 1 1-2 0v-5.2a7 7 0 0 0-5.928 7.422zM18 23.005V19h15.4l1.6 4v.046l-17-.041zM33.293 36.5a2.7 2.7 0 1 0 5.4 0 2.7 2.7 0 0 0-5.4 0z",
      }),
      a("path", {
        className: "at-0 ttc-3 ttcw-3",
        fill: "#00BED5",
        d: "M18 7.983h-7.043a1 1 0 1 0 0 2H18v-2zM18 23v.034a9.005 9.005 0 0 1 7.052 4.918H35V23H18z",
      })
    );
  };
export {
  Ma as Icon247,
  M as IconAcupunc,
  M as IconAcupuncture,
  vl as IconAdditionalBenefits,
  Ll as IconAirplane,
  l as IconAlert,
  K as IconAmblnc,
  K as IconAmbulance,
  ol as IconArrows,
  ia as IconAsthma,
  fl as IconAward,
  nl as IconBaby,
  Ga as IconBandage,
  Ha as IconBankCard,
  s as IconBarChart,
  B as IconBeaker,
  Wa as IconBed,
  U as IconBev,
  U as IconBeverage,
  xa as IconBike,
  e as IconBook,
  il as IconBottle,
  r as IconBrain,
  N as IconBraingame,
  ml as IconBullseye,
  X as IconBus,
  m as IconCal,
  m as IconCalendar,
  Ra as IconCare,
  aa as IconChat,
  zl as IconCheckmark,
  D as IconCheckup,
  C as IconChiro,
  C as IconChiropractor,
  ma as IconClean,
  gl as IconClinic,
  I as IconClipboard,
  D as IconClipboardChecked,
  z as IconClock,
  la as IconCollaboration,
  Pa as IconCompass,
  Aa as IconCost,
  x as IconCover,
  c as IconCritIll,
  Ua as IconCrutches,
  G as IconDental,
  Qa as IconDentures,
  ra as IconDesktop,
  t as IconDiabMntr,
  t as IconDiabetesMonitor,
  e as IconDocBook,
  I as IconDocClipbrd,
  f as IconDocFold,
  o as IconDocMult,
  v as IconDocSng,
  v as IconDocument,
  o as IconDocumentMultiple,
  dl as IconDogAndCat,
  b as IconEar,
  La as IconElliptical,
  ta as IconEmail,
  Hl as IconEr,
  A as IconExerHvy,
  H as IconExerLt,
  E as IconEye,
  $a as IconEyeExam,
  Na as IconFax,
  d as IconFitnessTracker,
  d as IconFittrack,
  f as IconFolder,
  O as IconFootCare,
  O as IconFootcare,
  N as IconGame,
  Q as IconGift,
  _a as IconGlasses,
  Za as IconGlobe,
  ca as IconGoDigital,
  $ as IconGogovrn,
  ha as IconHandshake,
  u as IconHappySmile,
  Ba as IconHealth,
  V as IconHealthFood,
  y as IconHealthProd,
  V as IconHealthyFood,
  b as IconHear,
  j as IconHearaid,
  j as IconHearingAid,
  qa as IconHeart,
  c as IconHeartHealth,
  Ja as IconHelix,
  Ca as IconHighFive,
  Al as IconHome,
  Y as IconHosp,
  Y as IconHospital,
  Fa as IconIdCard,
  k as IconImmun,
  Ka as IconInfusion,
  B as IconLabserv1,
  T as IconLabserv2,
  ua as IconLaptop,
  $ as IconLeaf,
  sa as IconLightBulb,
  R as IconLocationPin,
  n as IconLock,
  R as IconLocpin,
  _ as IconMagnify,
  _ as IconMagnifyingGlass,
  ea as IconMail,
  S as IconMammo,
  S as IconMammogram,
  W as IconMapd,
  za as IconMask,
  pl as IconMeal,
  q as IconMedal,
  wl as IconMediaPlay,
  tl as IconMedicareA,
  W as IconMedicareAdvantagePd,
  cl as IconMedicareB,
  hl as IconMedicareC,
  sl as IconMedicareD,
  el as IconMedicareSupplement,
  y as IconMedicineBottle,
  x as IconMedsupp,
  r as IconMenthealth,
  Xa as IconMicroscope,
  p as IconMobile,
  ka as IconMobileClinic,
  Ta as IconMobilePantry,
  p as IconMobilePhone,
  Ia as IconMoon,
  Da as IconMusic,
  wa as IconNetwork,
  h as IconNoSmoking,
  xl as IconOffice,
  Ml as IconPencil,
  rl as IconPetCare,
  va as IconPhone,
  g as IconPhysicalTherapy,
  g as IconPhysther,
  i as IconPieChart,
  i as IconPiechart,
  w as IconPiggyBank,
  Ya as IconPill,
  F as IconPillBot,
  F as IconPillBottle,
  Nl as IconPin,
  u as IconPositiv,
  al as IconPregnancy,
  Z as IconProv,
  oa as IconQuestionMark,
  Q as IconRewards,
  ba as IconRun,
  Bl as IconRxDelivery,
  w as IconSavings,
  P as IconScale,
  n as IconSecur,
  da as IconSixFeetApart,
  ul as IconStar,
  Z as IconStethoscope,
  Ea as IconStopwatch,
  Rl as IconStore,
  J as IconSuitcase,
  Oa as IconSwim,
  k as IconSyringe,
  Va as IconTablet,
  H as IconTennisShoe,
  T as IconTestTube,
  z as IconTime,
  h as IconTobacCess,
  G as IconTooth,
  ll as IconToothbrush,
  X as IconTransport,
  J as IconTravel,
  ja as IconTreadmill,
  Vl as IconTree,
  x as IconUmbrella,
  s as IconUpgrow,
  l as IconUrgent,
  L as IconUsMap,
  L as IconUsmap,
  q as IconVet,
  fa as IconVideoChat,
  na as IconVirtualCare,
  E as IconVision,
  pa as IconWashHands,
  P as IconWeight,
  A as IconWeights,
  Sa as IconWellness,
  Cl as IconWheelchair,
  ya as IconWhistle,
  ga as Icon_$0,
};
//# sourceMappingURL=uhc-brand-icons.modern.js.map
